var _style, _defs, _defs2, _rect, _path, _path2, _defs3, _g, _defs4, _path3, _defs5, _g2, _defs6, _path4, _defs7, _g3, _defs8, _path5, _rect2, _rect3, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFlagMx = function SvgFlagMx(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#2E6A4A;}\n\t.st4{fill:#BC1F34;}\n\t.st5{clip-path:url(#SVGID_6_);}\n\t.st6{fill:#9A9B5E;}\n\t.st7{fill:#E0911E;}\n\t.st8{fill:#686124;}\n\t.st9{fill:#B9B992;}\n\t.st10{fill:#1A1E27;}\n\t.st11{fill:#EFB82E;}\n\t.st12{fill:#826924;}\n\t.st13{fill:#945B22;}\n\t.st14{fill:#6D5923;}\n\t.st15{fill:#F7BB31;}\n\t.st16{fill:#5B4A1E;}\n\t.st17{fill:#363517;}\n\t.st18{fill:#947627;}\n\t.st19{fill:#8C8D53;}\n\t.st20{fill:#626527;}\n\t.st21{fill:#2A583A;}\n\t.st22{fill:#A90C28;}\n\t.st23{fill:#4CB4D0;}\n\t.st24{fill:#1E6194;}\n\t.st25{fill:#E99442;}\n\t.st26{fill:#73221E;}\n\t.st27{fill:#1D1B1C;}\n\t.st28{fill:#82AEAD;}\n\t.st29{fill:#21453F;}\n\t.st30{fill:#317175;}\n\t.st31{clip-path:url(#SVGID_8_);}\n\t.st32{fill:url(#Trazado_5118_1_);}\n\t.st33{clip-path:url(#SVGID_10_);}\n\t.st34{fill:#D3395F;}\n\t.st35{clip-path:url(#SVGID_12_);}\n\t.st36{fill:url(#Trazado_5535_1_);}\n\t.st37{clip-path:url(#SVGID_14_);}\n\t.st38{fill:#C80030;}\n\t.st39{fill:#F6DA04;}\n\t.st40{fill:#72361D;}\n\t.st41{fill:#905823;}\n\t.st42{fill:#3A2116;}\n\t.st43{fill:#BD8F54;}\n\t.st44{fill:#70351E;}\n\t.st45{fill:#1C1C1C;}\n\t.st46{fill:#1D1D1C;}\n\t.st47{fill:#3C332E;}\n\t.st48{fill:#64301C;}\n\t.st49{fill:#975E22;}\n\t.st50{fill:#472E1B;}\n\t.st51{fill:#6D341E;}\n\t.st52{fill:#261E17;}\n\t.st53{fill:#1C1D1D;}\n\t.st54{fill:#472C17;}\n\t.st55{fill:#161716;}\n\t.st56{fill:#362E25;}\n\t.st57{fill:#CB9A5A;}\n\t.st58{fill:#6E3E1C;}\n\t.st59{fill:#975C22;}\n\t.st60{fill:#553218;}\n\t.st61{fill:#DA5419;}\n\t.st62{fill:#040405;}\n\t.st63{fill:#C9C6BC;}\n\t.st64{fill:#543419;}\n\t.st65{fill:#A56A25;}\n\t.st66{fill:#F2B82B;}\n\t.st67{fill:#FBEFCD;}\n\t.st68{fill:#FCE39B;}\n\t.st69{fill:#3D2B1F;}\n\t.st70{fill:#6F401E;}\n\t.st71{clip-path:url(#SVGID_16_);}\n\t.st72{fill:url(#Trazado_5532_1_);}\n\t.st73{fill:none;stroke:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3573"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M22.6,11.8c0.1,5.9-4.5,10.7-10.4,10.8S1.5,18.1,1.4,12.2C1.3,6.4,5.9,1.5,11.8,1.4H12 C17.8,1.3,22.5,6,22.6,11.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3571"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -4,
    y: 2.7,
    width: 32.1,
    height: 18.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2261"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1978",
    x: -4,
    y: 2.7,
    className: "st2",
    width: 32.1,
    height: 18.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1979",
    className: "st3",
    d: "M-4,2.7H6.7V21H-4V2.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1980",
    className: "st4",
    d: "M17.4,2.7h10.7V21H17.4V2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3559"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -4,
    y: 2.7,
    width: 32.1,
    height: 18.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4787",
    className: "st6",
    d: "M10.3,9.8c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1-0.4-0.1-0.4S9.8,9.4,9.8,9.3 S10.1,9,10.1,9h0.1c0,0,0.1-0.1,0.1-0.1s0.1,0,0,0S10.2,9,10.2,9.1s0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1 c0,0,0,0.1,0,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.1-0.1s0,0.1-0.1,0.1s-0.1,0.1-0.2,0.1s0,0.1,0.1,0.1 c0.1,0,0.1,0,0.2,0L10.3,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4788",
    className: "st6",
    d: "M9.6,10.6c0.1,0,0.1,0.1,0.1,0.1c0,0.1-0.1,0.2-0.1,0.4s0,0.2,0.3,0.4 c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.4,0.3,0.4s0.3-0.2,0.3-0.2l-0.1-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1-0.1 c0-0.1,0-0.2-0.1-0.3c-0.1-0.2-0.3-0.2-0.3-0.4s0.1-0.2,0.1-0.4c0-0.1-0.1-0.2-0.3-0.3H9.5L9.6,10.6L9.6,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4789",
    className: "st7",
    d: "M10.3,9.3c0.1,0,0-0.2,0-0.2l-0.1,0.1C10.2,9.1,10.2,9.1,10.3,9.3 C10.2,9.2,10.2,9.2,10.3,9.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4790",
    className: "st6",
    d: "M10.4,11.4L10.4,11.4c0,0-0.2-0.1-0.1-0.4s0.6-0.5,0.6-0.7 s0.2-0.2-0.3-0.5l-0.1,0.1l0.2,0.1l0,0c0,0,0,0.1-0.1,0.1l-0.3,0.2l-0.1,0.1c-0.1,0.1-0.1,0.1-0.1,0.2 C10,10.8,10,10.9,10,11C10,11.2,10.2,11.4,10.4,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4791",
    className: "st8",
    d: "M10.2,11.6v0.1h-0.1H10L10,11.8l0,0l0,0c0,0,0,0,0-0.1H10h0.1L10.2,11.6 L10.2,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4792",
    className: "st8",
    d: "M9.9,11.6L9.9,11.6L9.9,11.6L9.9,11.6L9.9,11.6L9.9,11.6L9.9,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4793",
    className: "st8",
    d: "M10.1,11.4C10.1,11.4,10.1,11.5,10.1,11.4v0.1H10H9.9v-0.1L10.1,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4794",
    className: "st8",
    d: "M10,12L10,12C10,12,10,11.9,10,12L10,12L10,12L10,12L10,12L10,12L10,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4795",
    className: "st8",
    d: "M10.3,11.8C10.3,11.8,10.2,11.8,10.3,11.8C10.2,11.8,10.2,11.8,10.3,11.8 L10.3,11.8l-0.1,0.1h0.1V11.8L10.3,11.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4796",
    className: "st8",
    d: "M10.1,12L10.1,12h0.1l0,0v-0.1L10.1,12L10.1,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4797",
    className: "st8",
    d: "M10.3,12l0.1-0.1v-0.1l0,0h-0.1L10.3,12L10.3,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4798",
    className: "st8",
    d: "M10.2,12.1c0.1,0,0.2,0,0.2,0c0.1,0,0.1-0.1,0.1-0.1h-0.1l-0.1,0.1H10.2z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4799",
    className: "st8",
    d: "M10.1,11.1L10,11l0,0h0.1V11.1L10.1,11.1L10.1,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4800",
    className: "st8",
    d: "M10.2,11.3L10.2,11.3L10.2,11.3L10.2,11.3L10.2,11.3L10.2,11.3L10.2,11.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4801",
    className: "st9",
    d: "M9.9,9.2c0,0,0,0.1,0,0.1s0.1,0,0.2-0.1c0,0,0.1-0.1,0.1-0.1V9 c0,0-0.1,0-0.1,0L9.9,9.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4803",
    className: "st6",
    d: "M10,9.1L10,9.1C10,9.1,10,9.1,10,9.1c0.1,0,0.1,0,0.2,0l0,0 C10.2,9.1,10.1,9.1,10,9.1L10,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4804",
    className: "st8",
    d: "M10.2,11.1C10.2,11.1,10.2,11.1,10.2,11.1L10.2,11.1L10.2,11.1L10.2,11.1 L10.2,11.1L10.2,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4805",
    className: "st8",
    d: "M10,10.9v-0.1v-0.1v0.1V10.9L10,10.9L10,10.9L10,10.9L10,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4806",
    className: "st8",
    d: "M10.2,10.9C10.2,10.9,10.2,10.9,10.2,10.9c0-0.1,0-0.1,0-0.1l0,0V10.9 L10.2,10.9L10.2,10.9L10.2,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4807",
    className: "st8",
    d: "M10.1,10.6C10.1,10.6,10.1,10.6,10.1,10.6l0.1-0.2L10.1,10.6L10.1,10.6 L10.1,10.6L10.1,10.6L10.1,10.6L10.1,10.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4808",
    className: "st8",
    d: "M10.3,10.8L10.3,10.8L10.3,10.8l-0.1-0.1v0.1H10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4809",
    className: "st8",
    d: "M10.2,10.4C10.2,10.4,10.2,10.4,10.2,10.4c0.1,0,0.1,0,0.1,0v0.2h-0.1 L10.2,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4810",
    className: "st8",
    d: "M10.4,10.7l0.1-0.1l-0.2-0.1L10.4,10.7L10.4,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4811",
    className: "st8",
    d: "M10.5,10.4v-0.2c0,0,0,0-0.1,0h-0.1l0,0h0.1L10.5,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4813",
    className: "st8",
    d: "M10.7,10.4L10.7,10.4c0.1-0.1,0.1-0.1,0.1-0.1h-0.2L10.7,10.4L10.7,10.4z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4814",
    className: "st8",
    d: "M10.2,9.8h0.2V9.8h-0.1V9.7v0.1L10.2,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4815",
    className: "st8",
    d: "M10.5,10.5L10.5,10.5l0.1-0.1h-0.2L10.5,10.5L10.5,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4816",
    className: "st8",
    d: "M10.8,10.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1l-0.1,0.1v0.1v0.1L10.8,10.2z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4817",
    className: "st8",
    d: "M10.6,10.1L10.6,10.1L10.6,10.1l0.2-0.1v0.1L10.6,10.1L10.6,10.1 L10.6,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4818",
    className: "st8",
    d: "M10.8,10l-0.1-0.1V9.8L10.8,10L10.8,10L10.8,10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4819",
    className: "st2",
    d: "M9.6,11L9.6,11c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1l0,0 c0,0-0.1-0.1-0.1-0.1C9.7,11,9.7,11,9.6,11 M9.6,10.7L9.6,10.7C9.6,10.7,9.7,10.6,9.6,10.7 c0.1-0.1,0.1-0.1,0.2-0.1l0,0C9.8,10.6,9.7,10.6,9.6,10.7C9.7,10.7,9.7,10.7,9.6,10.7 M9.9,10.9 C9.9,10.9,9.9,10.9,9.9,10.9c-0.1-0.1-0.2-0.1-0.2-0.1l0,0C9.8,10.8,9.8,10.8,9.9,10.9 C9.8,10.8,9.9,10.8,9.9,10.9z M9.7,10.7L9.7,10.7c0,0,0-0.1,0-0.1l0.1-0.1l0,0L9.7,10.7 C9.7,10.6,9.7,10.6,9.7,10.7 M9.7,10.6L9.7,10.6L9.7,10.6L9.7,10.6L9.7,10.6c0.1,0,0.1,0.1,0.1,0.1l0,0 C9.7,10.6,9.7,10.6,9.7,10.6 M10.1,9.6L10.1,9.6c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0,0.1l0,0c0,0,0-0.1,0-0.1 c0,0,0.1,0.1,0.1,0.1l0,0c0,0,0-0.1,0-0.1l0,0c0,0,0.1,0.1,0.1,0.1l0,0l-0.1-0.1l0,0c0,0,0.1-0.1,0.1-0.1l0,0 l0,0l0,0l0,0l-0.1,0.1c0,0,0-0.1,0-0.1l0,0c0,0-0.1,0-0.1,0.1c0,0,0-0.1,0.1-0.1l0,0L10.1,9.6 C10.1,9.7,10.1,9.7,10.1,9.6L10.1,9.6l-0.1,0 M10.1,9.7c0,0,0.1-0.1,0.1-0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 L10.1,9.7L10.1,9.7 M9.7,10.7L9.7,10.7c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l0,0c0,0-0.1,0-0.1,0 C9.8,10.7,9.7,10.7,9.7,10.7 M10.8,10.2L10.8,10.2L10.8,10.2L10.8,10.2L10.8,10.2L10.8,10.2 c-0.1-0.1-0.1-0.1-0.1-0.2V9.9l0,0l0,0c0,0-0.1,0-0.1,0l0,0h0.1h0.1V10l0,0l0,0l0,0h0.1 C10.9,10,10.9,10.1,10.8,10.2L10.8,10.2L10.7,10l0,0l0,0h-0.1l0,0v0.1h-0.1l0,0l0,0c0,0.1,0,0.1,0,0.2l0,0 c0,0-0.1,0-0.1-0.1l0,0c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1-0.1l0,0c0,0.1,0,0.1,0,0.2l0,0l0,0c0,0-0.1,0-0.1-0.1l0,0 c0,0.1,0,0.1,0.1,0.2l0,0c0,0-0.1,0-0.1,0V11l0.1,0.1l0,0h-0.1l0,0l0.1-0.1h0.1l0,0h-0.1l0.1-0.1v-0.1 c0,0,0,0-0.1,0c0.1-0.1,0.1-0.1,0.1-0.1l0,0c0,0,0,0-0.1-0.1h0.1l0,0c0,0,0-0.1-0.1-0.1h0.1l0,0c0,0,0-0.1,0-0.1 h0.2c0,0,0-0.1,0-0.1h0.2l0,0C10.9,10.3,10.9,10.3,10.8,10.2 M10.3,11c0,0,0,0.1-0.1,0.1l0,0l0,0 c0,0-0.1,0-0.1-0.1L10.3,11L10.3,11 M10.3,10.8l-0.1,0.1l0,0c-0.1,0-0.1-0.1-0.1-0.2 C10.2,10.7,10.2,10.7,10.3,10.8L10.3,10.8C10.3,10.8,10.3,10.8,10.3,10.8 M10.4,10.7h-0.1l0,0c0-0.1,0-0.1,0-0.2 c0,0,0.1,0.1,0.1,0.1V10.7 M10.4,10.5c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1L10.4,10.5 M10.7,10.4 c0,0-0.1,0-0.1,0l0,0c0,0,0-0.1,0-0.1l0,0h0.1l0,0L10.7,10.4 M10.6,10.2L10.6,10.2v-0.1h0.1 C10.7,10.1,10.7,10.1,10.6,10.2h0.1H10.6 M10.2,11.1L10.2,11.1C10.2,11.1,10.2,11.2,10.2,11.1L10.2,11.1 l-0.2,0.1l0,0L10.2,11.1L10.2,11.1l-0.1,0.1l0,0L10.2,11.1L10.2,11.1L10.2,11.1c0,0.1,0,0.1,0,0.1h0.1l0,0h-0.1 C10.3,11.2,10.3,11.2,10.2,11.1L10.2,11.1L10.2,11.1L10.2,11.1L10.2,11.1 M9.7,11.1c0,0,0.1,0,0.1,0l0,0 C9.8,11.1,9.7,11.1,9.7,11.1c0-0.1-0.1,0-0.1,0v0.1C9.6,11.1,9.7,11.1,9.7,11.1 M10.4,12.1h-0.1V12 c0.1,0,0.1-0.1,0.1-0.1l0,0c0,0.1-0.1,0.1-0.1,0.1c0-0.1,0-0.2,0-0.2l0,0c0,0-0.1,0.1-0.1,0.1c0,0,0-0.1,0-0.1 l0,0h-0.1l0,0l0.1-0.2l0,0l-0.1,0.1l0,0H10l0,0h0.1c0,0,0,0-0.1,0.1v0.1h0.1c0,0-0.1,0.1-0.1,0.1l0,0 c0.1,0,0.1,0,0.2,0l-0.1,0.1C10.2,12.1,10.3,12.1,10.4,12.1C10.4,12.1,10.4,12.1,10.4,12.1L10.4,12.1 C10.4,12.1,10.4,12.1,10.4,12.1 M10,11.9L10,11.9L10,11.9c0.1-0.1,0.1-0.1,0.2-0.1c0,0,0,0,0,0.1L10,11.9  M10.1,12.1L10.1,12.1L10.1,12.1c0.1-0.1,0.2-0.1,0.2-0.1c0,0,0,0.1,0,0.1C10.3,12.1,10.2,12.1,10.1,12.1  M10,11.5h0.2l0,0H10c0.1,0,0.1-0.1,0.1-0.1l0,0C10.1,11.4,10.1,11.4,10,11.5L10,11.5L10,11.5 C10,11.5,10,11.5,10,11.5L10,11.5L10,11.5C10,11.6,10,11.6,10,11.5L10,11.5L10,11.5L10,11.5z M9.9,11.2L9.9,11.2 H9.7c0,0-0.1,0.1-0.1,0.1v0.1c0,0,0.1-0.1,0.1-0.1C9.7,11.3,9.8,11.3,9.9,11.2 M9.9,11.4L9.9,11.4 c-0.1,0-0.1,0-0.2,0c0,0,0,0.1,0,0.1l0,0c0,0,0-0.1,0-0.1H9.9 M9.7,11.3c0,0,0.1,0,0.1-0.1l0,0 C9.8,11.3,9.7,11.3,9.7,11.3C9.7,11.3,9.6,11.3,9.7,11.3L9.7,11.3L9.7,11.3 M10,9.1L10,9.1C10,9,10,9,10,9.1 L10,9.1l0.1,0.1c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1l0,0l0,0c0,0,0,0,0-0.1 c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1C10.1,9.2,10.1,9.1,10,9.1L10,9.1C10,9.1,9.9,9.1,10,9.1L9.8,9.2 c0,0,0.1,0,0.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4820",
    className: "st8",
    d: "M10.3,9.6h-0.1v0.1L10.3,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4822",
    className: "st8",
    d: "M10.1,9.8L10,9.7v0.1L10.1,9.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4823",
    className: "st8",
    d: "M10.5,12L10.5,12c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0 c0,0-0.1,0-0.1-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2l-0.2-0.2c-0.1-0.1-0.1-0.1-0.1-0.2l0,0 c0-0.1,0-0.2,0.1-0.2c0,0,0.1-0.1,0.1-0.2l0,0c0,0,0-0.1-0.1-0.1H9.6H9.5h0.1l0,0h0.1c0,0,0,0.1,0,0.1l0,0 c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.2l0,0c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.1,0.1,0.2,0.1 c0,0.1,0.1,0.2,0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.2,0C10.3,12.1,10.4,12.1,10.5,12 L10.5,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4824",
    className: "st8",
    d: "M10.4,11.8L10.4,11.8L10.4,11.8c-0.1,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1 c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.1-0.2l0,0c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.2 l0,0c0-0.1-0.1-0.2-0.2-0.2l-0.1-0.1l0,0c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.1,0.2l0,0c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.1,0,0.2l0,0c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0.1,0.1 C10.3,11.8,10.4,11.8,10.4,11.8L10.4,11.8L10.4,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4825",
    className: "st6",
    d: "M10.9,11.4C10.9,11.4,10.9,11.4,10.9,11.4c0.1,0.1,0.1,0.2,0.1,0.2 l-0.1-0.1L10.9,11.4L10.9,11.4L10.9,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4826",
    className: "st11",
    d: "M9.4,10.6c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1-0.1 s0.1,0,0.1,0s0-0.1,0.1-0.1s0.1,0,0.1,0L9.4,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4827",
    className: "st12",
    d: "M9.4,10.6L9.4,10.6C9.3,10.6,9.3,10.6,9.4,10.6L9.4,10.6L9.4,10.6 L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6l0,0.1 l0,0L9.4,10.6L9.4,10.6L9.4,10.6C9.4,10.5,9.3,10.5,9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6 L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6C9.3,10.5,9.3,10.6,9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4828",
    className: "st11",
    d: "M9.4,10.6c0,0-0.1,0-0.1,0s0-0.1,0-0.1c0,0-0.1,0-0.1-0.1 c0,0,0.1,0,0.1,0s0-0.1,0.1-0.1c0,0,0,0,0.1,0.1L9.4,10.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4829",
    className: "st12",
    d: "M9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6 L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6c0,0,0,0.1,0,0.1l0,0 C9.4,10.7,9.4,10.6,9.4,10.6L9.4,10.6L9.4,10.6L9.4,10.6C9.4,10.5,9.4,10.5,9.4,10.6L9.4,10.6L9.4,10.6l-0.1-0.1 l0,0l0,0l0,0l0,0l0,0l0,0l0,0L9.4,10.6L9.4,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4830",
    className: "st11",
    d: "M9.6,10.6C9.5,10.6,9.5,10.6,9.6,10.6c-0.1,0-0.1-0.1-0.1-0.1 s-0.1,0,0-0.1s0.1,0,0.1,0s0-0.1,0.1-0.1s0.1,0.1,0.1,0.1s-0.1,0-0.1,0.1C9.6,10.6,9.6,10.6,9.6,10.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4831",
    className: "st12",
    d: "M9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6 L9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6L9.6,10.6 L9.6,10.6c-0.1,0-0.1,0-0.1,0.1l0,0c0,0,0,0.1,0,0.1l0,0v-0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0l0,0l0,0 c0,0,0,0,0,0.1l0,0l0,0 M9.4,10.8L9.4,10.8L9.4,10.8L9.4,10.8L9.4,10.8L9.4,10.8L9.4,10.8L9.4,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4832",
    className: "st13",
    d: "M10.7,11.4l-0.1-0.1l-0.1-0.1l-0.1-0.1L10.3,11v-0.1v-0.1v-0.1 c0,0-0.2,0.1-0.1,0.5c0,0.1,0.1,0.2,0.2,0.2L10.7,11.4L10.7,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4833",
    className: "st14",
    d: "M10.6,10L10.6,10L10.6,10L10.6,10c-0.1,0.2-0.2,0.3-0.4,0.4 c-0.1,0.1-0.1,0.1-0.2,0.2C10,10.6,10,10.7,10,10.9l0,0c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.1,0.3,0.1h0.3l0,0 l0,0c0,0,0,0,0,0.1l0,0l0,0l0,0c0,0,0,0,0-0.1l0,0h-0.1h-0.3c-0.1,0-0.2,0-0.2-0.1C10,11.2,9.9,11,9.9,10.9l0,0 c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.2,0.3-0.3C10.4,10.2,10.5,10.1,10.6,10L10.6,10L10.6,10L10.6,10L10.6,10 L10.6,10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4834",
    className: "st2",
    d: "M10.9,11.5c0,0,0,0.1-0.1,0.1c0,0,0.1,0,0.1,0l0,0c0,0-0.1,0-0.1,0l0,0 h0.1C10.9,11.5,10.9,11.5,10.9,11.5L10.9,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4835",
    className: "st15",
    d: "M11.1,11.5H11h-0.1c0,0,0-0.1,0-0.1h-0.1h-0.1l-0.2-0.3h0.1h0.1h0.2H11 l0,0l0,0v0.1v0.1v0.2L11.1,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4836",
    className: "st13",
    d: "M11.1,11.5H11h-0.1l0,0v0.1v0.1h0.1h0.1L11.1,11.5L11.1,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4838",
    className: "st15",
    d: "M11,10V9.9l-0.1-0.1V9.7l-0.1-0.1l0,0l0,0h-0.1l-0.1,0.1 C10.8,9.9,10.9,9.9,11,10c0,0.1,0.1,0.1,0.1,0.1l0,0L11,10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4839",
    className: "st13",
    d: "M10.9,10.1c0,0.1,0,0.1,0,0.2V10.1l0.1,0c0,0-0.1-0.1-0.1-0.1 C10.9,10,10.9,10.1,10.9,10.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4840",
    className: "st14",
    d: "M11.1,11.7L11.1,11.7l-0.1-0.1l0,0H11l0,0l0,0L11.1,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4841",
    className: "st16",
    d: "M11.1,11.6C11.1,11.6,11.1,11.7,11.1,11.6L11,11.8l0.1,0.1l0.1-0.1 L11.1,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4843",
    className: "st15",
    d: "M13.8,14.2v0.2l0.1-0.1L13.8,14.2L13.8,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4844",
    className: "st18",
    d: "M13.8,14.2L13.8,14.2v0.2l0.1-0.1L13.8,14.2L13.8,14.2L13.8,14.2 l0.1,0.2h-0.1L13.8,14.2L13.8,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4845",
    className: "st15",
    d: "M13.9,14.2C13.9,14.2,13.9,14.3,13.9,14.2L13.9,14.2 c-0.1,0.1-0.1,0.1-0.1,0c0,0,0,0,0,0l0,0c0,0,0-0.1,0-0.1C13.8,14.1,13.8,14.1,13.9,14.2L13.9,14.2 C13.8,14.1,13.9,14.2,13.9,14.2C13.9,14.2,13.9,14.2,13.9,14.2L13.9,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4846",
    className: "st18",
    d: "M13.9,14.2L13.9,14.2C13.9,14.2,13.9,14.3,13.9,14.2 C13.9,14.3,13.8,14.3,13.9,14.2L13.9,14.2c-0.1,0.1-0.1,0.1-0.1,0l0,0C13.8,14.2,13.8,14.1,13.9,14.2L13.9,14.2 C13.9,14.1,13.9,14.2,13.9,14.2L13.9,14.2C13.9,14.2,13.9,14.1,13.9,14.2C13.8,14.1,13.8,14.1,13.9,14.2 L13.9,14.2c-0.1-0.1-0.2,0-0.2,0C13.7,14.2,13.8,14.3,13.9,14.2L13.9,14.2C13.8,14.3,13.9,14.3,13.9,14.2 L13.9,14.2L13.9,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4848",
    className: "st18",
    d: "M13.9,14.2L13.9,14.2c-0.1,0-0.1,0-0.1,0c0,0,0,0,0-0.1l0,0v0.1l0,0 L13.9,14.2L13.9,14.2L13.9,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4849",
    className: "st15",
    d: "M14.1,14.6l-0.2-0.2l-0.1,0.1L14.1,14.6L14.1,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4850",
    className: "st18",
    d: "M14.1,14.6L14.1,14.6l-0.2-0.2l-0.1,0.1L14.1,14.6L14.1,14.6L14.1,14.6 L14.1,14.6l-0.2-0.1H14L14.1,14.6L14.1,14.6L14.1,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4851",
    className: "st15",
    d: "M14.1,14.7C14.1,14.7,14.1,14.6,14.1,14.7c0-0.1,0-0.1,0-0.1 c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1C14.2,14.7,14.2,14.7,14.1,14.7L14.1,14.7C14.1,14.7,14.1,14.7,14.1,14.7 C14.1,14.7,14.1,14.7,14.1,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4852",
    className: "st18",
    d: "M14.1,14.7L14.1,14.7L14.1,14.7C14.1,14.7,14.1,14.6,14.1,14.7 L14.1,14.7L14.1,14.7L14.1,14.7C14.1,14.7,14.1,14.7,14.1,14.7L14.1,14.7L14.1,14.7C14,14.7,14.1,14.7,14.1,14.7 L14.1,14.7C14.1,14.7,14.1,14.6,14.1,14.7c0-0.1-0.1-0.1-0.1-0.1H14c0,0,0,0,0,0.1l0,0L14.1,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4853",
    className: "st18",
    d: "M14.1,14.6L14.1,14.6l-0.2-0.1L14.1,14.6L14.1,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4854",
    className: "st18",
    d: "M14.2,14.6C14.2,14.7,14.2,14.7,14.2,14.6L14.2,14.6 C14.1,14.6,14.1,14.6,14.2,14.6L14.2,14.6L14.2,14.6L14.2,14.6L14.2,14.6L14.2,14.6L14.2,14.6L14.2,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4855",
    className: "st15",
    d: "M15.4,12.3l0.2,0.2v-0.1L15.4,12.3L15.4,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4856",
    className: "st18",
    d: "M15.4,12.3L15.4,12.3l0.2,0.2v-0.1L15.4,12.3L15.4,12.3L15.4,12.3 L15.4,12.3l0.2,0.1v0.1L15.4,12.3L15.4,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4857",
    className: "st15",
    d: "M15.4,12.2C15.4,12.3,15.4,12.3,15.4,12.2c-0.1,0.1-0.1,0-0.1,0l0,0 C15.3,12.2,15.3,12.2,15.4,12.2L15.4,12.2C15.4,12.2,15.4,12.2,15.4,12.2L15.4,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4858",
    className: "st18",
    d: "M15.4,12.3L15.4,12.3C15.4,12.3,15.4,12.3,15.4,12.3L15.4,12.3 L15.4,12.3c-0.1,0.1-0.1,0-0.1,0l0,0C15.3,12.2,15.3,12.2,15.4,12.3L15.4,12.3C15.4,12.2,15.4,12.2,15.4,12.3 L15.4,12.3C15.4,12.2,15.4,12.2,15.4,12.3C15.3,12.2,15.3,12.2,15.4,12.3c-0.1-0.1-0.1-0.1-0.1,0 C15.3,12.3,15.3,12.3,15.4,12.3C15.3,12.3,15.3,12.3,15.4,12.3L15.4,12.3C15.4,12.3,15.4,12.3,15.4,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4860",
    className: "st18",
    d: "M15.4,12.2C15.4,12.3,15.4,12.3,15.4,12.2c-0.1,0.1-0.1,0-0.1,0l0,0l0,0 v0.1l0,0l0,0l0,0l0,0L15.4,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4861",
    className: "st15",
    d: "M15.8,12.4l-0.3,0.1v-0.1L15.8,12.4L15.8,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4862",
    className: "st18",
    d: "M15.8,12.4L15.8,12.4l-0.2,0.1v-0.1H15.8L15.8,12.4L15.8,12.4L15.8,12.4 h-0.3v0.1L15.8,12.4L15.8,12.4L15.8,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4863",
    className: "st15",
    d: "M15.9,12.4C15.9,12.4,15.9,12.4,15.9,12.4L15.9,12.4 c-0.1,0.1-0.1,0-0.1,0C15.8,12.3,15.8,12.3,15.9,12.4C15.9,12.3,15.9,12.3,15.9,12.4 C15.9,12.4,15.9,12.4,15.9,12.4L15.9,12.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4864",
    className: "st18",
    d: "M15.9,12.4L15.9,12.4C15.9,12.4,15.9,12.4,15.9,12.4 c-0.1,0.1-0.1,0-0.1,0l0,0C15.8,12.3,15.8,12.3,15.9,12.4L15.9,12.4L15.9,12.4C15.9,12.3,15.9,12.3,15.9,12.4 L15.9,12.4C15.9,12.3,15.9,12.3,15.9,12.4c-0.1-0.1-0.1,0-0.1,0C15.8,12.4,15.8,12.4,15.9,12.4L15.9,12.4 C15.9,12.4,15.9,12.4,15.9,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4865",
    className: "st18",
    d: "M15.9,12.3L15.9,12.3C15.9,12.4,15.9,12.4,15.9,12.3 C15.9,12.4,15.9,12.4,15.9,12.3c-0.1,0.1-0.1,0-0.1,0l0,0l0,0l0,0l0,0l0,0l0,0v-0.1L15.9,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4867",
    className: "st15",
    d: "M15,13.6l-0.2-0.2l0,0L15,13.6L15,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4868",
    className: "st18",
    d: "M15,13.6L15,13.6l-0.2-0.2l0,0L15,13.6L15,13.6L15,13.6L15,13.6 l-0.1-0.2l0,0L15,13.6L15,13.6L15,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4869",
    className: "st15",
    d: "M14.8,13.3C14.8,13.3,14.8,13.3,14.8,13.3c0.1,0.1,0,0.1,0,0.1 C14.7,13.4,14.7,13.4,14.8,13.3C14.7,13.3,14.7,13.3,14.8,13.3C14.7,13.3,14.7,13.3,14.8,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4870",
    className: "st18",
    d: "M14.9,13.3L14.9,13.3C14.9,13.4,14.8,13.4,14.9,13.3L14.9,13.3 c-0.1,0.1-0.1,0-0.1,0C14.7,13.3,14.7,13.3,14.9,13.3C14.8,13.3,14.9,13.3,14.9,13.3L14.9,13.3 C14.8,13.3,14.8,13.3,14.9,13.3c-0.1-0.1-0.2,0-0.2,0C14.7,13.4,14.7,13.4,14.9,13.3 C14.8,13.4,14.8,13.4,14.9,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4871",
    className: "st18",
    d: "M14.9,13.5L14.9,13.5L14.9,13.5L14.9,13.5L14.9,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4872",
    className: "st18",
    d: "M14.8,13.3c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0l0,0v0.1l0,0 L14.8,13.3L14.8,13.3L14.8,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4873",
    className: "st15",
    d: "M15,13.6h0.2l0,0H15L15,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4874",
    className: "st18",
    d: "M15,13.6L15,13.6h0.2l0,0H15L15,13.6L15,13.6L15,13.6L15,13.6L15,13.6 L15,13.6L15,13.6L15,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4875",
    className: "st15",
    d: "M15.3,13.7C15.3,13.7,15.3,13.7,15.3,13.7L15.3,13.7 c-0.1,0.1-0.1,0-0.1,0C15.1,13.6,15.2,13.6,15.3,13.7C15.3,13.6,15.3,13.6,15.3,13.7L15.3,13.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4876",
    className: "st18",
    d: "M15.3,13.7L15.3,13.7C15.3,13.7,15.3,13.7,15.3,13.7 c-0.1,0.1-0.1,0-0.1,0l0,0C15.2,13.6,15.2,13.6,15.3,13.7C15.3,13.6,15.3,13.6,15.3,13.7L15.3,13.7 C15.3,13.6,15.3,13.6,15.3,13.7c-0.1-0.1-0.2,0-0.2,0C15.1,13.7,15.2,13.8,15.3,13.7L15.3,13.7 C15.3,13.8,15.3,13.7,15.3,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4878",
    className: "st18",
    d: "M15.3,13.7C15.3,13.7,15.3,13.7,15.3,13.7L15.3,13.7 C15.3,13.7,15.3,13.7,15.3,13.7L15.3,13.7L15.3,13.7L15.3,13.7L15.3,13.7L15.3,13.7L15.3,13.7L15.3,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4879",
    className: "st19",
    d: "M16,11.8c0,0.2-0.2,0.3-0.3,0.4c-0.1,0-0.1,0.1-0.1,0.2v0.1v0.1l0,0 c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.2l0.1-0.1h0.1l0,0c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.2-0.1,0.3-0.3,0.4 c-0.1,0.1-0.2,0-0.3,0.1l0,0L15,13.6v0.1h-0.1l0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1H15h0c0,0,0,0,0,0.1 c0,0.1-0.1,0.3-0.2,0.3c-0.2,0.1-0.4,0.1-0.7,0.1h-0.1L14,14.4l-0.1,0.1l0,0l-0.1,0.1l-0.1,0.1c0,0,0.1,0,0.1,0 l0.2,0.1h-0.2c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.2-0.4-0.2l-0.1-0.1h-0.2h-0.2v-0.1h0.2 c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l0.3-0.2l0.3-0.1h0.1h0.1l0,0v0.1l-0.1,0.1l0,0h0.2h0.1l0,0 c0,0,0,0,0-0.1c0-0.1,0.1-0.1,0.2-0.1h0.1l0.1-0.2V14l0.2-0.2l0.1-0.1l0.1-0.2l0,0c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.1s0-0.1,0-0.1V13 l0.1-0.3l0.2-0.1l0,0c0,0,0,0,0,0.1v0.1c0-0.1,0.1-0.1,0.1-0.1l0,0v-0.1c0-0.1,0-0.1,0-0.2v-0.1v-0.1l-0.1-0.2 v-0.3l-0.1-0.1c0,0,0,0,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2l0.2-0.5c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.2l0.3-0.2 v0.1C16.1,11.6,16.1,11.7,16,11.8 M12.7,15c0,0,0-0.1-0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1v0.1l0.2,0.1L12.7,15 L12.7,15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4880",
    className: "st20",
    d: "M13.8,14.6c0.1-0.1,0.1-0.1,0.2-0.2h0.2c0.1,0,0.2,0,0.3-0.1 c0.1-0.1,0.2-0.2,0.3-0.3h0.1l-0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.4,0.1 C14,14.5,14,14.5,13.8,14.6l0,0.1l0,0 M14.4,14c-0.1,0.1-0.2,0.2-0.3,0.4c0,0,0.2-0.1,0.3-0.2s0.2-0.1,0.3-0.2 s0.1-0.1,0.1-0.1c0,0,0,0,0.1-0.1C14.9,13.8,14.8,13.7,14.4,14 M14,14.5c0.1,0,0.1-0.1,0.1-0.1 c0,0,0-0.1,0.1-0.1c0,0,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0,0.1,0,0.1c-0.1,0.1-0.3,0.2-0.4,0.4 c0,0.1,0,0.1,0,0.2C14.1,14.4,14.1,14.4,14,14.5 M13.9,15c-0.1,0-0.1-0.1-0.2-0.1c-0.2,0-0.4,0.2-0.6,0.2 s-0.2-0.1-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1l0,0c0.1,0,0.2,0,0.3,0c0.2,0.1,0.3,0.2,0.5,0.2 c0.2,0,0.4-0.1,0.6-0.2C13.8,14.9,13.8,14.9,13.9,15 M12.7,14.8c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.3-0.2,0.4-0.3 h0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.1,0.1-0.2,0.2C12.9,14.8,12.8,14.8,12.7,14.8 M12.7,15.1 L12.7,15.1L12.5,15l-0.2-0.1l0,0l0.2,0.1C12.5,15,12.6,15,12.7,15.1C12.6,15.1,12.7,15.1,12.7,15.1 C12.7,15.1,12.8,15.1,12.7,15.1C12.7,15,12.7,15,12.7,15.1 M12.8,14.9c0.1,0,0.1,0,0.2,0c0.3,0,0.4-0.2,0.6-0.2 c0.1,0,0.2,0,0.3,0l0,0c-0.1,0-0.1-0.1-0.2-0.1c-0.2,0-0.5,0.1-0.7,0.2L12.8,14.9 M15.6,12.9 c-0.1,0.1-0.2,0.3-0.3,0.5c0,0.1-0.1,0.1-0.2,0.1L15,13.6l0,0l0,0c0,0,0,0,0.1-0.1c0-0.1,0.1-0.1,0.1-0.1 l0.3-0.2c0.1-0.1,0.2-0.4,0.2-0.4c0.1-0.1,0.1-0.1,0.2-0.1C15.9,12.7,15.8,12.7,15.6,12.9 M15.2,13.4 c0,0,0-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2 c-0.1,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.3-0.2,0.4C15.3,13.1,15.2,13.2,15.2,13.4 M15.1,13.5c0,0,0,0,0-0.2 c0-0.1,0-0.3,0-0.4c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.2,0.1-0.2,0.1C15.1,12.7,15,12.8,15,13 c0,0.1,0.1,0.2,0.1,0.3S15.1,13.5,15.1,13.5 M15.6,12.5c0,0,0-0.2,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2 c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1,0-0.2,0-0.4v0.1c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.2,0-0.3c0,0-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.4v0.3c0,0.1,0,0.1,0,0.2v0.1 L15.6,12.5L15.6,12.5z M15.4,11.5c0,0,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.1,0.1,0.2 c0,0.1,0,0.1,0,0.2c0-0.1,0-0.2,0-0.3c0-0.1,0,0-0.1-0.1c0-0.1,0-0.2,0-0.3C15.5,11.5,15.5,11.5,15.4,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4881",
    className: "st15",
    d: "M10.3,14.2C10.3,14.2,10.2,14.2,10.3,14.2c-0.1-0.1,0-0.1,0-0.1 C10.3,14.1,10.3,14.2,10.3,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4882",
    className: "st18",
    d: "M10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2 L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2 C10.3,14.2,10.3,14.2,10.3,14.2L10.3,14.2C10.3,14.2,10.3,14.2,10.3,14.2L10.3,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4883",
    className: "st15",
    d: "M10.3,14.3v0.2h-0.1L10.3,14.3L10.3,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4884",
    className: "st18",
    d: "M10.3,14.3L10.3,14.3l0.1,0.2h-0.1V14.3L10.3,14.3L10.3,14.3v0.3h0.1 L10.3,14.3L10.3,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4885",
    className: "st15",
    d: "M10.3,14.2c0,0,0,0.1-0.1,0.1s-0.1,0-0.1-0.1S10.2,14.3,10.3,14.2 C10.3,14.3,10.3,14.2,10.3,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4886",
    className: "st18",
    d: "M10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2 c-0.1,0-0.1,0-0.1,0s0,0,0,0l0,0l0,0H10.3L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2 L10.3,14.2h-0.1l0,0l0,0c0,0,0,0,0,0.1L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2L10.3,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4887",
    className: "st18",
    d: "M10.3,14.2c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0l0,0l0,0l0,0l0,0h0.1l0,0 l0,0l0,0l0,0L10.3,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4889",
    className: "st15",
    d: "M10,14.6C10,14.6,10,14.6,10,14.6c-0.2,0.1-0.2,0.1-0.2,0 S9.8,14.5,10,14.6C10,14.5,10,14.5,10,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4890",
    className: "st18",
    d: "M10,14.6L10,14.6L10,14.6L10,14.6L10,14.6L10,14.6L10,14.6 C10,14.6,10,14.6,10,14.6L10,14.6L10,14.6C10,14.6,10,14.6,10,14.6l-0.2-0.1c0,0,0,0,0,0.1l0,0 C9.9,14.6,9.9,14.6,10,14.6L10,14.6L10,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4891",
    className: "st15",
    d: "M10,14.6h0.2v-0.1L10,14.6L10,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4892",
    className: "st18",
    d: "M10,14.6h0.2v-0.1L10,14.6L10,14.6L10,14.6L10,14.6l0.2,0l0,0L10,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4893",
    className: "st15",
    d: "M10,14.5c0,0,0,0.1,0,0.1S9.9,14.6,10,14.5C9.9,14.6,9.9,14.5,10,14.5 C9.9,14.4,10,14.5,10,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4894",
    className: "st18",
    d: "M10,14.5L10,14.5C10,14.6,10,14.6,10,14.5c0,0.1,0,0.1,0,0.1l0,0l0,0  M9.9,14.6L9.9,14.6L9.9,14.6L9.9,14.6L9.9,14.6L9.9,14.6C9.9,14.5,9.9,14.5,9.9,14.6L9.9,14.6 C10,14.6,10,14.5,9.9,14.6C9.9,14.5,9.9,14.5,9.9,14.6L9.9,14.6L9.9,14.6C9.9,14.5,9.9,14.6,9.9,14.6L9.9,14.6 L9.9,14.6L9.9,14.6L9.9,14.6L9.9,14.6C9.9,14.6,9.9,14.6,9.9,14.6C9.9,14.5,9.9,14.6,9.9,14.6L9.9,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4896",
    className: "st18",
    d: "M10.1,14.6L10.1,14.6L10.1,14.6L10.1,14.6C10,14.6,10,14.6,10.1,14.6 L10.1,14.6L10.1,14.6L10.1,14.6L10.1,14.6L10.1,14.6L10.1,14.6L10.1,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4897",
    className: "st18",
    d: "M9.8,14.6C9.8,14.6,9.9,14.6,9.8,14.6L9.8,14.6L9.8,14.6L9.8,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4899",
    className: "st18",
    d: "M9.3,13.3L9.3,13.3C9.3,13.3,9.3,13.3,9.3,13.3L9.3,13.3 C9.2,13.3,9.2,13.2,9.3,13.3L9.3,13.3L9.3,13.3L9.3,13.3L9.3,13.3L9.3,13.3L9.3,13.3C9.3,13.2,9.3,13.3,9.3,13.3 L9.3,13.3L9.3,13.3C9.3,13.3,9.3,13.3,9.3,13.3L9.3,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4900",
    className: "st15",
    d: "M9.3,13.4v0.2l-0.1-0.1L9.3,13.4L9.3,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4901",
    className: "st18",
    d: "M9.3,13.4L9.3,13.4v0.2H9.2L9.3,13.4L9.3,13.4l-0.1,0.2l0.1,0.1 L9.3,13.4L9.3,13.4L9.3,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4902",
    className: "st15",
    d: "M9.4,13.3c0,0.1-0.1,0.1-0.1,0.1s-0.1,0-0.1-0.1s0.1,0,0.1,0 S9.3,13.3,9.4,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4903",
    className: "st18",
    d: "M9.4,13.3L9.4,13.3L9.4,13.3H9.2H9.2c0,0,0,0,0-0.1l0,0l0,0L9.4,13.3 L9.4,13.3L9.4,13.3L9.4,13.3l-0.1-0.1H9.2l0,0l0,0l0,0c0,0,0,0,0,0.1h0.1l0,0H9.4C9.3,13.3,9.3,13.3,9.4,13.3 L9.4,13.3L9.4,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4904",
    className: "st18",
    d: "M9.3,13.3L9.3,13.3C9.3,13.4,9.3,13.4,9.3,13.3 c-0.1,0.1-0.2,0.1-0.2,0.1l0,0l0,0l0,0h0.1l0,0L9.3,13.3L9.3,13.3L9.3,13.3L9.3,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4907",
    className: "st18",
    d: "M8.9,13.6L8.9,13.6C8.9,13.6,8.9,13.6,8.9,13.6H8.8 C8.8,13.6,8.8,13.6,8.9,13.6L8.9,13.6L8.9,13.6C8.9,13.6,8.9,13.6,8.9,13.6H8.8l0,0l0,0l0,0 C8.8,13.6,8.8,13.6,8.9,13.6L8.9,13.6L8.9,13.6L8.9,13.6L8.9,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4908",
    className: "st15",
    d: "M9,13.6h0.2l0.1,0.1L9,13.6L9,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4909",
    className: "st18",
    d: "M9,13.6h0.2l0.1,0.1L9,13.6L9,13.6L9,13.6L9,13.6l0.3,0.1l-0.1-0.1 L9,13.6L9,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4910",
    className: "st15",
    d: "M8.9,13.5C9,13.5,9,13.6,9,13.6l0,0c0,0.1,0,0.1-0.1,0.1c0,0,0,0,0-0.1 l0,0c0,0,0,0,0-0.1S8.9,13.6,8.9,13.5C8.9,13.5,8.9,13.6,8.9,13.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4911",
    className: "st18",
    d: "M8.9,13.5L8.9,13.5L8.9,13.5C9,13.5,9,13.6,8.9,13.5L8.9,13.5 c0.1,0.1,0.1,0.2,0,0.2c0,0,0,0,0,0l0,0l0,0l0,0l0,0l0,0l0,0C8.9,13.7,8.9,13.7,8.9,13.5L8.9,13.5L8.9,13.5 L8.9,13.5L8.9,13.5c0,0.1,0,0.1,0,0.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0.1,0,0.1,0,0.1-0.1v0l0,0c0,0,0,0,0-0.1 C9,13.5,9,13.5,8.9,13.5L8.9,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4913",
    className: "st18",
    d: "M9,13.6L9,13.6C9,13.6,9,13.7,9,13.6C8.8,13.7,8.9,13.7,9,13.6L9,13.6 L9,13.6L9,13.6L9,13.6L9,13.6L9,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4915",
    className: "st15",
    d: "M8.8,12.1C8.8,12.1,8.8,12.2,8.8,12.1C8.6,12.1,8.7,12.1,8.8,12.1 C8.7,12,8.8,12,8.8,12.1C8.8,12,8.8,12,8.8,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4916",
    className: "st18",
    d: "M8.8,12.1L8.8,12.1L8.8,12.1L8.8,12.1L8.8,12.1 C8.8,12.1,8.8,12.1,8.8,12.1L8.8,12.1L8.8,12.1L8.8,12.1C8.8,12.1,8.8,12.1,8.8,12.1L8.8,12.1 C8.8,12.1,8.8,12.1,8.8,12.1L8.8,12.1L8.8,12.1C8.8,12.1,8.8,12.1,8.8,12.1C8.7,12.1,8.7,12.1,8.8,12.1L8.8,12.1 L8.8,12.1L8.8,12.1L8.8,12.1L8.8,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4917",
    className: "st15",
    d: "M8.6,12.5l0.1-0.2l0,0L8.6,12.5L8.6,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4918",
    className: "st18",
    d: "M8.6,12.5L8.6,12.5l0.1-0.2l0,0L8.6,12.5L8.6,12.5L8.6,12.5L8.6,12.5 l0.1-0.2l0,0L8.6,12.5L8.6,12.5L8.6,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4919",
    className: "st15",
    d: "M8.6,12.2c0,0,0-0.1,0-0.1 M8.7,12.1L8.7,12.1L8.7,12.1 c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0.1l0,0C8.8,12.2,8.7,12.2,8.7,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4920",
    className: "st18",
    d: "M8.6,12.2L8.6,12.2C8.6,12.2,8.6,12.2,8.6,12.2L8.6,12.2L8.6,12.2 L8.6,12.2L8.6,12.2L8.6,12.2L8.6,12.2L8.6,12.2L8.6,12.2L8.6,12.2c-0.1-0.1-0.1-0.1-0.1-0.1l0,0 C8.6,12.2,8.6,12.2,8.6,12.2L8.6,12.2L8.6,12.2L8.6,12.2L8.6,12.2L8.6,12.2L8.6,12.2L8.6,12.2L8.6,12.2L8.6,12.2 L8.6,12.2C8.6,12.2,8.6,12.3,8.6,12.2L8.6,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4921",
    className: "st18",
    d: "M8.8,12.2L8.8,12.2C8.8,12.2,8.7,12.2,8.8,12.2l-0.2-0.1l0,0l0,0 L8.8,12.2L8.8,12.2L8.8,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4922",
    className: "st18",
    d: "M8.6,12.3L8.6,12.3C8.6,12.3,8.6,12.3,8.6,12.3L8.6,12.3L8.6,12.3 L8.6,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4923",
    className: "st15",
    d: "M8.2,12.2C8.2,12.2,8.2,12.3,8.2,12.2C8.2,12.3,8.2,12.3,8.2,12.2 C8,12.3,8.1,12.2,8.2,12.2C8.1,12.2,8.1,12.2,8.2,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4924",
    className: "st18",
    d: "M8.2,12.2L8.2,12.2C8.2,12.2,8.2,12.3,8.2,12.2L8.2,12.2L8.2,12.2 L8.2,12.2C8.2,12.3,8.2,12.2,8.2,12.2L8.2,12.2L8.2,12.2L8.2,12.2L8.2,12.2L8.2,12.2L8.2,12.2L8.2,12.2 C8.2,12.2,8.2,12.3,8.2,12.2L8.2,12.2L8.2,12.2L8.2,12.2C8.2,12.3,8.2,12.3,8.2,12.2L8.2,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4925",
    className: "st15",
    d: "M8.3,12.3l0.2,0.1v0.1L8.3,12.3L8.3,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4926",
    className: "st18",
    d: "M8.3,12.3L8.3,12.3l0.2,0.1v0.1L8.3,12.3L8.3,12.3L8.3,12.3L8.3,12.3 l0.2,0.2v-0.1L8.3,12.3L8.3,12.3L8.3,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4927",
    className: "st15",
    d: "M8.3,12.3c0,0-0.1,0.1-0.1,0s0-0.1,0-0.1l0,0c0,0,0,0,0-0.1s0.1,0,0.1,0 l0,0C8.3,12.3,8.3,12.3,8.3,12.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4928",
    className: "st18",
    d: "M8.3,12.3L8.3,12.3C8.3,12.3,8.3,12.3,8.3,12.3L8.3,12.3L8.3,12.3 L8.3,12.3L8.3,12.3L8.3,12.3L8.3,12.3L8.3,12.3L8.3,12.3c-0.1,0-0.1,0.1-0.1,0.1l0,0C8.3,12.4,8.3,12.4,8.3,12.3 L8.3,12.3L8.3,12.3L8.3,12.3L8.3,12.3L8.3,12.3L8.3,12.3L8.3,12.3L8.3,12.3L8.3,12.3L8.3,12.3 C8.3,12.4,8.3,12.4,8.3,12.3L8.3,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4929",
    className: "st18",
    d: "M8.4,12.3L8.4,12.3l0.1,0.1L8.4,12.3L8.4,12.3L8.4,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4931",
    className: "st18",
    d: "M8.2,12.3L8.2,12.3C8.2,12.3,8.2,12.3,8.2,12.3L8.2,12.3L8.2,12.3 L8.2,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4932",
    className: "st19",
    d: "M11.4,15c0,0,0-0.1,0.1-0.1c0.1-0.1,0.2-0.1,0.4-0.1v0.1h-0.1l-0.1,0.1 L11.5,15L11.4,15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4933",
    className: "st19",
    d: "M11.7,14.7c-0.1,0-0.2,0-0.3,0.1c0,0,0,0-0.1,0l-0.1-0.1l0,0v0.1 L11,14.5v0.1v0.1l-0.2-0.2v0.2h-0.1l-0.2-0.1l0,0v0.1h-0.2h-0.1l-0.1,0.1l0,0h0.1l0,0c0,0,0,0.1,0,0.1 s0.1-0.1,0.2-0.1s-0.1,0.1-0.1,0.2s0.2,0,0.2,0s0.1-0.1,0.2-0.1s-0.1,0.1-0.1,0.2s0.1,0,0.2,0s0.2-0.2,0.2-0.2 S11,14.9,11,15s0.1,0,0.2,0s0.1-0.1,0.1-0.2s0.1,0,0.1,0s0.1-0.1,0.1-0.1L11.7,14.7L11.7,14.7L11.7,14.7l0.1,0v0 C11.8,14.7,11.7,14.7,11.7,14.7 M10.3,14.7L10.3,14.7L10.3,14.7c0-0.1-0.1-0.1-0.1-0.2l-0.1-0.1L10,14.3v-0.1 l0,0H9.9l-0.1-0.3l0,0l0,0L9.7,14l-0.1-0.1v-0.2l0,0l-0.1,0.1l-0.1-0.2l0,0c0,0,0,0.1,0,0.1c0,0-0.1-0.1-0.1-0.1 c-0.1,0-0.1-0.1-0.1-0.1L9,13.3l0.1-0.1v-0.1H8.9v-0.3v-0.1l-0.1,0.2v-0.1v-0.2l0,0v0.1l-0.1-0.1 c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.2-0.1-0.2c0-0.1,0.1-0.1,0.1-0.1s-0.1,0,0,0s0.2-0.1,0.1-0.2s-0.2,0.1-0.2,0 s0.2-0.1,0.2-0.2s-0.1,0.1-0.2,0s0.1-0.1,0.1-0.2s0-0.1,0-0.1s-0.1,0.1-0.1,0.1H8.6v0.1v0.1l-0.1-0.1v0.1v0.1 H8.3L8.2,12l0.1,0.1l0.1,0.1l0,0l0.1,0.1v0.1v0.1v0.3c0,0-0.1,0-0.1,0s0.1,0.1,0.1,0.1s-0.2,0-0.2,0 c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0,0l0,0c0.1,0,0.3,0.1,0.2,0.1s-0.2-0.1-0.2,0c0,0.1,0.1,0.2,0.1,0.2 c0,0,0.2,0,0.2,0s-0.2,0-0.2,0.1s0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0L9,13.5c0.1,0.1,0.2,0.1,0.2,0.2l0,0 c0,0-0.1,0-0.1,0s0.3,0.1,0.2,0.2s-0.2-0.1-0.2,0S9.2,14,9.2,14s0.3,0,0.3,0.1s-0.3,0-0.3,0 c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.2-0.1s-0.1,0.1,0,0.1s0.1-0.1,0.2-0.1c0.1,0,0.2,0.1,0.3,0.1l0.1,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4934",
    className: "st20",
    d: "M11.5,15C11.5,15,11.5,15,11.5,15l0.2-0.1l0.2-0.1l0,0l-0.2,0.1L11.5,15 C11.5,15,11.5,15,11.5,15L11.5,15C11.4,15,11.4,15,11.5,15 M11.9,14.8C11.9,14.8,11.8,14.8,11.9,14.8 c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0.1c0,0,0,0.1-0.1,0.1c0,0,0.1,0,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1 C11.7,14.8,11.8,14.8,11.9,14.8L11.9,14.8L11.9,14.8z M9.4,13.8L9.4,13.8l-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.3 l0.1,0.1C9.2,13.7,9.3,13.7,9.4,13.8L9.4,13.8 M11.1,15c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0-0.1 l0,0l0.1,0.1h0.1h0.1l0,0l0,0c-0.1,0-0.1-0.1-0.1-0.1s0,0.1,0,0.1s-0.1-0.2-0.2-0.2s-0.1,0-0.1,0 s0.1,0.1,0.1,0.2s-0.2-0.2-0.3-0.2s-0.1,0-0.1,0.1s0.1,0,0.1,0.1s-0.1-0.1-0.2-0.1s-0.1,0-0.1,0s0,0.1,0,0.1 h-0.1l-0.1,0.1c0,0,0.1-0.1,0.1-0.1h0.3l0,0c0,0,0,0-0.1-0.1l0.1,0.1c0,0,0.1,0,0.1,0.1h0.1c0,0,0,0,0,0.1 l-0.1,0.1l0.1-0.1l0.1-0.1H11c0,0,0,0,0-0.1L11,14.5l0.1,0.1c0,0.1,0,0.1,0.1,0.1h0.1c0,0,0,0,0,0.1 C11.2,14.9,11.2,14.9,11.1,15c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.1-0.1h0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1 c0,0,0,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.1,0.1h0.1c0,0,0,0.1,0,0.1v0.1 M10.5,14.3C10.5,14.3,10.6,14.3,10.5,14.3 c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.2s-0.1,0.1-0.1,0.1s0-0.2,0-0.3s-0.1-0.1-0.1-0.1s0,0.2-0.1,0.2s0-0.2,0-0.3 s-0.1-0.1-0.1-0.1s0,0.1,0,0.1s0-0.1-0.1-0.1s0,0,0,0v-0.1c0,0,0,0.1,0,0.1v0.1c0,0,0.1,0.1,0,0.1l0,0H9.3h0.1 c0,0,0.1,0,0.1,0c0,0,0,0.1,0.1,0.1c0,0,0-0.1,0-0.1v-0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1s0.1,0.1,0,0.1 c0,0-0.1,0-0.1,0H9.3h0.1h0.2L9.7,14c0,0,0-0.1,0-0.1v-0.2c0,0.1,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0-0.1,0-0.1,0 c-0.1,0-0.1,0-0.2,0h0.2c0.1,0,0.1,0,0.1,0l0,0L9.8,14H9.7H9.6h0.1l0,0l0,0V14v-0.1c0,0,0,0.1,0,0.1V14 c0,0,0,0,0.1,0 M8.5,12.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2-0.1-0.3l0,0v-0.1H8.4H8.3l0,0h0.1l0,0V12H8.3l-0.1-0.1 L8.3,12h0.1h0.1l0.1-0.1H8.4H8.4v-0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.1l0.1,0.1l0.1,0.1h0.1l0.1-0.1l-0.1,0.1H8.4 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1s0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0.1l0,0c0.1,0,0.1-0.1,0.2-0.2 c0,0,0.1-0.1,0-0.1s-0.1,0.1-0.1,0.1s0-0.1-0.1-0.1c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.1s-0.1-0.1-0.1-0.1 c0,0-0.1,0.1-0.1,0.1c0,0,0.1,0.2,0.1,0.2s-0.1-0.1-0.2,0S8.2,12,8.3,12s0,0,0,0.1s0.1,0.1,0.1,0.1 c0.1,0.1,0.1,0.2,0.1,0.3L8.5,12.6 M9.1,13.5c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.3,0.1-0.3S9,13.1,9,13.1 s0.1-0.2,0-0.3s0-0.1-0.1-0.1s-0.1,0.2-0.1,0.2s0-0.1,0-0.2s0-0.1-0.1-0.1s-0.1,0.1-0.1,0.1s-0.1-0.1-0.1-0.1 s0.1,0.2,0.1,0.2c0,0,0,0,0-0.1v-0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1H8.5H8.4l0.1,0.1h0.1L8.8,13v0.1 c0,0,0-0.1,0-0.1L9,12.8c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.1H8.8H8.6l0.2,0.1h0.1L9,13.3v-0.1c0,0,0-0.1,0-0.1 c0,0,0,0.1,0,0.1v0.1H8.8h0.1H9v0.1L9.1,13.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4935",
    className: "st2",
    d: "M11.8,15.3C11.7,15.3,11.7,15.3,11.8,15.3l-0.1-0.1l0,0v-0.1l0.3-0.3 v-0.3h0.2V15l0,0l0.3,0.2v0.1l0,0l0,0h-0.1l-0.2-0.1L12,15.1L11.8,15.3L11.8,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4936",
    className: "st21",
    d: "M12,14.6C12,14.6,12,14.6,12,14.6c0,0.1,0,0.2,0,0.3 c0,0-0.2,0.1-0.2,0.2s-0.1,0.1-0.1,0.1h-0.1l-0.1,0.1c0-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.1 c0-0.1,0-0.2,0-0.3l0,0H12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4937",
    className: "st21",
    d: "M12.3,15.4L12.3,15.4L12.3,15.4L12.3,15.4c-0.1-0.1-0.1-0.1-0.2-0.1 c0,0-0.1-0.1-0.1-0.1L12,15.2c0,0,0,0.1,0.1,0.1l0.2,0.1L12.3,15.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4938",
    className: "st22",
    d: "M12.1,14.6L12.1,14.6L12.1,14.6c0.1,0.1,0.1,0.2,0.1,0.3 c0,0.1,0,0.1-0.1,0.1l-0.2,0.2l-0.1,0.1l0,0l0,0c0-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.2L12.1,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4939",
    className: "st22",
    d: "M12.7,15.3C12.7,15.3,12.7,15.3,12.7,15.3h-0.2c0,0-0.1-0.1-0.1-0.1 c-0.1,0-0.1,0-0.2-0.1c0,0-0.1-0.1-0.1-0.1v-0.1c0,0,0.1,0.1,0.1,0.1c0,0,0.2,0.1,0.2,0.1L12.7,15.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4940",
    className: "st23",
    d: "M13.3,14.1c0,0-0.2-0.1-0.2-0.1s0.4-0.2,0.4-0.2v-0.1 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.1,0-0.2,0l-1.4-0.1h-0.1c-0.2,0-0.3-0.3-0.3-0.3h-0.1 c0,0,0,0.1,0,0.1c-0.2-0.1-0.5-0.2-0.7-0.3v0.1c0,0,0.4,0.2,0.4,0.3s-0.1,0.1-0.1,0.1v0.1c0,0,0.6,0,0.6,0.2 s-0.1,0.1-0.1,0.1l0.1,0.1l0,0c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0.1,0.2,0.2c0.3,0.1,0.7,0.1,1,0 c0.1,0,0.2-0.2,0.4-0.2C13.1,14.1,13.2,14.1,13.3,14.1L13.3,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4941",
    className: "st24",
    d: "M13.3,14.1L13.3,14.1L13.2,14l0,0l0,0l0,0l0,0c0.1,0,0.1-0.1,0.2-0.1 h0.1l0,0v-0.1l0,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.1,0-0.2,0h-0.1h-0.8h-0.4h-0.3 c0,0-0.1,0-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1v-0.1l0,0h-0.1l0,0c0,0,0,0,0,0.1l0,0h-0.1c-0.1,0-0.3-0.1-0.4-0.2 l-0.2-0.1h-0.1l0,0v0.2l0,0l0.2,0.1c0,0,0.1,0,0.1,0.1l0,0l0,0l0,0l0,0l0,0h-0.1l0.1,0.1l0,0 c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0,0.2,0.1l0.1,0l0,0l0,0l0,0h-0.1h-0.1l0.1,0.1l0,0h0.3h0.1h0.1 c0,0,0.1,0.1,0.1,0.1l0.1,0.1h0.1c0.1,0,0.3,0,0.4,0h0.5c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.1,0.2-0.1l0.2-0.1 h0.1v-0.1l0,0v0.1l0,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.2,0.1c0,0.1-0.1,0.1-0.2,0.1h-0.1h-0.8h-0.1 l-0.1-0.1L11.4,14h-0.1H11l0,0l0,0L10.9,14l0,0c0,0,0.1,0,0.1,0H11c0,0,0,0,0,0l0,0l0,0c0,0-0.1-0.1-0.1-0.1 c-0.1,0-0.2,0-0.3-0.1h-0.2l-0.1-0.1l0,0l0,0h0.1l0,0l0,0l0,0l0,0l-0.1-0.1c-0.1-0.1-0.2-0.1-0.3-0.1l0,0v-0.1 l0,0l0.3,0.1l0.2,0.1h0.1h0.1l0,0l0,0c0,0,0-0.1,0-0.1h0.1c0,0.1,0.1,0.1,0.1,0.1l0.1,0.1c0,0,0.1,0.1,0.1,0.1 h0.1h0.8h0.4h0.2c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4-0.1h0.1l0,0l0,0l0,0v0.1l0,0L13.3,14L13.1,14l0,0l0,0l0,0 l0,0l0,0l0,0L13.3,14.1L13.3,14.1L13.3,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4942",
    className: "st2",
    d: "M10.4,13.8c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0l0,0 c0-0.1,0-0.1,0.1-0.1h0C10.3,13.7,10.4,13.8,10.4,13.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4943",
    className: "st24",
    d: "M10.4,13.8L10.4,13.8C10.4,13.9,10.3,13.9,10.4,13.8 C10.3,13.9,10.3,13.9,10.4,13.8c-0.1,0.1-0.2,0-0.2,0C10.2,13.8,10.2,13.7,10.4,13.8 C10.3,13.7,10.4,13.8,10.4,13.8L10.4,13.8c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0.1-0.1,0.1s0.1,0.1,0.1,0.1l0,0 C10.4,13.9,10.4,13.9,10.4,13.8L10.4,13.8L10.4,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4944",
    className: "st2",
    d: "M11,13.3c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.1,0-0.1-0.1v0 c0-0.1,0-0.1,0.1-0.1l0,0C11,13.2,11,13.3,11,13.3L11,13.3L11,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4945",
    className: "st24",
    d: "M11,13.3L11,13.3C11,13.4,11,13.4,11,13.3c-0.1,0.1-0.2,0-0.2,0 C10.8,13.3,10.9,13.3,11,13.3C11,13.3,11,13.3,11,13.3L11,13.3c0-0.1,0-0.1-0.1-0.1c0,0,0,0,0,0 c-0.1,0-0.1,0.1-0.1,0.1l0,0c0,0.1,0.1,0.1,0.1,0.1l0,0l0,0C10.9,13.5,11,13.4,11,13.3C11,13.3,11,13.3,11,13.3 L11,13.3L11,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4946",
    className: "st2",
    d: "M13.5,14.1c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.1,0-0.1-0.1 c0-0.1,0.1-0.1,0.1-0.1l0,0C13.4,14,13.5,14.1,13.5,14.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4947",
    className: "st24",
    d: "M13.5,14.1L13.5,14.1C13.5,14.1,13.5,14.2,13.5,14.1 C13.4,14.2,13.4,14.2,13.5,14.1c-0.1,0.1-0.2,0-0.2,0C13.3,14.1,13.4,14,13.5,14.1C13.4,14,13.5,14.1,13.5,14.1 L13.5,14.1c0.1-0.1,0-0.1-0.1-0.1s-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0,0l0,0 C13.5,14.3,13.5,14.2,13.5,14.1C13.5,14.1,13.5,14.1,13.5,14.1L13.5,14.1L13.5,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4948",
    className: "st11",
    d: "M9.8,13.2c0,0.1,0.1,0.2,0.2,0.2s0.1,0,0.2-0.1c0,0,0-0.1,0-0.1 C10.1,13.2,9.8,13.1,9.8,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4949",
    className: "st2",
    d: "M10.1,13.3c0-0.1-0.1-0.1-0.1-0.1s-0.1,0-0.1,0S10,13.3,10.1,13.3 C10,13.3,10,13.3,10.1,13.3C10,13.3,10,13.3,10.1,13.3C10.1,13.3,10.1,13.3,10.1,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4950",
    className: "st11",
    d: "M10.9,14.2c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.2,0-0.2,0 c0-0.1,0.1-0.1,0.1-0.2S10.9,14.2,10.9,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4951",
    className: "st2",
    d: "M10.8,14.2C10.8,14.2,10.8,14.2,10.8,14.2C10.8,14.2,10.8,14.2,10.8,14.2 C10.8,14.1,10.8,14.1,10.8,14.2c0-0.1-0.2,0-0.2,0.1s0,0,0.1,0L10.8,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4952",
    className: "st11",
    d: "M13.5,13.8c0.1,0.1,0.2,0,0.2,0s0.1-0.1,0.1-0.1c0,0-0.1,0-0.1,0 C13.6,13.7,13.5,13.7,13.5,13.8C13.5,13.8,13.5,13.9,13.5,13.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4953",
    className: "st2",
    d: "M13.5,13.8c0,0,0-0.1,0.1-0.1c0.1,0,0.1,0,0.1,0s0,0,0,0 c0,0,0,0.1-0.1,0.1h0l0,0C13.6,13.7,13.6,13.7,13.5,13.8C13.5,13.7,13.5,13.8,13.5,13.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4954",
    className: "st25",
    d: "M12.1,13.6L12.1,13.6h-0.3l0.2,0.5l0.2,0.3h0.1h0.2v-0.1l-0.1-0.5 L12.1,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4955",
    className: "st26",
    d: "M12.1,13.6L12.1,13.6L12.1,13.6h-0.3l0.2,0.5l0,0l0.2,0.3l0,0h0.1h0.2 v-0.1l0,0l-0.1-0.5l0,0L12.1,13.6L12.1,13.6l0.2,0.2l0.1,0.5v0.1h-0.1h-0.1L12,14.1l-0.2-0.5L12.1,13.6 L12.1,13.6L12.1,13.6L12.1,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4956",
    className: "st25",
    d: "M11.6,13.6L11.6,13.6l0.2-0.1c0.1,0.1,0.1,0.1,0.2,0.2 c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.2,0.2,0.2,0.2H12h-0.1L11.6,14L11.6,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4957",
    className: "st26",
    d: "M11.6,13.6L11.6,13.6L11.6,13.6l0.2-0.1c0.1,0.1,0.1,0.1,0.1,0.2 c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0.1,0.2c0,0.1,0.2,0.2,0.2,0.2H12h-0.1L11.6,14L11.6,13.6L11.6,13.6l0.1,0.3 l0,0l0.3,0.4l0,0H12h0.2l0,0l-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.1-0.1v-0.1l0,0 h-0.2v0.1L11.6,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4958",
    className: "st25",
    d: "M11.4,13.6h0.1c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.3 c0,0.1,0.1,0.2,0.2,0.2h-0.3c-0.1,0-0.1,0-0.2-0.1l-0.1-0.1h-0.1v-0.1v-0.3v-0.2L11.4,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4959",
    className: "st26",
    d: "M11.4,13.6L11.4,13.6h0.1c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0,0.1,0,0.1 c0,0.1,0,0.1,0.1,0.1c0,0.1,0.1,0.2,0.2,0.2h-0.3h-0.1l0,0l0,0h-0.1l0,0h-0.1v-0.1l0,0v-0.3v-0.2h0.1l0,0h-0.1 l0,0v0.2l0,0v0.3v0.1h0.1l0.1,0.1l0,0h0.2H12c-0.1-0.1-0.1-0.2-0.1-0.2c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1 c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.2L11.4,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4960",
    className: "st25",
    d: "M12.6,13.7l-0.2-0.1h-0.4c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.3,0.1,0.4 c0,0.1,0.1,0.2,0.1,0.2l0.2-0.1h0.1v-0.1l0,0v-0.4L12.6,13.7L12.6,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4961",
    className: "st26",
    d: "M12.6,13.7L12.6,13.7l-0.2-0.1h-0.4c0,0,0,0.1,0,0.2 c0,0.1,0.1,0.3,0.1,0.4c0,0,0.1,0.1,0.1,0.1v0.1l0,0h0.1l0.1-0.1l0,0h0.1l0,0v-0.1l0,0l0,0v-0.4l0,0L12.6,13.7 L12.6,13.7L12.6,13.7L12.6,13.7L12.6,13.7l0,0.5l0,0l0,0v0.1h-0.1l0,0h-0.1h-0.1l0,0l0,0l-0.1-0.2 c-0.1-0.1-0.1-0.2-0.1-0.4c0,0,0-0.1,0-0.1v-0.1l0,0h0.4L12.6,13.7L12.6,13.7L12.6,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4962",
    className: "st25",
    d: "M11.4,13.7C11.4,13.7,11.4,13.7,11.4,13.7 C11.5,13.7,11.5,13.7,11.4,13.7c0.1-0.1,0-0.1,0-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0.1,0.1,0.1,0.1 c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0.1,0.2c0,0-0.1,0.1-0.1,0.1c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1 c0,0,0-0.1-0.1-0.1h-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4963",
    className: "st26",
    d: "M11.4,13.7L11.4,13.7L11.4,13.7L11.4,13.7L11.4,13.7 C11.4,13.6,11.4,13.6,11.4,13.7c0-0.1,0-0.1,0-0.1c0,0-0.1,0-0.1,0l0,0c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1l0,0l0,0l0,0c0,0,0,0.1,0,0.1l0,0c0,0,0,0.1,0,0.1l0,0l0,0V14c0,0,0,0.1-0.1,0.1 c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l0,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1h-0.1l0,0l0,0l0,0l0,0l0,0 h0.1l0,0l0,0l0,0h0c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1l0,0l0,0c0,0-0.1-0.1-0.1-0.2l0,0 c0,0,0-0.1,0-0.1l0,0l0,0l0,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0l0,0c0,0,0,0,0.1,0 C11.4,13.5,11.4,13.6,11.4,13.7L11.4,13.7L11.4,13.7L11.4,13.7L11.4,13.7L11.4,13.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4964",
    className: "st25",
    d: "M12.7,13.7L12.7,13.7C12.6,13.7,12.6,13.7,12.7,13.7 C12.6,13.7,12.7,13.6,12.7,13.7c0.1-0.1,0.2,0,0.2,0c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.2 c0.1,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.1c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1-0.1s0-0.1,0.1-0.1s0.1,0,0.1,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4965",
    className: "st26",
    d: "M12.7,13.7L12.7,13.7L12.7,13.7 M12.6,13.6L12.6,13.6L12.6,13.6 L12.6,13.6c0.1,0.1,0.1,0.1,0.1,0.1s0,0.1,0,0.1l0,0 M12.7,13.8L12.7,13.8c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1l0,0 l0,0l0,0l0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0h-0.1l0,0l0,0c0,0,0,0,0-0.1l0,0l0,0l0,0l0,0 c0,0,0,0,0-0.1h-0.1c0,0,0,0-0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1h0.1h0.1c0,0,0.1,0,0.1,0 c0.1-0.1,0.1-0.2,0-0.2c0,0,0,0,0,0l0,0l0,0l0,0C12.8,14,12.8,13.9,12.7,13.8C12.8,13.8,12.8,13.8,12.7,13.8 L12.7,13.8L12.7,13.8L12.7,13.8c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0l0,0c0,0-0.1,0-0.1,0l0,0 l0,0 M12.7,13.6L12.7,13.6L12.7,13.6L12.7,13.6L12.7,13.6L12.7,13.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4966",
    className: "st26",
    d: "M11.5,14.2L11.5,14.2C11.5,14.2,11.5,14.3,11.5,14.2 c0.2,0.1,0.3,0.1,0.5,0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.1-0.1,0.1-0.1l0,0l0,0v0.1l0,0l0,0c0,0-0.1,0-0.1,0h-0.8 C11.6,14.2,11.6,14.2,11.5,14.2L11.5,14.2L11.5,14.2L11.5,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4967",
    className: "st26",
    d: "M12.5,13.6L12.5,13.6c0.1,0,0,0,0,0.1s0,0.1,0,0.1h-0.3l-0.1-0.1 L12.5,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4968",
    className: "st27",
    d: "M13.4,13.6C13.3,13.6,13.3,13.6,13.4,13.6c-0.1-0.1-0.1-0.1-0.1-0.2 s0.1,0,0,0.1L13.4,13.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4969",
    className: "st27",
    d: "M13.9,13.5L13.9,13.5L13.9,13.5C13.9,13.5,13.9,13.5,13.9,13.5 L13.9,13.5L13.9,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4970",
    className: "st27",
    d: "M14.1,13.5C14,13.5,14,13.5,14.1,13.5c-0.1,0-0.2,0-0.1-0.1 S13.9,13.4,14.1,13.5L14.1,13.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4972",
    className: "st27",
    d: "M13.9,12.8C13.9,12.8,13.9,12.8,13.9,12.8l-0.1,0.1 C13.8,12.9,13.8,12.8,13.9,12.8L13.9,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4973",
    className: "st27",
    d: "M13.6,12.9C13.6,12.9,13.6,12.9,13.6,12.9L13.6,13 C13.6,13,13.6,13,13.6,12.9C13.6,12.9,13.6,12.9,13.6,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4974",
    className: "st28",
    d: "M13.2,13.2L13,13.4c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2 c0-0.1,0-0.2,0-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2-0.2,0.2L13.2,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4975",
    className: "st29",
    d: "M13.2,13.2L13.2,13.2L13,13.4l0,0l0.2,0.1c0.1,0,0.3,0.1,0.4,0.1l0,0 c0.1,0,0.3-0.1,0.4-0.1l0.1-0.1l0,0l0,0l0,0l0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0 c0,0-0.1-0.1-0.1-0.1h-0.1h-0.1c-0.1,0-0.1,0-0.1,0.1l-0.2,0.1l-0.1,0.1l0,0h-0.1c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1-0.1l0.1-0.1l0.2-0.1c0,0,0.1-0.1,0.1-0.1l0,0h0.1l0.1,0.1l0,0l0,0c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1l0,0l0,0l-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1l0,0c-0.1,0-0.3,0-0.4-0.1L13,13.4l0,0l0,0L13.2,13.2 L13.2,13.2L13.2,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4976",
    className: "st30",
    d: "M13.1,13.3c0,0,0.4,0.1,0.4,0s0.2-0.3,0.3-0.3H14l0.1,0.1l0.1,0.1v0.2 v0.1L14,13.4l-0.2,0.1l-0.2,0.1h-0.2l-0.3-0.1l-0.1-0.1l0,0L13.1,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4977",
    className: "st29",
    d: "M13.7,13.1L13.7,13.1L13.7,13.1C13.8,13.1,13.8,13.1,13.7,13.1 C13.6,13.1,13.7,13.1,13.7,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4978",
    className: "st29",
    d: "M13.8,13.2C13.8,13.2,13.8,13.2,13.8,13.2c0.1,0,0.1,0,0.1,0.1v0 c0,0,0,0.1-0.1,0.1C13.9,13.3,13.8,13.2,13.8,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4979",
    className: "st29",
    d: "M13.8,13.4C13.8,13.4,13.8,13.4,13.8,13.4 M13.9,13.4 C13.9,13.4,13.9,13.5,13.9,13.4L13.9,13.4c-0.1,0.1-0.1,0.1-0.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4980",
    className: "st29",
    d: "M13.6,13.3C13.6,13.3,13.6,13.3,13.6,13.3c0.1,0,0.1,0,0.1,0l0,0 C13.7,13.4,13.7,13.4,13.6,13.3L13.6,13.3C13.6,13.4,13.6,13.3,13.6,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4981",
    className: "st29",
    d: "M13.3,13.3C13.3,13.3,13.3,13.3,13.3,13.3L13.3,13.3 c0.1-0.1,0.1,0,0.1,0C13.4,13.4,13.4,13.4,13.3,13.3L13.3,13.3C13.3,13.4,13.3,13.4,13.3,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4983",
    className: "st28",
    d: "M13.8,13.4C13.8,13.4,13.8,13.4,13.8,13.4c0.1,0,0.1,0,0.1,0 C13.9,13.4,13.9,13.4,13.8,13.4L13.8,13.4C13.8,13.4,13.8,13.4,13.8,13.4L13.8,13.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4984",
    className: "st28",
    d: "M13.6,13.3C13.6,13.3,13.6,13.3,13.6,13.3 C13.7,13.3,13.7,13.3,13.6,13.3c0.1,0.1,0.1,0.1,0.1,0.1C13.6,13.4,13.6,13.4,13.6,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4986",
    className: "st28",
    d: "M13.3,13.3C13.3,13.3,13.3,13.3,13.3,13.3c0.1-0.1,0.1-0.1,0.1,0 C13.4,13.4,13.4,13.4,13.3,13.3C13.4,13.4,13.3,13.4,13.3,13.3L13.3,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4987",
    className: "st27",
    d: "M13.4,13.3C13.4,13.3,13.4,13.3,13.4,13.3 C13.4,13.3,13.4,13.3,13.4,13.3C13.4,13.4,13.4,13.3,13.4,13.3L13.4,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4988",
    className: "st27",
    d: "M13.7,13.2C13.6,13.2,13.6,13.3,13.7,13.2l-0.1,0.1 C13.6,13.3,13.6,13.3,13.7,13.2C13.6,13.3,13.6,13.2,13.7,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4993",
    className: "st29",
    d: "M14.2,13.2c0,0.1,0,0.1-0.1,0.1c-0.2,0.1-0.3,0.2-0.5,0.2 c-0.2,0-0.3-0.1-0.5-0.1l0,0h0.1l0.2,0.1l0.2,0.1h0.2l0.2-0.1l0.2-0.1L14.2,13.2L14.2,13.2L14.2,13.2L14.2,13.2z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4994",
    className: "st27",
    d: "M9.8,11.9C9.8,11.9,9.8,11.9,9.8,11.9C9.8,12.1,9.8,12.1,9.8,11.9 C9.8,12,9.8,12,9.8,11.9L9.8,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4996",
    className: "st27",
    d: "M9.3,12.3C9.3,12.3,9.4,12.3,9.3,12.3L9.3,12.3L9.3,12.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4997",
    className: "st27",
    d: "M9.5,12.6L9.5,12.6c0.1,0.1,0.1,0.1,0.1,0.1C9.6,12.7,9.6,12.7,9.5,12.6 C9.5,12.7,9.5,12.7,9.5,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4998",
    className: "st27",
    d: "M9.8,12.8C9.8,12.8,9.8,12.8,9.8,12.8 M9.8,12.8L9.8,12.8 C9.8,12.8,9.8,12.8,9.8,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4999",
    className: "st28",
    d: "M10.2,12.7c0-0.2-0.1-0.4-0.2-0.5c-0.2-0.2-0.4-0.2-0.5-0.1 c-0.1,0.2-0.1,0.4,0.1,0.5l0,0C9.7,12.7,9.9,12.8,10.2,12.7L10.2,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5000",
    className: "st29",
    d: "M10.2,12.7L10.2,12.7L10.2,12.7c0-0.2-0.1-0.4-0.2-0.5 C9.9,12.1,9.8,12,9.6,12c-0.1,0-0.1,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.2,0.4 c0.1,0.1,0.3,0.2,0.5,0.2h0.1V12.7L10.2,12.7v0.1l0,0l0,0h-0.1c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.2-0.2-0.3 c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.2,0.1,0.3,0.1C10.1,12.3,10.2,12.4,10.2,12.7L10.2,12.7 L10.2,12.7L10.2,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5001",
    className: "st30",
    d: "M9.4,12.3c0,0,0-0.2,0.1-0.2c0.2-0.1,0.4,0,0.5,0.1l0,0 c0.1,0.1,0.1,0.3,0.1,0.5H9.9l-0.2-0.1l-0.2-0.1L9.4,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5002",
    className: "st29",
    d: "M10.1,12.7c0,0-0.1,0-0.1,0c-0.3,0-0.5-0.2-0.6-0.5v0.1v0.1l0.1,0.1 l0.1,0.1l0.1,0.1h0.1H10H10L10.1,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5003",
    className: "st29",
    d: "M9.9,12.6L9.9,12.6L9.9,12.6L9.9,12.6C9.9,12.7,9.9,12.7,9.9,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5004",
    className: "st29",
    d: "M9.9,12.4C9.9,12.4,9.9,12.4,9.9,12.4L9.9,12.4L9.9,12.4L9.9,12.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5005",
    className: "st29",
    d: "M9.8,12.6C9.8,12.6,9.8,12.6,9.8,12.6c0.1-0.1,0.1,0,0.1,0 C9.9,12.6,9.9,12.6,9.8,12.6C9.7,12.6,9.8,12.6,9.8,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5006",
    className: "st29",
    d: "M9.7,12.4L9.7,12.4L9.7,12.4C9.8,12.4,9.8,12.5,9.7,12.4 C9.7,12.5,9.7,12.4,9.7,12.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5007",
    className: "st29",
    d: "M9.6,12.4L9.6,12.4C9.6,12.4,9.6,12.4,9.6,12.4 C9.6,12.5,9.6,12.5,9.6,12.4L9.6,12.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5008",
    className: "st29",
    d: "M9.6,12.2C9.6,12.2,9.6,12.2,9.6,12.2c0.1,0,0.1,0,0.1,0 S9.7,12.3,9.6,12.2C9.6,12.3,9.6,12.2,9.6,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5009",
    className: "st29",
    d: "M9.8,12.2C9.8,12.2,9.8,12.2,9.8,12.2 M9.9,12.3L9.9,12.3 C9.9,12.3,9.9,12.3,9.9,12.3C9.8,12.3,9.8,12.3,9.9,12.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5011",
    className: "st28",
    d: "M9.6,12.4L9.6,12.4L9.6,12.4 M9.6,12.5L9.6,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5013",
    className: "st28",
    d: "M9.7,12.5L9.7,12.5C9.8,12.5,9.8,12.4,9.7,12.5c0.1-0.1,0-0.1,0-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5015",
    className: "st28",
    d: "M9.8,12.6C9.8,12.6,9.8,12.7,9.8,12.6C9.8,12.7,9.8,12.7,9.8,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5018",
    className: "st27",
    d: "M9.8,12.1C9.8,12.1,9.8,12.2,9.8,12.1v0.1l0,0 C9.8,12.2,9.8,12.2,9.8,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5019",
    className: "st27",
    d: "M9.6,12.1C9.6,12.2,9.6,12.2,9.6,12.1L9.6,12.1L9.6,12.1 C9.6,12.2,9.6,12.2,9.6,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5020",
    className: "st27",
    d: "M9.6,12.2L9.6,12.2L9.6,12.2L9.6,12.2C9.6,12.2,9.6,12.1,9.6,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5023",
    className: "st27",
    d: "M10,12.5C10,12.5,10,12.5,10,12.5L10,12.5L10,12.5 C10,12.5,10,12.5,10,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5026",
    className: "st29",
    d: "M9.6,12c0,0-0.2,0-0.2,0.1c0,0.1,0,0.1,0,0.2v-0.1v-0.1l0.1-0.1L9.6,12 L9.6,12L9.6,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5027",
    className: "st29",
    d: "M10.1,12.6c0,0,0,0,0-0.2c0-0.1-0.1-0.2-0.1-0.3l0.1,0.1l0.1,0.1v0.1 L10.1,12.6L10.1,12.6L10.1,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5028",
    className: "st27",
    d: "M10.3,12.4C10.3,12.4,10.4,12.4,10.3,12.4 C10.4,12.5,10.4,12.5,10.3,12.4C10.4,12.5,10.3,12.5,10.3,12.4C10.3,12.5,10.3,12.5,10.3,12.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5029",
    className: "st27",
    d: "M10.1,13.1C10.1,13.1,10.1,13,10.1,13.1c0.1-0.1,0.1-0.1,0.1-0.1 S10.2,13,10.1,13.1L10.1,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5030",
    className: "st27",
    d: "M10.5,13.2L10.5,13.2c0.1-0.1,0.1-0.1,0.1-0.1s0,0-0.1,0L10.5,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5031",
    className: "st27",
    d: "M10.4,13.2L10.4,13.2L10.4,13.2L10.4,13.2L10.4,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5032",
    className: "st28",
    d: "M11.1,12.9c-0.2-0.2-0.4-0.3-0.6-0.4c-0.2,0-0.4,0.1-0.4,0.3l0,0l0,0 c0,0.1,0.1,0.2,0.6,0.3S11.1,12.9,11.1,12.9C11.1,12.9,11.1,12.8,11.1,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5033",
    className: "st29",
    d: "M11.1,12.9L11.1,12.9c0-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.3-0.2-0.5-0.2 l0,0c-0.2,0-0.3,0.1-0.4,0.2c0,0,0,0.1,0,0.1l0,0c0,0.1,0.1,0.3,0.6,0.3h0.1c0.1,0,0.2-0.1,0.3-0.1L11.1,12.9 L11.1,12.9L11.1,12.9L11.1,12.9L11.1,12.9L11.1,12.9L11.1,12.9L11.1,12.9L11.1,12.9C11.1,13,11,13,11,13 c-0.1,0.1-0.2,0.1-0.3,0.1h-0.1c-0.4,0-0.5-0.2-0.5-0.3l0,0c0,0,0-0.1,0-0.1c0.1-0.1,0.2-0.2,0.3-0.2l0,0 c0.2,0,0.3,0.1,0.5,0.2c0,0,0.1,0.1,0.1,0.1l0,0l0,0L11.1,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5034",
    className: "st30",
    d: "M10.8,12.6l0.1,0.1c0,0.1,0,0.1,0,0.1c-0.1-0.1-0.3-0.2-0.4-0.2 c-0.2,0-0.3,0-0.4,0.1c0,0.1,0,0.2,0.1,0.3c0.2,0.1,0.3,0.1,0.5,0.1h0.2L11,13l0,0v-0.1l0,0l-0.1-0.1L10.8,12.6z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5035",
    className: "st29",
    d: "M10.5,12.7C10.5,12.7,10.5,12.7,10.5,12.7 C10.4,12.7,10.4,12.7,10.5,12.7L10.5,12.7L10.5,12.7C10.5,12.7,10.5,12.7,10.5,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5036",
    className: "st29",
    d: "M10.3,12.8C10.3,12.8,10.3,12.8,10.3,12.8L10.3,12.8 C10.3,12.8,10.3,12.8,10.3,12.8C10.3,12.8,10.3,12.8,10.3,12.8C10.2,12.8,10.2,12.8,10.3,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5037",
    className: "st29",
    d: "M10.5,12.9C10.5,12.9,10.5,12.8,10.5,12.9L10.5,12.9 c0.1-0.1,0.1,0,0.1,0v0C10.6,12.9,10.6,12.9,10.5,12.9C10.5,12.9,10.6,12.9,10.5,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5038",
    className: "st28",
    d: "M10.3,12.9C10.3,12.9,10.3,12.9,10.3,12.9c0.1,0,0.1,0,0.1,0.1 s0,0.1-0.1,0.1C10.4,13,10.3,13,10.3,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5039",
    className: "st29",
    d: "M10.7,13L10.7,13L10.7,13L10.7,13C10.7,13,10.7,13,10.7,13L10.7,13 L10.7,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5040",
    className: "st29",
    d: "M10.8,12.9L10.8,12.9L10.8,12.9C10.9,12.9,10.9,12.9,10.8,12.9 S10.8,12.9,10.8,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5044",
    className: "st28",
    d: "M10.6,12.9C10.6,12.9,10.6,12.9,10.6,12.9 C10.5,12.9,10.6,12.9,10.6,12.9L10.6,12.9L10.6,12.9C10.6,12.9,10.6,12.9,10.6,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5045",
    className: "st28",
    d: "M10.9,12.9C10.9,12.9,10.9,12.9,10.9,12.9L10.9,12.9 C10.8,12.9,10.8,12.9,10.9,12.9C11,12.9,10.9,12.9,10.9,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5049",
    className: "st27",
    d: "M10.5,12.8C10.5,12.8,10.5,12.8,10.5,12.8L10.5,12.8L10.5,12.8 L10.5,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5051",
    className: "st27",
    d: "M10.3,12.9L10.3,12.9L10.3,12.9C10.4,12.9,10.4,12.9,10.3,12.9 L10.3,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5054",
    className: "st27",
    d: "M10.4,12.6C10.4,12.6,10.4,12.6,10.4,12.6 C10.5,12.6,10.4,12.6,10.4,12.6L10.4,12.6C10.4,12.6,10.4,12.5,10.4,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5055",
    className: "st29",
    d: "M11.1,13c-0.1,0.1-0.3,0.1-0.4,0.1c-0.2,0-0.4-0.1-0.6-0.2v0.1l0.1,0.1 l0.2,0.1l0.2,0.1h0.2h0.2L11.1,13L11.1,13L11.1,13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5056",
    className: "st29",
    d: "M11.1,12.9L11,12.7c-0.1-0.1-0.2-0.1-0.3-0.2l0.2,0.1l0.1,0.1L11.1,12.9 L11.1,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5057",
    className: "st27",
    d: "M11.1,12.6L11.1,12.6L11.1,12.6C11.2,12.6,11.2,12.7,11.1,12.6 L11.1,12.6C11.2,12.6,11.2,12.6,11.1,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5058",
    className: "st27",
    d: "M11.3,12.5C11.3,12.5,11.4,12.6,11.3,12.5l0.1,0.1 C11.4,12.6,11.3,12.6,11.3,12.5L11.3,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5059",
    className: "st27",
    d: "M11.4,12.5L11.4,12.5L11.4,12.5C11.4,12.6,11.4,12.6,11.4,12.5 C11.4,12.5,11.4,12.5,11.4,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5060",
    className: "st27",
    d: "M11.7,12.6C11.7,12.6,11.8,12.6,11.7,12.6c0.1,0.1,0.1,0.1,0.1,0.1l0,0 l0,0C11.8,12.7,11.8,12.7,11.7,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5063",
    className: "st27",
    d: "M11.5,13.4C11.5,13.4,11.6,13.4,11.5,13.4 C11.6,13.4,11.6,13.4,11.5,13.4L11.5,13.4L11.5,13.4C11.6,13.4,11.6,13.4,11.5,13.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5064",
    className: "st27",
    d: "M11.8,13.4L11.8,13.4C11.9,13.4,11.9,13.4,11.8,13.4 C11.9,13.3,11.9,13.4,11.8,13.4L11.8,13.4C11.9,13.4,11.9,13.4,11.8,13.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5065",
    className: "st27",
    d: "M11.9,13.4C11.9,13.4,11.9,13.4,11.9,13.4v-0.1 C11.9,13.3,11.9,13.4,11.9,13.4L11.9,13.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5066",
    className: "st28",
    d: "M11,13c0-0.1,0.2-0.4,0.4-0.4c0.1,0,0.3,0,0.4,0.1 c0.1,0,0.1,0.1,0.2,0.1h0.2h0.2l-0.2,0.3l-0.1,0.1c-0.1,0.1-0.1,0.2-0.2,0.2c-0.2,0.1-0.4,0.1-0.6,0 C11.1,13.3,11,13.2,11,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5067",
    className: "st29",
    d: "M11,13L11,13c0,0,0-0.1,0-0.1c0-0.1,0.1-0.1,0.1-0.2 c0.1-0.1,0.1-0.1,0.2-0.1l0,0c0.1,0,0.1,0,0.2,0l0.2,0.1l0.1,0.1h0.1h0.2h0.2L12.2,13l-0.1,0.1l0,0 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1-0.1-0.2-0.1C11,13.1,11,13,11,13 L11,13c0,0,0,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.3,0,0.4,0.1c0.1,0,0.2,0,0.2,0c0.1,0,0.2-0.1,0.2-0.2 l0,0l0.1-0.1l0.2-0.3h-0.3H12h-0.1c0,0-0.1-0.1-0.1-0.1l-0.2-0.1c-0.1,0-0.1,0-0.2,0l0,0c-0.1,0-0.1,0-0.1,0.1 c-0.1,0-0.1,0.1-0.2,0.2C11,12.9,11,12.9,11,13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5068",
    className: "st30",
    d: "M12.2,13C12.2,13,12.2,13,12.2,13c-0.3-0.1-0.6-0.2-0.8-0.3 c-0.2,0-0.3,0.1-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.3,0.1,0.4,0.1h0.2h0.2l0.1-0.1l0.1-0.1L12.2,13L12.2,13z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5069",
    className: "st29",
    d: "M11.4,13L11.4,13L11.4,13C11.3,13.1,11.3,13,11.4,13 C11.4,13,11.3,13,11.4,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5070",
    className: "st29",
    d: "M11.4,12.8C11.4,12.8,11.4,12.8,11.4,12.8c0.1,0,0.1,0,0.1,0l0,0l0,0 C11.5,12.8,11.5,12.8,11.4,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5071",
    className: "st29",
    d: "M11.8,12.9C11.8,12.9,11.8,12.8,11.8,12.9L11.8,12.9 C11.8,12.9,11.8,12.9,11.8,12.9L11.8,12.9L11.8,12.9C11.8,12.9,11.8,12.9,11.8,12.9L11.8,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5072",
    className: "st29",
    d: "M11.8,13.1L11.8,13.1L11.8,13.1L11.8,13.1L11.8,13.1L11.8,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5073",
    className: "st29",
    d: "M11.7,13.2L11.7,13.2L11.7,13.2L11.7,13.2 C11.7,13.2,11.7,13.2,11.7,13.2L11.7,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5074",
    className: "st29",
    d: "M11.4,13.2L11.4,13.2L11.4,13.2C11.4,13.1,11.4,13.1,11.4,13.2 C11.4,13.2,11.4,13.2,11.4,13.2L11.4,13.2L11.4,13.2 M11.3,13.2L11.3,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5075",
    className: "st28",
    d: "M11.4,13C11.4,13,11.4,13,11.4,13L11.4,13C11.3,13,11.3,13,11.4,13 S11.4,13,11.4,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5076",
    className: "st28",
    d: "M11.5,12.8L11.5,12.8C11.5,12.8,11.5,12.8,11.5,12.8 C11.5,12.8,11.5,12.8,11.5,12.8L11.5,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5077",
    className: "st28",
    d: "M11.9,12.9C11.9,12.9,11.9,12.9,11.9,12.9L11.9,12.9 C11.8,12.9,11.8,12.9,11.9,12.9L11.9,12.9C11.8,12.9,11.8,12.9,11.9,12.9L11.9,12.9L11.9,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5078",
    className: "st29",
    d: "M11.7,13L11.7,13C11.7,13.1,11.6,13.1,11.7,13C11.6,13,11.6,13,11.7,13 L11.7,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5079",
    className: "st28",
    d: "M11.4,13.2C11.5,13.2,11.5,13.2,11.4,13.2L11.4,13.2 C11.4,13.2,11.4,13.2,11.4,13.2L11.4,13.2L11.4,13.2C11.4,13.2,11.4,13.2,11.4,13.2L11.4,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5080",
    className: "st28",
    d: "M11.6,13L11.6,13C11.6,13,11.6,13,11.6,13c-0.1-0.1,0-0.1,0-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5081",
    className: "st28",
    d: "M11.9,13.1C11.9,13.1,11.9,13.1,11.9,13.1L11.9,13.1 M11.9,13.1 L11.9,13.1L11.9,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5082",
    className: "st28",
    d: "M11.8,13.2L11.8,13.2L11.8,13.2C11.7,13.2,11.7,13.2,11.8,13.2 C11.7,13.2,11.7,13.2,11.8,13.2S11.8,13.2,11.8,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5084",
    className: "st27",
    d: "M11.7,12.8L11.7,12.8l0.1,0.1l0,0L11.7,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5085",
    className: "st27",
    d: "M11.5,12.9C11.5,12.9,11.6,13,11.5,12.9L11.5,12.9L11.5,12.9L11.5,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5087",
    className: "st27",
    d: "M11.4,12.7h0.1c0,0,0,0,0,0.1l0,0C11.5,12.8,11.5,12.8,11.4,12.7 L11.4,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5088",
    className: "st27",
    d: "M11.2,12.9l0.1,0.1l0,0L11.2,12.9C11.2,12.9,11.2,12.9,11.2,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5092",
    className: "st29",
    d: "M12.2,13.1c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0.1-0.2,0.1-0.4,0.1 c-0.1,0-0.2,0-0.4-0.1c-0.1,0-0.2-0.1-0.2-0.2v0.1l0.1,0.1l0.1,0.1h0.2h0.2h0.1h0.1H12H12l0,0L12.2,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5093",
    className: "st29",
    d: "M12,12.8c0,0,0,0-0.1,0c-0.1-0.1-0.3-0.1-0.4-0.1 c-0.1,0-0.2,0.1-0.3,0.2l0.1-0.1h0.1h0.1h0.1h0.1h0.1h0.1h0.1L12,12.8L12,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5094",
    className: "st29",
    d: "M12.3,12.9h-0.2c0,0,0,0-0.1,0l0,0v-0.1L12.3,12.9L12.3,12.9L12.3,12.9z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5095",
    className: "st30",
    d: "M12.1,13.8C12.1,13.8,12.1,13.8,12.1,13.8h0.1h0.2l0.1-0.1v-0.1v-0.1 l0.2-0.1h0.1h0.1H13l0.1-0.1v-0.1v-0.1v-0.1L13,13l-0.2-0.1h-0.1L12.5,13L12.2,13c-0.1,0-0.2,0.1-0.2,0.2 c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.4,0,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5096",
    className: "st29",
    d: "M12.1,13.8L12.1,13.8L12.1,13.8h0.3l0.1-0.1v-0.2l0,0l0,0l0,0l0,0 l0.1-0.1h0.1l0,0h0.1h0.1H13l0.1-0.1l0.1-0.1v-0.1v-0.1L13,13L12.8,13h-0.1L12.5,13l-0.3,0.1l0,0h-0.1 c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2C12,13.6,12,13.7,12.1,13.8L12.1,13.8L12.1,13.8 L12,13.5c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.1h0.1l0,0l0,0l0.3-0.1h0.2h0.1l0.2,0.1 l0.1,0.1v0.1v0.1v0.1L13,13.5h-0.1h-0.1h-0.1l0,0h-0.1h-0.1l0,0l0,0l0,0l0,0v0.2l-0.1,0.1L12.1,13.8L12.1,13.8 L12.1,13.8L12.1,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5097",
    className: "st28",
    d: "M12.1,13.7c0,0,0-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.2l0,0c0,0,0,0,0.1,0 c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1h0.1l0,0c0,0,0.1,0,0.1,0l0,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0l0,0l0,0 c0,0,0,0.1,0.1,0.1H13l0,0l0,0l0,0c0,0,0.1,0.1,0.1,0.1c0,0,0-0.1,0-0.1L13,13h-0.1h-0.2l-0.2,0.1l-0.2,0.1 c0,0,0,0.1,0,0.1s-0.1-0.1-0.1-0.1l-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.1,0.1,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5101",
    className: "st28",
    d: "M12.2,13.4C12.2,13.4,12.2,13.4,12.2,13.4c0.1,0,0.1,0,0.1,0l0,0H12.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5102",
    className: "st29",
    d: "M12.4,13.6L12.4,13.6L12.4,13.6L12.4,13.6 C12.3,13.6,12.4,13.6,12.4,13.6C12.4,13.6,12.4,13.6,12.4,13.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5103",
    className: "st29",
    d: "M13.1,13.2C13.1,13.2,13.1,13.2,13.1,13.2L13.1,13.2L13.1,13.2 C13,13.2,13,13.2,13.1,13.2C13,13.1,13,13.2,13.1,13.2C13.1,13.2,13.1,13.2,13.1,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5104",
    className: "st29",
    d: "M12.5,13.3C12.5,13.3,12.5,13.4,12.5,13.3L12.5,13.3L12.5,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5105",
    className: "st29",
    d: "M12.6,13.3C12.6,13.3,12.6,13.3,12.6,13.3 C12.6,13.4,12.6,13.3,12.6,13.3L12.6,13.3L12.6,13.3L12.6,13.3L12.6,13.3L12.6,13.3L12.6,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5106",
    className: "st29",
    d: "M12.8,13.1C12.8,13.1,12.8,13.1,12.8,13.1L12.8,13.1L12.8,13.1 L12.8,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5107",
    className: "st29",
    d: "M12.1,13.8c0,0,0.3,0,0.3,0s0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.4-0.1 c0.1,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.1-0.2-0.2S12.9,13,12.9,13c-0.1,0-0.2,0-0.2,0.1c0,0,0,0.1-0.1,0.1 s-0.2,0-0.2,0s0,0.1,0,0.1s-0.1,0-0.1,0v-0.1l0.2-0.1l0.2-0.1H13c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.1 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.1,0.3-0.1,0.3 C12.4,13.9,12.2,13.9,12.1,13.8L12.1,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5108",
    className: "st27",
    d: "M12.2,13.3L12.2,13.3C12.2,13.3,12.2,13.3,12.2,13.3L12.2,13.3 L12.2,13.3L12.2,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5109",
    className: "st27",
    d: "M12.4,13.3C12.4,13.3,12.4,13.3,12.4,13.3l0.1-0.1L12.4,13.3 C12.5,13.2,12.5,13.3,12.4,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5110",
    className: "st27",
    d: "M12.3,13.6C12.3,13.6,12.3,13.6,12.3,13.6c0-0.1,0.1-0.1,0.1-0.1 C12.4,13.5,12.4,13.5,12.3,13.6C12.4,13.5,12.4,13.5,12.3,13.6L12.3,13.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5111",
    className: "st27",
    d: "M12.5,13.5L12.5,13.5h-0.1c0,0,0,0,0-0.1L12.5,13.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5114",
    className: "st27",
    d: "M12.7,13.1C12.7,13.1,12.7,13.1,12.7,13.1L12.7,13.1L12.7,13.1 L12.7,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5115",
    className: "st27",
    d: "M13.1,13.1C13.1,13.1,13,13.1,13.1,13.1C13,13.1,13,13.1,13.1,13.1 C13,13.2,13,13.1,13.1,13.1L13.1,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5116",
    className: "st27",
    d: "M13,13.3L13,13.3L13,13.3L13,13.3L13,13.3L13,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5117",
    className: "st15",
    d: "M10.8,12.2l-0.1,0.2h0.1L10.8,12.2L10.8,12.2z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3561"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M10.6,12.5c0,0.1,0,0.2,0.1,0.2s0.2-0.1,0.2-0.2s0-0.2-0.1-0.2l0,0 C10.7,12.4,10.6,12.4,10.6,12.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2251"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Trazado_5118_1_",
    cx: 476.0649,
    cy: 496.0876,
    r: 0.38,
    gradientTransform: "matrix(0.6 0.25 0.25 -0.6 -398.9753 188.4568)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D3395F"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5118",
    className: "st32",
    d: "M10.4,12.7l0.4,0.2l0.2-0.5l-0.4-0.2L10.4,12.7z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3563"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -4,
    y: 2.7,
    width: 32.1,
    height: 18.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5120",
    className: "st18",
    d: "M10.8,12.2L10.8,12.2l-0.1,0.2h0.1V12.2L10.8,12.2L10.8,12.2L10.8,12.2 v0.2l0,0V12.2L10.8,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5121",
    className: "st15",
    d: "M10.9,12.1C10.9,12.1,10.8,12.1,10.9,12.1 C10.8,12.2,10.8,12.2,10.9,12.1C10.9,12.2,10.9,12.1,10.9,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5122",
    className: "st18",
    d: "M10.9,12.1L10.9,12.1C10.8,12.1,10.8,12.1,10.9,12.1L10.9,12.1 c-0.1,0.1,0,0.1,0,0.1l0,0C10.9,12.2,10.9,12.2,10.9,12.1L10.9,12.1L10.9,12.1C10.9,12.1,10.9,12.1,10.9,12.1 L10.9,12.1 M10.9,12.1L10.9,12.1C10.9,12.1,10.9,12.1,10.9,12.1L10.9,12.1L10.9,12.1L10.9,12.1 M10.9,12.1 L10.9,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5123",
    className: "st18",
    d: "M10.9,12.1L10.9,12.1C10.8,12.1,10.8,12.1,10.9,12.1 C10.8,12.1,10.8,12.1,10.9,12.1L10.9,12.1L10.9,12.1L10.9,12.1L10.9,12.1L10.9,12.1L10.9,12.1L10.9,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5125",
    className: "st15",
    d: "M14.5,12.6l-0.2,0.2h0.1L14.5,12.6L14.5,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5126",
    className: "st18",
    d: "M14.5,12.6L14.5,12.6l-0.2,0.2h0.1L14.5,12.6L14.5,12.6L14.5,12.6 L14.5,12.6l-0.1,0.2h-0.1L14.5,12.6L14.5,12.6L14.5,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5127",
    className: "st15",
    d: "M14.6,12.5C14.6,12.5,14.6,12.5,14.6,12.5c-0.1,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1c0,0,0,0,0,0l0,0C14.6,12.6,14.6,12.6,14.6,12.5C14.7,12.6,14.7,12.6,14.6,12.5 C14.6,12.5,14.6,12.5,14.6,12.5L14.6,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5128",
    className: "st18",
    d: "M14.6,12.5L14.6,12.5C14.6,12.5,14.6,12.5,14.6,12.5 c-0.1,0-0.1,0.1-0.1,0.1l0,0c0,0,0,0,0.1,0l0,0C14.6,12.6,14.6,12.6,14.6,12.5L14.6,12.5 C14.6,12.6,14.6,12.6,14.6,12.5L14.6,12.5C14.6,12.6,14.6,12.7,14.6,12.5C14.5,12.6,14.5,12.6,14.6,12.5 L14.6,12.5L14.6,12.5L14.6,12.5L14.6,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5129",
    className: "st18",
    d: "M14.6,12.5L14.6,12.5c0,0-0.1,0-0.1,0c0,0,0,0,0,0.1c0,0,0,0,0,0l0,0 l0,0v-0.1l0,0l0,0L14.6,12.5L14.6,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5130",
    className: "st18",
    d: "M14.5,12.7L14.5,12.7L14.5,12.7L14.5,12.7L14.5,12.7L14.5,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5131",
    className: "st15",
    d: "M9.2,11.5l0.1,0.2v-0.1L9.2,11.5L9.2,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5132",
    className: "st18",
    d: "M9.2,11.5L9.2,11.5l0.1,0.2l0.1-0.1L9.2,11.5L9.2,11.5l0.2,0.2v0.1 L9.2,11.5L9.2,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5133",
    className: "st15",
    d: "M9.1,11.4C9.1,11.4,9.1,11.4,9.1,11.4C9.1,11.5,9.1,11.5,9.1,11.4 L9.1,11.4C9.2,11.4,9.2,11.4,9.1,11.4C9.2,11.4,9.2,11.4,9.1,11.4L9.1,11.4C9.2,11.4,9.1,11.4,9.1,11.4L9.1,11.4 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5134",
    className: "st34",
    d: "M9.6,11.9c0.1,0.1,0,0.2,0,0.3s-0.2,0-0.2-0.1s0-0.2,0-0.3 S9.5,11.7,9.6,11.9"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3565"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M9.3,11.7c-0.1,0-0.1,0.2,0,0.3s0.2,0.2,0.2,0.1s0.1-0.2,0-0.3C9.5,11.8,9.5,11.7,9.3,11.7 L9.3,11.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2255"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Trazado_5535_1_",
    cx: -3917.6216,
    cy: -2661.2214,
    r: 0.45,
    gradientTransform: "matrix(-5.000000e-02 -0.52 -0.5 5.000000e-02 -1505.5992 -1914.8732)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D3395F"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5535",
    className: "st36",
    d: "M9.2,11.7h0.4v0.5H9.2V11.7z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3567"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: -4,
    y: 2.7,
    width: 32.1,
    height: 18.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5136",
    className: "st18",
    d: "M9.1,11.4L9.1,11.4L9.1,11.4C9.1,11.4,9.2,11.5,9.1,11.4L9.1,11.4 L9.1,11.4C9.2,11.4,9.2,11.4,9.1,11.4L9.1,11.4C9.2,11.4,9.2,11.4,9.1,11.4L9.1,11.4L9.1,11.4 C9.1,11.4,9.1,11.4,9.1,11.4C9.2,11.4,9.2,11.5,9.1,11.4c0.1,0.1,0.1,0.1,0.1,0.1l0,0c0,0,0,0-0.1,0l0,0l0,0 L9.1,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5137",
    className: "st18",
    d: "M9.1,11.4L9.1,11.4C9.1,11.4,9.1,11.4,9.1,11.4c0,0.1,0,0.1,0,0.1 c0,0,0.1,0,0.1,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0L9.1,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5138",
    className: "st18",
    d: "M9.2,11.5L9.2,11.5L9.2,11.5L9.2,11.5L9.2,11.5L9.2,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5139",
    className: "st38",
    d: "M9.2,11.9L9.2,11.9L9.2,11.9L9.2,11.9C9.2,11.9,9.2,11.8,9.2,11.9 L9.2,11.9L9.2,11.9C9.2,11.8,9.1,11.9,9.2,11.9C9.1,11.9,9.1,11.9,9.2,11.9L9.2,11.9L9.2,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5140",
    className: "st38",
    d: "M9.2,11.7L9.2,11.7L9.2,11.7h0.1l0,0v-0.1l0,0l0,0 C9.3,11.7,9.2,11.7,9.2,11.7C9.2,11.7,9.2,11.7,9.2,11.7C9.2,11.8,9.2,11.8,9.2,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5141",
    className: "st38",
    d: "M9.5,11.7C9.5,11.7,9.5,11.6,9.5,11.7L9.5,11.7L9.5,11.7 c0-0.1-0.1-0.1-0.1-0.1s0,0,0,0l0,0c0,0,0,0,0,0.1l0,0L9.5,11.7L9.5,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5142",
    className: "st39",
    d: "M9.2,11.8C9.3,11.8,9.3,11.8,9.2,11.8L9.2,11.8L9.2,11.8L9.2,11.8 L9.2,11.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5143",
    className: "st39",
    d: "M9.3,11.7L9.3,11.7C9.3,11.7,9.3,11.7,9.3,11.7 C9.3,11.7,9.3,11.7,9.3,11.7L9.3,11.7L9.3,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5145",
    className: "st38",
    d: "M10.6,12.3L10.6,12.3L10.6,12.3L10.6,12.3 C10.6,12.3,10.6,12.3,10.6,12.3L10.6,12.3L10.6,12.3l-0.1-0.1l0,0l0,0v0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5146",
    className: "st38",
    d: "M10.7,12.3C10.7,12.3,10.7,12.3,10.7,12.3L10.7,12.3L10.7,12.3 L10.7,12.3L10.7,12.3L10.7,12.3L10.7,12.3L10.7,12.3L10.7,12.3L10.7,12.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5147",
    className: "st38",
    d: "M10.9,12.4C10.9,12.4,10.9,12.4,10.9,12.4L10.9,12.4L10.9,12.4 c0-0.1-0.1-0.1-0.1-0.1s0,0,0,0l0,0l0,0l0,0l0,0l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5148",
    className: "st39",
    d: "M10.7,12.3L10.7,12.3C10.7,12.3,10.7,12.3,10.7,12.3 C10.7,12.2,10.7,12.3,10.7,12.3L10.7,12.3L10.7,12.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5150",
    className: "st39",
    d: "M10.9,12.3L10.9,12.3C10.9,12.4,10.9,12.4,10.9,12.3 C10.9,12.4,10.9,12.4,10.9,12.3L10.9,12.3L10.9,12.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5151",
    className: "st38",
    d: "M14.2,12.7C14.2,12.7,14.2,12.8,14.2,12.7L14.2,12.7L14.2,12.7 L14.2,12.7C14.2,12.8,14.2,12.8,14.2,12.7L14.2,12.7C14.2,12.7,14.1,12.7,14.2,12.7 C14.1,12.7,14.1,12.7,14.2,12.7L14.2,12.7L14.2,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5152",
    className: "st38",
    d: "M14.4,12.7L14.4,12.7L14.4,12.7L14.4,12.7L14.4,12.7L14.4,12.7 L14.4,12.7L14.4,12.7C14.4,12.7,14.3,12.7,14.4,12.7C14.3,12.7,14.3,12.7,14.4,12.7l-0.1-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5153",
    className: "st38",
    d: "M14.4,12.9L14.4,12.9L14.4,12.9L14.4,12.9 C14.4,12.9,14.4,12.8,14.4,12.9C14.4,12.8,14.4,12.8,14.4,12.9L14.4,12.9L14.4,12.9L14.4,12.9L14.4,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5154",
    className: "st39",
    d: "M14.3,12.7C14.3,12.7,14.3,12.7,14.3,12.7 C14.2,12.7,14.3,12.7,14.3,12.7L14.3,12.7L14.3,12.7L14.3,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5155",
    className: "st39",
    d: "M14.4,12.7L14.4,12.7 M14.4,12.8L14.4,12.8L14.4,12.8L14.4,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5157",
    className: "st40",
    d: "M11.5,9.4v0.1l-0.2,0.1l0,0l0,0V9.6h-0.1l0,0V9.5h0.1L11.5,9.4L11.5,9.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5158",
    className: "st41",
    d: "M12,8.4c0,0-0.4-0.1-0.3,0.2c0,0.1,0,0.1,0.1,0.1c0.1,0,0.2,0.1,0.4,0.1 c0.1,0.1,0.2,0.3,0.1,0.4l0.1,0.4l0.1,0.3l0.2-0.1l0.1-0.4l-0.2-0.8L12,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5159",
    className: "st42",
    d: "M12,8.4L12,8.4c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0.1-0.1,0.2l0,0 c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.1 c0,0.1,0,0.1,0,0.2l0,0l0,0l0.1,0.4l0.1,0.3l0.2-0.1l0.1-0.4l-0.2-0.8L12,8.4L12,8.4L12,8.4l0.6,0.2l0.2,0.7 l-0.1,0.4l-0.2,0.1l-0.1-0.3l-0.1-0.4l0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1-0.1-0.1-0.1-0.1 C12,8.8,12,8.8,11.9,8.8h-0.2h-0.1c0,0,0-0.1,0-0.1l0,0c0-0.1,0-0.1,0.1-0.2C11.8,8.5,11.9,8.5,12,8.4L12,8.4 L12,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5160",
    className: "st42",
    d: "M12.3,9.9c0.1,0,0.1-0.1,0.2-0.1l-0.1-0.1c0,0,0.1,0,0.1,0.1 c0,0,0,0,0.1,0c0,0,0.1-0.1,0-0.2c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0h0.1v0.1c0-0.1,0-0.1,0-0.2 c0,0-0.1-0.1-0.1-0.1h-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0.1,0.1,0c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1h-0.1 c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0h-0.1c-0.1,0-0.1-0.1-0.2-0.1H12l0,0c0,0,0.1,0,0.1,0h-0.1h-0.1h-0.1l0,0h0.1 c0.1,0,0,0,0,0V8.7h0.2L12.3,9l0.2,0.2l0.1,0.3V10l-0.3,0.2h-0.1v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5161",
    className: "st43",
    d: "M12,8.6C12,8.5,12,8.5,12,8.6L12,8.6c-0.1-0.1-0.2-0.1-0.2,0 c0,0.1,0,0.1,0,0.2h0.1c0,0,0.1,0,0.1,0c0,0,0,0-0.1,0h-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5162",
    className: "st44",
    d: "M12.4,9.9L12.4,9.9l0,0.4l0.4,0.6h0.2l0.1-0.1H13c0,0.1,0.1,0.1,0.1,0.2 c0,0,0.1,0,0.1,0.1l0.2,0.3v-0.1L13.5,11l-0.1-0.1l0,0h0.1h0.1l0.1,0.1V11v0.1l0,0v0.1l0.1,0.1l0.1,0.1l0,0v-0.1 L13.7,11l-0.1-0.1l0.1,0.1l0.1,0.1v0.1v0.1v0.1v0.1h0.1v-0.1l-0.1-0.2v-0.2h0.1l0.1,0.1v0.2v0.2l0.1,0.2l0.1,0.1 v0.1v-0.1l0.2-0.7l0,0l0,0c0,0,0,0.1,0,0.1v0.1v0.2v0.2l0.1,0.2v0.1v-0.1V11l0,0l0.1,0.1l0,0v0.2v0.5v0.1 l0.2-1.4h0.1l0,0h-0.1l-0.2-0.2L14.3,10l-0.2-0.4l-0.3-0.4L13.5,9L13.4,9V8.9V8.8l0,0h-0.1h-0.1L13,8.7l-0.2-0.1 L13,8.4l-0.3-0.1l-0.3-0.1h-0.1h-0.1c-0.1,0-0.1,0.1-0.1,0.2l0,0c0,0.1,0,0.1,0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2 l0.1,0.1v0.1v0l0.1,0.5L12.4,9.9L12.4,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5163",
    className: "st41",
    d: "M12.7,10.8c0,0,0.1,0,0.1,0l0,0c0.1-0.1,0-0.3,0-0.3l0,0l0.1,0.1 c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1-0.1,0.2h-0.1L12.7,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5164",
    className: "st42",
    d: "M14.8,12l-0.1-0.2c0,0,0-0.1,0-0.2s0-0.4,0-0.4c0-0.1,0-0.1,0-0.2 l-0.1-0.1l0,0l0,0l0,0c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.3-0.2-0.4l0,0v0.1l0.1,0.1l0.2,0.1h0.1l0.1,0.1 c0,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.2-0.1,0.3C14.9,11.5,14.9,11.7,14.8,12L14.8,12L14.8,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5165",
    className: "st44",
    d: "M14.8,11.4c0,0,0.1-0.1,0.1-0.1c0-0.2,0-0.5,0-0.7 c-0.1-0.1-0.1-0.1-0.2-0.1l0.1,0.2c0,0,0,0,0,0.1v0.1c0,0.1,0,0.2,0.1,0.3C14.8,11.3,14.8,11.4,14.8,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5166",
    className: "st42",
    d: "M14.5,11.7c0-0.1,0-0.3,0-0.4c0-0.2,0-0.2,0-0.2 c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0.1h-0.1v-0.1v-0.1v-0.1 l0.1,0.1l0.2,0.1l0.1,0.4l0.1,0.3v0.8L14.5,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5167",
    className: "st42",
    d: "M14.6,10.5L14.6,10.5c0.1,0.1,0.2,0.1,0.2,0.1h-0.1h-0.1L14.6,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5168",
    className: "st42",
    d: "M14.2,11.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3-0.1-0.4 c-0.1-0.1-0.1-0.2-0.2-0.2c0-0.1-0.1-0.2-0.1-0.2c0,0-0.1-0.1-0.1-0.1v-0.2l0.2,0.1H14l0.1,0.4l0.1,0.1v0.2 l0.1,0.4v0.3l0,0L14.2,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5169",
    className: "st42",
    d: "M14,11.4c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.1-0.1-0.2l-0.2-0.2 c-0.1-0.1-0.1-0.2-0.2-0.2v-0.1l0.1,0.1l0.1,0.1v0.2l0.1,0.1l0.1,0.1h0.1v0.2v0.1L14,11.4L14,11.4L14,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5170",
    className: "st42",
    d: "M13.9,11.4L13.9,11.4c0,0,0-0.1,0-0.1l-0.1-0.2L13.7,11l-0.2-0.2 c-0.1,0-0.1-0.1-0.2-0.2h-0.1v-0.2c0,0,0.1,0.1,0.1,0.1h0.1l0.1,0.2v0.1l0.1,0.1V11v0.1v0.2v0.1L13.9,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5171",
    className: "st42",
    d: "M13.6,11.4c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.1 c0-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.1-0.2-0.2l0,0l0,0l0.2,0.2l0.1,0.1v0.1v0.1v0.1L13.6,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5172",
    className: "st42",
    d: "M14.4,10.3c0,0,0.1,0.2,0.2,0c0-0.1,0-0.2-0.1-0.2c0,0-0.1-0.2-0.2-0.3 l-0.3-0.4l-0.2-0.1l0.1,0.1c0.1,0.1,0.2,0.3,0.3,0.4C14.3,9.9,14.4,10.1,14.4,10.3L14.4,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5173",
    className: "st42",
    d: "M13.5,9.1c0.2,0.2,0.3,0.3,0.5,0.5c0.2,0.3,0.3,0.5,0.2,0.5 s-0.2,0-0.2-0.1c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.2l-0.1-0.2L13.5,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5174",
    className: "st42",
    d: "M13.4,9.7c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.1,0.2,0.2l0.1,0.1 c0,0-0.1-0.1,0-0.1 M13.9,10.2l-0.6-0.6L13.9,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5175",
    className: "st42",
    d: "M13.3,9.8c0,0.1,0.1,0.1,0.2,0.2l0.2,0.2v0.1c0,0-0.3-0.2-0.3-0.1 c0,0.1,0,0.1,0.1,0.1h-0.1l-0.1-0.1l0-0.1l-0.1-0.2L13.3,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5176",
    className: "st42",
    d: "M12.5,10.4c0,0,0.1,0.1,0.2,0c0-0.1,0-0.2,0-0.2c0,0,0.2,0.3,0.2,0 c0-0.1-0.1-0.2-0.1-0.2l0,0L13,10c0.1,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2-0.1-0.2l0.1,0.1c0,0,0.2,0,0.2-0.1 s-0.1-0.2-0.1-0.2s0.1,0,0.1-0.1s-0.2-0.1-0.2-0.2c0,0,0-0.1,0.1-0.1l0,0c0.1,0,0.2,0.1,0.2,0s0-0.1,0-0.1h-0.1 l-0.2-0.1L13,8.8h-0.1l0.1,0.1v0.3v0.1v0.3l-0.1,0.2v0.1l0,0L12.8,10l-0.1,0.1l-0.1,0.1L12.5,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5177",
    className: "st41",
    d: "M13.5,10.9c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1l0.2,0.2 L13.5,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5178",
    className: "st41",
    d: "M13.8,10.9c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.2l0,0v0.2 l0.1,0.1C13.7,10.9,13.7,10.9,13.8,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5179",
    className: "st41",
    d: "M14,10.9c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.2v0.1l0.1,0.1 l0.1,0.1L14,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5180",
    className: "st41",
    d: "M14.2,10.8c0-0.1,0-0.3,0-0.4c0-0.1-0.1-0.1-0.1-0.1l0,0v0.2l0.1,0.2 L14.2,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5181",
    className: "st41",
    d: "M14.4,10.3c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.3,0.1,0.4l0,0l-0.2-0.3 L14.4,10.3L14.4,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5182",
    className: "st43",
    d: "M13.1,10.7h0.1c0,0-0.1-0.1-0.1-0.2s0.1,0,0.1,0s-0.1-0.2-0.1-0.2 s0.1,0.2,0.1,0.2s0,0.1,0,0.1S13,10.8,13.1,10.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5183",
    className: "st43",
    d: "M13.3,10.5h0.2l-0.1-0.1c0,0,0-0.1,0-0.1h0.1c0,0-0.1-0.2-0.1-0.2 s0,0,0,0c0,0,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.1,0.2C13.5,10.6,13.3,10.5,13.3,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5184",
    className: "st43",
    d: "M14,10.2c0,0,0-0.1,0-0.1l0,0c0,0-0.1,0-0.1,0h-0.1l0.1,0.1H14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5185",
    className: "st43",
    d: "M13.5,10.3h0.2l-0.2-0.2l0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1 s0.1,0.1,0.1,0.1s0-0.1,0-0.2l0.1,0.1c0,0,0.1,0.1,0.2,0.1s0-0.1,0-0.1s0,0.1,0,0.1c0,0-0.1,0-0.1,0h-0.1l0,0 c0,0,0,0.1,0,0.1h-0.2L13.5,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5186",
    className: "st8",
    d: "M10.3,9.8H10c-0.1,0-0.1-0.1-0.1-0.3l0,0c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.2-0.3,0.3-0.3h0.1L10.3,9l0,0l0,0l0,0c0,0-0.1,0.1-0.1,0.1l0,0c0,0,0,0.1,0,0.1l0,0c0,0,0,0.1-0.1,0.1 l0,0c0,0,0,0.1,0,0.1c0.1,0,0.1,0,0.2,0l0.1-0.1l0,0c0,0.1-0.1,0.1-0.1,0.1h-0.1h-0.1l0,0c0,0,0,0,0,0.1 c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0l0,0l-0.1,0.3L10.3,9.8z M10.4,9.6L10.4,9.6c-0.1,0-0.1,0-0.2,0 c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1l0,0c0,0,0.1,0,0.1,0h0.1c0.1,0,0.1-0.1,0.1-0.1l0,0l0,0h-0.1c-0.1,0-0.1,0-0.2,0 l0,0l0,0c0,0,0-0.1,0.1-0.1l0,0c0,0,0-0.1,0-0.1l0,0L10.3,9l0,0l0,0l0,0c0,0-0.1,0-0.1,0.1l0,0c0,0,0,0-0.1,0 c0,0-0.3,0.2-0.3,0.3c0,0.1,0,0.1,0.1,0.1l0,0l0,0c0,0.1,0,0.3,0.1,0.4h0.3L10.4,9.6L10.4,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5187",
    className: "st43",
    d: "M14.1,10.2c0,0,0.2,0.1,0.3,0.1s-0.1-0.4-0.1-0.4s0.2,0.4,0.1,0.4 s-0.1,0-0.1,0l-0.1-0.1L14.1,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5188",
    className: "st43",
    d: "M14.8,10.8L14.8,10.8L14.8,10.8L14.8,10.8L14.8,10.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5191",
    className: "st43",
    d: "M14.6,10.6h0.1c0,0,0,0,0.1,0H14.6L14.6,10.6L14.6,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5192",
    className: "st43",
    d: "M14.2,9.5L14.2,9.5L14.2,9.5C14.3,9.5,14.3,9.5,14.2,9.5L14.2,9.5 L14.2,9.5L14.2,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5193",
    className: "st43",
    d: "M13.9,9.1H14c0,0,0,0,0.1,0c0,0.1,0,0.1,0,0.2 C14.1,9.3,13.9,9.2,13.9,9.1L13.9,9.1L13.9,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5194",
    className: "st43",
    d: "M13.7,9.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1L13.6,9L13.7,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5195",
    className: "st43",
    d: "M13.4,8.9L13.4,8.9c0.1,0,0.2-0.1,0.3-0.1s0.1,0,0.1,0c0,0,0,0.1,0,0.1 L13.5,9L13.4,8.9L13.4,8.9L13.4,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5196",
    className: "st43",
    d: "M13.4,8.7c0-0.1-0.1-0.1-0.1-0.1S13.3,8.7,13.4,8.7c0,0.1,0,0.2,0,0.2 l0,0L13.4,8.7L13.4,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5197",
    className: "st43",
    d: "M13.1,8.6c-0.1-0.1-0.2-0.1-0.3-0.2C12.9,8.5,13,8.6,13.1,8.6 c0,0.1,0,0.2,0,0.2s0,0,0,0V8.7L13.1,8.6L13.1,8.6L13.1,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5198",
    className: "st43",
    d: "M12.8,8.5c-0.2-0.1-0.3-0.2-0.5-0.1c-0.2,0-0.3,0-0.2,0.1 s0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0.1,0.2,0.1c0,0-0.1-0.1-0.1-0.1l-0.1-0.1c0,0,0,0,0.1,0 c0.1,0,0.2,0.1,0.3,0.2c0,0,0,0.1,0,0.1l0,0l0,0c0,0,0,0,0-0.1c0,0,0-0.1-0.1-0.1L12.8,8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5199",
    className: "st43",
    d: "M12.3,9.9c0.1-0.1,0.2-0.2,0.3-0.3c0-0.2,0-0.4-0.1-0.6 c0-0.1,0.1,0,0.1,0c0.1,0.2,0.1,0.3,0.1,0.5c0,0.1,0,0.3-0.1,0.4C12.5,9.9,12.4,10,12.3,9.9L12.3,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5200",
    className: "st43",
    d: "M12.6,10.5C12.6,10.5,12.6,10.5,12.6,10.5c0.2,0,0.3-0.1,0.3-0.2 s-0.1-0.1-0.1-0.2l0,0h0.1v0.1c0,0,0,0,0.1,0s0.1-0.1,0.1-0.1s-0.1-0.1-0.1-0.2v0H13V10c0,0,0,0,0.1,0 c0,0,0.1-0.1,0.1-0.1L13,9.7l0,0l0,0c0,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1s0-0.1-0.1-0.1l0,0l0,0v0.1v0.1v0.1 l-0.1,0.1h-0.1l0,0l0.1,0.1V10L13,10L13,10.1v0.1l-0.1,0.1l-0.1,0.1l0,0v0.1l-0.1,0.1L12.6,10.5L12.6,10.5 L12.6,10.5L12.6,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5201",
    className: "st43",
    d: "M13.2,9.4c0,0,0.2,0.1,0.2-0.1s-0.2-0.2-0.2-0.2c0,0,0,0,0-0.1l0.1,0.1 c0,0,0.1,0,0.1,0s0-0.1,0-0.1h0.1v0.1l-0.1,0.3c0,0,0,0.1-0.1,0.1C13.4,9.5,13.3,9.5,13.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5202",
    className: "st43",
    d: "M13.4,10.9C13.4,10.9,13.4,10.8,13.4,10.9c0-0.1-0.1-0.2-0.1-0.2 L13.4,10.9L13.4,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5203",
    className: "st43",
    d: "M13.7,10.9l-0.1-0.1c0,0-0.1-0.1-0.1-0.1s0,0.1,0,0.1L13.7,10.9 L13.7,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5204",
    className: "st43",
    d: "M14,10.9c0,0-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0,0,0.1,0,0.1 l0.1,0.2L14,10.9L14,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5205",
    className: "st43",
    d: "M14.1,10.8c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2v0.2L14.1,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5206",
    className: "st43",
    d: "M14.6,10.9l-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0,0.1,0,0.1,0,0.1l0.1,0.2 L14.6,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5207",
    className: "st43",
    d: "M14.9,10.5c-0.1-0.1-0.1-0.1-0.2-0.1l-0.3-0.1l0,0h0.1l0.1,0.1h0.2 L14.9,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5208",
    className: "st45",
    d: "M13.5,10.5c0,0.1,0,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.2 c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.2s0.1,0.1,0,0.1s-0.1,0-0.1-0.1s0,0,0-0.1c0-0.1-0.1-0.3-0.1-0.4 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.1-0.1-0.1L13.5,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5209",
    className: "st45",
    d: "M13.8,11.3c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.2 c0,0-0.1,0-0.1,0c-0.1-0.1-0.1-0.1-0.2-0.2l0,0c0,0,0.2,0.2,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0,0,0.1,0,0.1 c0,0,0,0.1,0.1,0.1l0,0c0,0-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3h0.1c0.1,0,0.2,0.1,0.2,0.2 C13.7,11.2,13.7,11.3,13.8,11.3c0,0.1,0,0.2,0,0.2l0,0C13.8,11.4,13.8,11.4,13.8,11.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5210",
    className: "st45",
    d: "M13.5,10.3l0.1,0.1h0.1c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.2,0.2 c0,0.1,0,0.3,0.1,0.4c0,0.1,0.1,0.3,0.1,0.4c0,0-0.1-0.1-0.1-0.2l-0.1-0.3c0-0.1-0.1-0.1-0.1-0.2l0,0 c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2l0,0l0,0c0,0,0-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.3l-0.1-0.2 c-0.1-0.1-0.1-0.2-0.1-0.3c0,0,0,0,0-0.1h-0.1C13.6,10.5,13.6,10.4,13.5,10.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5211",
    className: "st45",
    d: "M13.8,10.3l0.1,0.1H14c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.2,0.2 c0,0.1,0,0.2,0,0.3c0,0.3,0,0.3,0,0.4c0,0.2,0,0.3,0,0.5c-0.1,0,0-0.3,0-0.4c-0.1-0.1-0.1-0.2-0.1-0.4 c-0.1-0.2,0-0.3-0.1-0.4S14,10.9,14,10.9c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.3,0.1,0.4c0,0.1,0.1,0.3,0.1,0.4 c0,0,0-0.3,0-0.5c0-0.1,0-0.3-0.1-0.4c0-0.1-0.1-0.1-0.1-0.2S14,10.5,14,10.4s0,0-0.1,0 C13.9,10.4,13.9,10.4,13.8,10.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5212",
    className: "st45",
    d: "M14.1,10.2c0,0,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0.1c0,0.1,0,0.2,0.1,0.4 c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.5,0,0.7s0,0.7,0,0.7s0-0.4,0-0.5c0,0,0-0.1-0.1-0.1c0-0.1,0-0.4-0.1-0.6 s-0.1-0.2-0.1-0.2c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.5,0.1,0.6c0,0.1,0.1,0.1,0.1,0.2c0-0.3,0-0.5,0-0.8 c-0.1-0.2-0.1-0.3-0.2-0.5c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5213",
    className: "st45",
    d: "M14.4,10.3c0.1,0.1,0.1,0.1,0.2,0.1l0.3,0.1C15,10.6,15,10.8,15,11 c0,0.2,0,0.3-0.1,0.5c-0.1,0.2-0.1,0.7-0.1,0.8v0.1c0,0.1,0,0.1,0,0.1s0-0.1,0-0.1c0.1-0.2,0.1-0.4,0-0.6 c0-0.1,0-0.7,0-0.7l-0.1-0.1c0.1,0,0.1,0.1,0.1,0.1c0,0.1,0,0.6,0.1,0.7s0,0,0-0.1c0-0.2,0-0.3,0-0.5 c0-0.2,0-0.4-0.1-0.5l0.1,0.1l0,0h0.1h-0.1l0,0c0,0.1,0.1,0.3,0.1,0.4c0,0.3,0,0.5,0,0.8c0,0,0-0.3,0.1-0.6 s0.1-0.3,0.1-0.5c0-0.2,0-0.3-0.1-0.4l-0.3-0.1C14.6,10.4,14.5,10.3,14.4,10.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5214",
    className: "st45",
    d: "M12.6,10.5C12.6,10.6,12.7,10.6,12.6,10.5c0.1,0,0.3-0.1,0.3-0.2v-0.1 l0,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1l0,0c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1h0.1c0,0,0.1-0.1,0.1-0.1 c0-0.1,0-0.1-0.1-0.1c0,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.2c0,0,0.1,0,0.2,0 c0,0,0-0.1,0-0.1l0,0c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.2-0.1c0,0-0.1,0.1-0.1,0.1s0,0.1,0.1,0.1l0,0h0.2 c0,0-0.1,0-0.1,0C13.9,9.3,14,9.3,14,9.4l0,0l0,0l0.2,0.2h0.1l0,0c0.1,0.1,0.1,0.2,0.2,0.3 c-0.1-0.2-0.2-0.3-0.3-0.5C14,9.4,14,9.3,14,9.4c0.1,0.1,0.1,0.2,0.2,0.3l0.1,0.3c-0.1-0.2-0.3-0.4-0.4-0.6 c-0.3-0.2-0.3-0.3-0.3-0.3s-0.1,0.2,0,0.2s0.2,0.2,0.4,0.4c0.1,0.2,0.3,0.3,0.4,0.5c-0.1-0.2-0.3-0.3-0.4-0.5 c-0.2-0.3-0.3-0.3-0.4-0.3s0,0,0,0.1s-0.1,0-0.1,0c0.1,0.1,0.2,0.2,0.2,0.2h0.1h0.1h-0.1h-0.1 c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0,0.1,0h0.1h-0.1H14l0.1,0.2c0,0-0.2-0.2-0.4-0.4s-0.2-0.2-0.2-0.2s0,0,0,0.1 h-0.1c0.1,0.1,0.2,0.2,0.2,0.3l0.2,0.2l-0.2-0.2c-0.1-0.1-0.2-0.1-0.2-0.1s0,0.1,0,0.1s0.2,0.3,0.2,0.3 s-0.2-0.3-0.3-0.3s0,0,0,0.1s-0.1,0-0.1,0s0.4,0.4,0.3,0.4c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0.1,0.2,0.1,0.2 S13.3,10,13.3,10s0,0-0.1,0.1s-0.1,0-0.1,0s0.2,0.3,0.2,0.3l-0.2-0.2l0,0l0.1,0.2c0,0-0.1-0.1-0.1-0.1 s0,0-0.1,0.1s-0.1,0-0.1,0s0,0,0.1,0.1c0,0,0,0.1,0,0.1L13,10.3c0,0-0.1-0.1-0.1-0.1s0,0,0,0L12.6,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5215",
    className: "st45",
    d: "M14.9,10.5L14.9,10.5C15,10.5,15,10.5,14.9,10.5 c-0.1-0.2-0.3-0.7-0.5-0.9c-0.2-0.2-0.4-0.4-0.6-0.6c0.3,0.2,0.5,0.4,0.6,0.6c0.2,0.3,0.3,0.5,0.4,0.8 c0.1,0.1,0.2,0.1,0.1,0.1 M15,10.5h-0.1H15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5216",
    className: "st45",
    d: "M12.5,10.3L12.5,10.3c0,0,0.1-0.1,0.1-0.1l-0.1-0.1c0,0,0-0.1,0-0.1 l0.1,0.1c0,0,0.1,0,0.1,0c0,0,0.2-0.1,0.1-0.2c0,0-0.1,0-0.1,0c0,0,0-0.1-0.1-0.1c0,0,0,0.1,0.1,0.1 c0,0,0.1,0,0.1,0c0-0.1,0.1-0.1,0.1-0.2c0,0-0.1,0-0.1,0c0,0,0-0.1-0.1-0.1c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0 c0,0,0-0.1,0-0.1c0,0,0-0.2,0-0.2h-0.1c0,0-0.1-0.1-0.1-0.1c0,0,0.1,0,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1 c0-0.1-0.1,0-0.1-0.1s0,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1 c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0.1,0,0.1,0h0.1c0,0,0-0.1-0.1-0.2l-0.2-0.1l0.2,0.1 c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1 c0.1,0,0.1,0.1,0.2,0.1c0,0,0-0.1,0-0.1l-0.1-0.1l0.1,0.1c0,0,0,0.1,0,0.1l0,0l0.1,0.1c0.1,0,0.1,0.1,0.1,0 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0,0.1h0.1c0,0-0.1,0-0.1,0 c-0.1,0-0.4-0.2-0.4-0.2s0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.1,0.1l-0.1-0.1L13,9l0,0c0,0,0,0.1,0,0.1 s0.2,0.2,0.2,0.2h-0.1c0,0-0.2,0-0.2,0s0.1,0.1,0.1,0.1s-0.1,0,0,0.1s0.1,0.1,0.1,0.2s-0.1,0.1-0.1,0.1l0.1,0.1 l-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1-0.1-0.1-0.1 s0,0,0,0c0,0,0,0.1-0.1,0.1c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1l-0.1-0.1c0,0-0.1,0.1-0.1,0.1 c0,0,0.1,0.1,0.1,0.1s-0.1,0-0.1,0L12.5,10.3L12.5,10.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5217",
    className: "st45",
    d: "M13.8,8.9C13.8,8.9,13.8,8.8,13.8,8.9c0-0.1,0.1-0.1,0-0.1s-0.1,0-0.1,0 s-0.1,0-0.2-0.1c-0.4-0.2-0.8-0.3-1.2-0.4c-0.2,0-0.3,0.1-0.3,0.1c0.1-0.1,0.2-0.1,0.3-0.1 c0.4,0,0.8,0.1,1.2,0.3c0.1,0.1,0.2,0.1,0.3,0.1h0.1L13.8,8.9C13.8,8.9,13.8,8.9,13.8,8.9L13.8,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5218",
    className: "st45",
    d: "M12.5,9L12.5,9c0-0.1-0.1-0.1-0.1-0.1c-0.1-0.1-0.3-0.2-0.4-0.2 c0.1,0.1,0.3,0.1,0.4,0.2C12.5,8.9,12.5,9,12.5,9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5219",
    className: "st43",
    d: "M12.5,9.5L12.5,9.5l-0.2-0.1c0,0,0.1,0,0.1,0 C12.5,9.4,12.5,9.4,12.5,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5220",
    className: "st43",
    d: "M12.5,9.2c0,0-0.1,0-0.1-0.1h-0.1C12.3,9.1,12.4,9.1,12.5,9.2 C12.5,9.2,12.5,9.2,12.5,9.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5221",
    className: "st43",
    d: "M12.4,9c0,0-0.1-0.1-0.1-0.1h-0.1C12.3,8.9,12.3,8.9,12.4,9 C12.5,8.9,12.4,9,12.4,9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5222",
    className: "st43",
    d: "M12.4,8.9c-0.1,0-0.1-0.1-0.2-0.1H12h0.3C12.3,8.8,12.3,8.9,12.4,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5223",
    className: "st43",
    d: "M12.1,8.7h-0.2h-0.2H12.1C12.1,8.7,12.1,8.8,12.1,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5224",
    className: "st11",
    d: "M11.3,11.7c0,0,0.1,0.1,0.1,0.1c0.1,0,0.2,0.1,0.2,0.1L11.4,12h-0.2 l-0.1-0.1L11.3,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5225",
    className: "st12",
    d: "M11.3,11.7L11.3,11.7L11.3,11.7c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1l0,0 l0,0l-0.1,0.1h-0.2l-0.1-0.1l0.1-0.2l0,0l-0.1,0.2l0.1,0.1h0.2l0.1-0.1l0,0l-0.1-0.1 C11.4,11.7,11.4,11.7,11.3,11.7C11.3,11.7,11.3,11.7,11.3,11.7L11.3,11.7L11.3,11.7L11.3,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5226",
    className: "st11",
    d: "M11.3,11.7c0-0.1-0.1-0.1-0.1-0.2c-0.1,0,0,0,0,0.1c0,0,0,0,0,0.1 c0,0,0,0.1,0,0.1S11.3,11.7,11.3,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5227",
    className: "st12",
    d: "M11.3,11.7L11.3,11.7L11.3,11.7C11.3,11.6,11.3,11.6,11.3,11.7 c0-0.1,0-0.1-0.1-0.2l0,0l0,0l0,0l0,0C11.2,11.5,11.2,11.6,11.3,11.7L11.3,11.7L11.3,11.7 C11.2,11.6,11.2,11.6,11.3,11.7L11.3,11.7L11.3,11.7L11.3,11.7L11.3,11.7L11.3,11.7L11.3,11.7L11.3,11.7 L11.3,11.7L11.3,11.7L11.3,11.7L11.3,11.7L11.3,11.7C11.3,11.6,11.3,11.6,11.3,11.7L11.3,11.7c0-0.1,0-0.1,0-0.1 l0,0C11.3,11.6,11.3,11.6,11.3,11.7L11.3,11.7L11.3,11.7L11.3,11.7L11.3,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5228",
    className: "st11",
    d: "M11.2,11.9C11.3,11.9,11.3,11.9,11.2,11.9c0.1,0,0.1,0,0.1-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5229",
    className: "st12",
    d: "M11.2,11.9L11.2,11.9c0.1,0,0.1,0,0.1,0l0,0H11.2L11.2,11.9L11.2,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5230",
    className: "st11",
    d: "M11.2,11.8c0,0,0.1-0.1,0.1-0.1s0,0-0.1,0 C11.2,11.7,11.2,11.8,11.2,11.8C11.1,11.8,11.1,11.9,11.2,11.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5231",
    className: "st12",
    d: "M11.2,11.8L11.2,11.8L11.2,11.8L11.2,11.8c0.1-0.1,0.1-0.1,0.1-0.1l0,0 l0,0l0,0l0,0h-0.1l0,0l0,0l0,0L11.2,11.8L11.2,11.8L11.2,11.8L11.2,11.8L11.2,11.8L11.2,11.8L11.2,11.8 L11.2,11.8L11.2,11.8L11.2,11.8L11.2,11.8L11.2,11.8L11.2,11.8L11.2,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5232",
    className: "st11",
    d: "M11.1,11.9C11.1,11.9,11.1,12,11.1,11.9c0.1,0.1,0.2,0.1,0.2,0 c0,0,0-0.1-0.1-0.1L11.1,11.9L11.1,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5233",
    className: "st12",
    d: "M11.1,11.9L11.1,11.9L11.1,11.9C11.1,11.9,11.1,11.9,11.1,11.9 c0.1,0,0.1,0,0.1,0l0,0l0,0l0,0c0,0,0,0,0-0.1l0,0L11.1,11.9L11.1,11.9L11.1,11.9L11.1,11.9L11.1,11.9L11.1,11.9 L11.1,11.9L11.1,11.9L11.1,11.9L11.1,11.9C11.2,11.9,11.1,11.9,11.1,11.9C11.1,11.9,11.1,11.9,11.1,11.9 L11.1,11.9L11.1,11.9L11.1,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5234",
    className: "st11",
    d: "M11.2,11.8c0,0-0.1,0.1-0.1,0.1c0,0-0.1-0.1-0.1-0.1h0.1l0,0l0,0 c0,0,0,0,0,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5236",
    className: "st11",
    d: "M11.1,11.9L11,12v-0.2h0.1c0,0,0.1,0,0.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5237",
    className: "st12",
    d: "M11.1,11.9L11.1,11.9L11.1,11.9L11,12l0,0l0,0l0,0l0,0c0,0,0-0.1,0-0.1 v-0.1l0,0L11.1,11.9L11.1,11.9L11.1,11.9L11.1,11.9L11.1,11.9L11.1,11.9L11,11.8l0,0c0,0.1,0,0.1,0,0.2l0,0l0,0 l0,0l0,0C11.1,12,11.1,11.9,11.1,11.9L11.1,11.9L11.1,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5238",
    className: "st11",
    d: "M10.9,11.7c0,0,0.2,0,0.2,0.1S11,11.8,10.9,11.7 C10.9,11.8,10.9,11.7,10.9,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5239",
    className: "st12",
    d: "M10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7 C10.9,11.8,10.9,11.8,10.9,11.7L10.9,11.7C10.9,11.7,10.9,11.7,10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7 L10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5240",
    className: "st46",
    d: "M10.5,12C10.5,12,10.5,12.1,10.5,12c0.1,0.1,0.2,0.1,0.2,0L10.5,12 L10.5,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5241",
    className: "st47",
    d: "M10.5,12L10.5,12L10.5,12C10.5,12,10.5,12,10.5,12L10.5,12 c0.1,0,0.2,0,0.2,0l0,0L10.5,12L10.5,12L10.5,12L10.5,12l0.2,0l0,0l0,0C10.7,12,10.6,12,10.5,12L10.5,12 C10.6,12,10.5,12,10.5,12L10.5,12L10.5,12L10.5,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5242",
    className: "st46",
    d: "M10.5,12c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2-0.1l-0.1-0.1L10.5,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5243",
    className: "st47",
    d: "M10.5,12L10.5,12c0,0,0.1,0.1,0.1,0.1l0,0c0.1,0,0.1,0,0.2-0.1l0,0 l-0.2-0.1L10.5,12L10.5,12l0.1-0.1l0.1,0.1l0,0c0,0-0.1,0.1-0.2,0.1l0,0L10.5,12L10.5,12L10.5,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5244",
    className: "st47",
    d: "M10.6,12C10.6,12,10.6,12,10.6,12h0.2h-0.1H10.6L10.6,12L10.6,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5245",
    className: "st46",
    d: "M10.7,11.9c0,0,0,0.1,0.1,0.1s0.1-0.1,0.1-0.1l-0.1-0.1L10.7,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5246",
    className: "st47",
    d: "M10.7,11.9L10.7,11.9L10.7,11.9C10.7,11.9,10.7,12,10.7,11.9L10.7,11.9 c0.1,0.1,0.1,0.1,0.2,0.1l0,0l0,0L10.7,11.9L10.7,11.9L10.7,11.9L10.7,11.9l0.2,0l0,0c0,0,0,0.1-0.1,0.1l0,0 C10.7,12,10.7,12,10.7,11.9L10.7,11.9L10.7,11.9L10.7,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5247",
    className: "st47",
    d: "M10.7,11.9c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0L10.7,11.9L10.7,11.9 L10.7,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5248",
    className: "st47",
    d: "M10.5,12C10.5,12,10.6,12,10.5,12c0.1,0,0.1,0,0.2,0l0,0l0,0H10.5 L10.5,12L10.5,12L10.5,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5249",
    className: "st11",
    d: "M10.9,11.7c0,0,0.1,0.1,0.1,0.2s0,0.1,0,0.1c-0.1,0-0.1-0.1-0.2-0.1 C10.8,11.9,10.8,11.8,10.9,11.7L10.9,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5250",
    className: "st12",
    d: "M10.9,11.7L10.9,11.7L10.9,11.7c0.1,0.1,0.1,0.1,0.1,0.1L11,12l0,0l0,0 l0,0l0,0c0,0-0.1-0.1-0.1-0.1C10.9,11.9,10.9,11.9,10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7 L10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0.1,0.1l0,0l0,0l0,0l0,0c0,0,0-0.1,0-0.1 C11,11.8,11,11.8,10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7L10.9,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5251",
    className: "st11",
    d: "M10.5,11.8c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1h0.1V11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5252",
    className: "st12",
    d: "M10.5,11.7L10.5,11.7L10.5,11.7L10.5,11.7L10.5,11.7 C10.4,11.8,10.4,11.8,10.5,11.7L10.5,11.7L10.5,11.7L10.5,11.7L10.5,11.7L10.5,11.7L10.5,11.7L10.5,11.7 L10.5,11.7L10.5,11.7L10.5,11.7L10.5,11.7L10.5,11.7C10.5,11.7,10.5,11.7,10.5,11.7L10.5,11.7L10.5,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5253",
    className: "st11",
    d: "M10.5,11.8L10.5,11.8C10.4,11.8,10.4,11.9,10.5,11.8L10.5,11.8 L10.5,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5254",
    className: "st12",
    d: "M10.5,11.8L10.5,11.8L10.5,11.8C10.4,11.8,10.4,11.9,10.5,11.8 L10.5,11.8L10.5,11.8L10.5,11.8L10.5,11.8L10.5,11.8L10.5,11.8L10.5,11.8L10.5,11.8L10.5,11.8L10.5,11.8 L10.5,11.8C10.4,11.9,10.4,11.9,10.5,11.8C10.4,11.8,10.4,11.8,10.5,11.8L10.5,11.8L10.5,11.8L10.5,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5255",
    className: "st11",
    d: "M10.5,11.9C10.5,11.9,10.4,11.9,10.5,11.9c-0.1,0.1-0.1,0.1,0,0.1 S10.5,12,10.5,11.9C10.6,11.9,10.6,11.9,10.5,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5256",
    className: "st12",
    d: "M10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9 C10.5,11.9,10.5,11.9,10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9 L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9 L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9L10.5,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5257",
    className: "st11",
    d: "M10.5,11.6c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1h0.1L10.5,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5258",
    className: "st12",
    d: "M10.6,11.6L10.6,11.6L10.6,11.6L10.6,11.6L10.6,11.6 C10.5,11.7,10.5,11.7,10.6,11.6L10.6,11.6c-0.1,0.1-0.1,0.1-0.1,0.2l0,0l0.1-0.1L10.6,11.6L10.6,11.6l0.1,0.1 h-0.1l0,0C10.5,11.7,10.5,11.7,10.6,11.6L10.6,11.6C10.5,11.6,10.5,11.6,10.6,11.6L10.6,11.6L10.6,11.6 L10.6,11.6L10.6,11.6L10.6,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5259",
    className: "st11",
    d: "M10.6,11.7c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1l0.1-0.1L10.6,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5260",
    className: "st12",
    d: "M10.6,11.7L10.6,11.7L10.6,11.7L10.6,11.7L10.6,11.7L10.6,11.7 C10.5,11.7,10.5,11.8,10.6,11.7L10.6,11.7L10.6,11.7L10.6,11.7L10.6,11.7l0-0.1l0,0L10.6,11.7L10.6,11.7 L10.6,11.7L10.6,11.7L10.6,11.7L10.6,11.7L10.6,11.7C10.6,11.7,10.6,11.7,10.6,11.7L10.6,11.7L10.6,11.7l0.1-0.1 l0,0L10.6,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5261",
    className: "st11",
    d: "M10.7,11.9L10.5,12c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1 S10.7,11.9,10.7,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5262",
    className: "st12",
    d: "M10.7,11.9L10.7,11.9L10.7,11.9L10.7,11.9L10.7,11.9 C10.6,11.9,10.6,11.9,10.7,11.9L10.7,11.9c-0.1-0.1-0.1-0.1-0.1-0.1h0.1l0,0C10.7,11.8,10.7,11.8,10.7,11.9 L10.7,11.9L10.7,11.9c0-0.1,0-0.1,0-0.1l0,0l0,0h-0.1c0,0,0,0-0.1,0.1l0,0v0.1l0,0l0,0L10.7,11.9L10.7,11.9 L10.7,11.9L10.7,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5263",
    className: "st11",
    d: "M10.8,11.5c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.1s0,0.1,0,0.1 s0.2-0.1,0.2-0.1L10.8,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5264",
    className: "st12",
    d: "M10.8,11.5L10.8,11.5C10.7,11.5,10.7,11.5,10.8,11.5L10.8,11.5 c-0.1,0-0.2,0-0.2,0.1c0,0,0,0.1-0.1,0.1l0,0c0,0,0,0,0,0.1l0,0h0.1l0.1-0.1l0,0L10.8,11.5L10.8,11.5l-0.1,0.1 l0,0l0,0l-0.1,0.1l0,0l0,0l0,0v-0.1l0,0c0,0,0-0.1,0-0.1C10.6,11.5,10.7,11.5,10.8,11.5L10.8,11.5L10.8,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5265",
    className: "st11",
    d: "M10.6,11.8c0,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.1,0.1-0.1 C10.7,11.6,10.7,11.8,10.6,11.8C10.7,11.8,10.6,11.8,10.6,11.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5266",
    className: "st12",
    d: "M10.6,11.8L10.6,11.8C10.6,11.8,10.6,11.8,10.6,11.8 C10.6,11.8,10.6,11.8,10.6,11.8L10.6,11.8L10.6,11.8c-0.1-0.1-0.1-0.1-0.1-0.1h0.1l0,0 C10.6,11.8,10.6,11.8,10.6,11.8L10.6,11.8L10.6,11.8L10.6,11.8L10.6,11.8L10.6,11.8L10.6,11.8L10.6,11.8 C10.7,11.9,10.7,11.9,10.6,11.8L10.6,11.8L10.6,11.8L10.6,11.8C10.7,11.9,10.7,11.9,10.6,11.8L10.6,11.8 L10.6,11.8L10.6,11.8L10.6,11.8L10.6,11.8L10.6,11.8L10.6,11.8C10.6,11.8,10.6,11.9,10.6,11.8 C10.6,11.9,10.6,11.9,10.6,11.8L10.6,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5267",
    className: "st11",
    d: "M10.8,11.8C10.8,11.9,10.7,11.9,10.8,11.8c-0.1,0.1-0.1,0.1-0.2,0.1 s0,0,0-0.1c0,0,0.1,0,0.1,0L10.8,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5268",
    className: "st12",
    d: "M10.8,11.8L10.8,11.8C10.8,11.9,10.7,11.9,10.8,11.8l-0.1,0.1l0,0l0,0 l0,0l0,0l0,0l0,0l0.1,0.1l0,0l-0.1-0.1l0,0c0,0,0,0-0.1,0l0,0 M10.6,12L10.6,12L10.6,12L10.6,12 C10.6,11.9,10.6,11.9,10.6,12L10.6,12L10.6,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5269",
    className: "st11",
    d: "M10.7,11.7C10.7,11.7,10.7,11.8,10.7,11.7c0,0.1,0,0.2,0.1,0.2 c0,0,0.1,0,0.1,0s0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1C10.9,11.6,10.8,11.7,10.7,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5270",
    className: "st12",
    d: "M10.7,11.7L10.7,11.7L10.7,11.7L10.7,11.7c0,0.1,0,0.1,0.1,0.1l0,0l0,0 c0,0,0.1,0,0.1,0l0,0c0,0,0,0,0-0.1l0,0c0,0,0-0.1,0-0.1l0,0C10.8,11.6,10.7,11.7,10.7,11.7L10.7,11.7 c0,0,0.1,0,0.1-0.1l0,0c0,0,0,0,0.1,0.1l0,0c0,0,0,0,0,0.1h-0.1C10.8,11.8,10.8,11.8,10.7,11.7L10.7,11.7 L10.7,11.7C10.7,11.8,10.7,11.7,10.7,11.7L10.7,11.7L10.7,11.7L10.7,11.7L10.7,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5271",
    className: "st46",
    d: "M10.9,11.5h-0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1l0.1-0.1 c0,0,0.1,0,0-0.1C10.8,11.6,10.8,11.6,10.9,11.5C10.8,11.5,10.8,11.5,10.9,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5272",
    className: "st47",
    d: "M10.9,11.5h-0.1c0,0-0.1,0.1-0.1,0.1v0.1v-0.1 C10.7,11.5,10.7,11.5,10.9,11.5L10.9,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5273",
    className: "st45",
    d: "M12.9,12.1v-0.3L12.2,12l0.3,0.3L12.9,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5274",
    className: "st43",
    d: "M11.5,11.6L11.5,11.6l-0.1-0.1h-0.1l0,0l0.1,0.1L11.5,11.6L11.5,11.6 L11.5,11.6L11.5,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5275",
    className: "st43",
    d: "M11.6,11.9l-0.2-0.1l0,0l0,0l0,0h0.1l0,0v0.1V12l0,0L11.6,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5276",
    className: "st43",
    d: "M11.6,11.9L11.6,11.9L11.6,11.9v-0.4l-0.2-0.2v0.1l0.1,0.2v0.1 L11.6,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5277",
    className: "st41",
    d: "M11.5,11.4c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.1,0.4l-0.1-0.1 C11.5,11.7,11.5,11.5,11.5,11.4C11.5,11.2,11.5,11.4,11.5,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5278",
    className: "st41",
    d: "M11.6,11.6C11.6,11.6,11.6,11.6,11.6,11.6l-0.1,0.2c0,0,0,0,0-0.1 s0,0.1,0,0.1L11.6,11.6L11.6,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5279",
    className: "st41",
    d: "M11.7,12c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.2-0.1-0.2-0.1s0.2,0,0.2,0h0.1 h0.1h0.1L11.7,12L11.7,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5280",
    className: "st41",
    d: "M11.3,12C11.3,12,11.3,12,11.3,12c0,0.1-0.1,0.1-0.1,0.1L11.3,12 L11.3,12L11.3,12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5281",
    className: "st43",
    d: "M11.2,11.9C11.2,11.9,11.2,11.9,11.2,11.9c0.1,0,0.2,0,0.2,0l0,0l0,0V12 L11.2,11.9L11.2,11.9L11.2,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5283",
    className: "st42",
    d: "M11.5,11.6l-0.1-0.1l-0.1-0.1v-0.1l0.1,0.1c0,0,0,0.1,0,0.1 C11.4,11.5,11.4,11.6,11.5,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5284",
    className: "st43",
    d: "M11.1,12C11.1,12,11.1,12,11.1,12h0.2l0.1,0.1l0,0h-0.2L11.1,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5285",
    className: "st44",
    d: "M11.7,11.6c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.1l0,0h-0.1h0.1 c0,0,0-0.1,0-0.1C11.7,11.7,11.7,11.7,11.7,11.6L11.7,11.6c0,0,0-0.1,0-0.1L11.7,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5286",
    className: "st41",
    d: "M11.3,12L11.3,12c0,0.1,0.1,0.1,0.2,0.1h0.2c0,0,0,0,0,0.1l-0.1,0.1l0,0 l0,0v-0.1L11.3,12L11.3,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5287",
    className: "st44",
    d: "M11.5,11.6c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1,0-0.2,0-0.3l0.1,0.2 c0,0,0,0.1,0,0.1C11.5,11.5,11.5,11.6,11.5,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5288",
    className: "st41",
    d: "M11.4,12.2C11.4,12.2,11.4,12.2,11.4,12.2c0.1-0.2,0.2-0.2,0.3-0.3v0.1 L11.4,12.2L11.4,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5289",
    className: "st44",
    d: "M11.4,12.1C11.4,12.1,11.5,12.1,11.4,12.1C11.5,12,11.5,12.1,11.4,12.1 l-0.2-0.1L11.4,12.1L11.4,12.1L11.4,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5290",
    className: "st44",
    d: "M11.9,12.2l-0.1-0.1c0,0,0-0.1,0-0.1l0,0h-0.1h0.1h-0.1c0,0,0.1,0,0.1,0 s-0.1,0-0.1,0.1l-0.1,0.1l0,0c0,0,0,0,0.1,0h0.1l0.2-0.1L11.9,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5291",
    className: "st41",
    d: "M11.9,12.2c0,0-0.1,0-0.1-0.2c0-0.1,0-0.2,0-0.3l0.1,0.1l0.1,0.1 L11.9,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5292",
    className: "st44",
    d: "M11.9,11.8c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.3l0,0v-0.1V12 L11.9,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5293",
    className: "st45",
    d: "M12,12c0,0,0,0.3-0.1,0.3s-0.1-0.1-0.1-0.1s0.1,0.1,0.1,0.1 S11.9,12,12,12L12,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5294",
    className: "st45",
    d: "M11.9,12.1L11.9,12.1c0,0,0,0-0.2,0.1s-0.2,0-0.2,0s0.1,0,0.2,0 L11.9,12.1L11.9,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5295",
    className: "st41",
    d: "M11.6,11.8C11.6,11.8,11.6,11.8,11.6,11.8l0.1,0.2l0,0 C11.6,11.9,11.6,11.9,11.6,11.8C11.5,11.8,11.5,11.7,11.6,11.8L11.6,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5296",
    className: "st44",
    d: "M11.4,12.1C11.4,12.1,11.4,12.1,11.4,12.1l-0.1-0.1L11.1,12 c0,0,0.1,0.1,0.1,0.1L11.4,12.1L11.4,12.1L11.4,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5297",
    className: "st45",
    d: "M11.4,12.1L11.4,12.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2-0.1l0.2,0.1 L11.4,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5298",
    className: "st41",
    d: "M11.5,11.7c0,0-0.1,0-0.1,0l-0.1,0.1h0.1c0,0,0-0.1,0-0.1 C11.4,11.7,11.4,11.7,11.5,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5299",
    className: "st44",
    d: "M11.3,11.5C11.3,11.6,11.4,11.6,11.3,11.5l0.2,0.1c0,0,0,0.1,0.1,0.1 c-0.1,0-0.1-0.1-0.2-0.1C11.3,11.6,11.3,11.6,11.3,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5300",
    className: "st44",
    d: "M11.4,11.6L11.4,11.6c-0.1,0-0.1,0-0.1,0l0,0v0.1l0,0c0,0-0.1,0-0.1-0.1 S11.4,11.6,11.4,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5301",
    className: "st45",
    d: "M12.7,11l0.4,0.6l-0.7,0.2H12l-0.2-0.1l0.1-0.2L12.7,11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5302",
    className: "st11",
    d: "M12.5,12.7L12.5,12.7l0.2-0.1v0.1l-0.1,0.1h-0.1l0,0L12.5,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5303",
    className: "st12",
    d: "M12.5,12.7L12.5,12.7L12.5,12.7l0.2-0.1l0,0v0.1l-0.1,0.1h-0.1l0,0l0,0 l0,0v0.1l0,0l0,0h0.1l0.1-0.1l0,0v-0.1l0,0l0,0h-0.1L12.5,12.7L12.5,12.7L12.5,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5304",
    className: "st11",
    d: "M12.4,12.7L12.4,12.7c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0.1l0,0L12.4,12.7 L12.4,12.7L12.4,12.7L12.4,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5305",
    className: "st12",
    d: "M12.4,12.7h0.1v0.1l0,0l0,0L12.4,12.7L12.4,12.7L12.4,12.7L12.4,12.7 L12.4,12.7L12.4,12.7L12.4,12.7L12.4,12.7l0.1,0l0,0l0,0l0,0l0,0l0,0L12.4,12.7L12.4,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5306",
    className: "st11",
    d: "M13,12.6L13,12.6l-0.2-0.1v0.2L13,12.6L13,12.6L13,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5307",
    className: "st12",
    d: "M13,12.6L13,12.6L13,12.6l-0.1-0.1l0,0l0,0v0.2H13L13,12.6L13,12.6 L13,12.6L13,12.6L13,12.6l0,0.1h-0.1L13,12.6L13,12.6L13,12.6L13,12.6L13,12.6L13,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5308",
    className: "st11",
    d: "M12.4,12.7C12.3,12.7,12.3,12.7,12.4,12.7c-0.1,0-0.1,0-0.2,0.1 c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.2h-0.1h-0.1C12.5,12.7,12.4,12.7,12.4,12.7 M12.3,12.7 L12.3,12.7C12.3,12.7,12.3,12.7,12.3,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5309",
    className: "st12",
    d: "M12.4,12.7L12.4,12.7C12.3,12.7,12.3,12.7,12.4,12.7L12.4,12.7h-0.1 c0,0,0,0,0,0.1l0,0c0,0,0,0,0,0.1c0,0,0,0,0,0.1h0.1l0,0h0.1l0.2-0.1h-0.1C12.5,12.7,12.4,12.7,12.4,12.7 L12.4,12.7L12.4,12.7L12.4,12.7L12.4,12.7L12.4,12.7L12.4,12.7L12.4,12.7L12.4,12.7L12.4,12.7L12.4,12.7l0.1,0 h0.1l0,0l0,0l-0.1,0.1h-0.1l0,0l0,0h-0.1l0,0C12.3,12.8,12.3,12.7,12.4,12.7L12.4,12.7L12.4,12.7L12.4,12.7 L12.4,12.7L12.4,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5310",
    className: "st46",
    d: "M12.1,13C12.1,13,12.1,12.9,12.1,13c0-0.1,0.1-0.1,0.1-0.1s0-0.1,0-0.1 v-0.1c0,0-0.2,0-0.2,0.1C12,12.9,12.1,13,12.1,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5311",
    className: "st11",
    d: "M12.5,12.7L12.5,12.7h-0.1v0.1L12.5,12.7L12.5,12.7L12.5,12.7L12.5,12.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5312",
    className: "st12",
    d: "M12.5,12.7L12.5,12.7L12.5,12.7L12.5,12.7L12.5,12.7L12.5,12.7 L12.5,12.7L12.5,12.7L12.5,12.7l0.1,0v-0.1L12.5,12.7L12.5,12.7l0.1-0.1v0.1L12.5,12.7L12.5,12.7L12.5,12.7 L12.5,12.7L12.5,12.7L12.5,12.7L12.5,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5313",
    className: "st11",
    d: "M13.1,12.7L13.1,12.7L13.1,12.7l-0.1,0.1v0.1H13l0,0h0.1L13.1,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5314",
    className: "st12",
    d: "M13.1,12.7L13.1,12.7L13.1,12.7L13.1,12.7L13.1,12.7L13.1,12.7 L13.1,12.7L13,12.8 M13,12.8L13,12.8L13,12.8h0.1l0,0v-0.1l0,0v0.1H13L13,12.8L13,12.8l0-0.1l0,0l0,0l0,0l0,0 l0,0l0,0l0,0L13,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5315",
    className: "st11",
    d: "M12.7,12.7L12.7,12.7l-0.1,0.1c0,0,0,0.1,0.1,0.1h0.1l0.1-0.1v-0.1 L12.7,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5316",
    className: "st12",
    d: "M12.7,12.7L12.7,12.7L12.7,12.7L12.7,12.7L12.7,12.7L12.7,12.7 L12.7,12.7L12.7,12.7L12.7,12.7l0.1,0l0,0v-0.1l0,0v0.1L12.7,12.7L12.7,12.7L12.7,12.7L12.7,12.7L12.7,12.7 L12.7,12.7L12.7,12.7L12.7,12.7L12.7,12.7L12.7,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5317",
    className: "st11",
    d: "M13.1,12.8L13.1,12.8L13.1,12.8L13,12.8l0,0v0.1h0.1h0.1L13.1,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5318",
    className: "st12",
    d: "M13.1,12.8L13.1,12.8L13.1,12.8L13.1,12.8L13.1,12.8L13.1,12.8 L13.1,12.8L13.1,12.8L13.1,12.8L13.1,12.8l-0.1,0.1l0,0h0.1l0,0h0.1l0,0l0,0l0,0l0,0l-0.1,0.1h-0.1v-0.1l0,0l0,0 l0,0l0,0h0.1l0,0l0,0L13.1,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5319",
    className: "st11",
    d: "M13,12.8L13,12.8L13,12.8L13,12.8c0,0,0,0.1,0.1,0.1h0.1l0,0l0.1-0.1 l0,0l0,0c0,0,0-0.1-0.1-0.1h-0.1C13.1,12.7,13.1,12.8,13,12.8L13,12.8L13,12.8L13,12.8v-0.1h-0.1l0,0l-0.1,0.1 c0,0,0,0-0.1,0.1c0,0-0.1,0-0.1,0c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0l0,0l0,0l0.1-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5320",
    className: "st12",
    d: "M13,12.8L13,12.8L13,12.8L13,12.8c0,0,0,0.1,0.1,0.1h0.1l0.1-0.1l0,0 l0,0l0,0l0,0l0,0l0,0l0,0h-0.1l0,0l0,0l0,0l0,0l0,0L13,12.8L13,12.8L13,12.8L13,12.8L13,12.8L13,12.8l-0.1,0.1 l0,0c0,0,0,0-0.1,0.1h-0.1l0,0l0,0l0,0l0,0c0,0-0.1,0-0.1,0l0,0l0,0c0,0,0,0-0.1,0c0,0,0,0,0,0.1l0,0 c0,0,0,0,0,0.1l0,0c0,0,0.1,0,0.1,0h0.1c0,0,0.1,0,0.1-0.1l0,0l0,0l0,0L13,12.8L13,12.8 c-0.1,0.1-0.1,0.1-0.2,0.1l0,0l0,0l0,0c0,0,0,0.1-0.1,0.1l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0,0-0.1s0,0,0,0l0,0 h0.1l0,0l0,0c0,0,0,0,0.1,0.1l0,0l0,0l0,0l0,0c0,0,0.1,0,0.1,0C13,13,13,13,13,13l0,0L13,12.8L13,12.8L13,12.8 L13,12.8L13,12.8L13,12.8L13,12.8c0.1,0.1,0.1,0.1,0.1,0.1l0,0l0,0l0,0l0,0l0,0v-0.1l0,0c0,0,0.1,0,0.1,0l0,0 l0,0l0,0l0,0L13.1,13H13c0,0,0,0-0.1-0.1l0,0l0,0l0,0H13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5321",
    className: "st11",
    d: "M12.8,12.4v0.1c0,0.1,0,0.1,0,0.2c0,0-0.1,0-0.1,0c0-0.1,0-0.1,0-0.2 L12.8,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5322",
    className: "st12",
    d: "M12.8,12.4L12.8,12.4v0.2l0,0v0.1c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0h-0.1 l0,0l0,0v-0.1l0,0L12.8,12.4L12.8,12.4l-0.1,0.2l0,0v0.2l0,0h0.1c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1 c0,0,0-0.1,0-0.1l0,0L12.8,12.4L12.8,12.4L12.8,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5323",
    className: "st46",
    d: "M12.4,13.2c0,0,0-0.1,0-0.1s0.1,0,0.1,0s0,0,0-0.1c0,0,0-0.1-0.1-0.1 c-0.1,0-0.1,0.1-0.1,0.1C12.3,13.2,12.3,13.2,12.4,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5324",
    className: "st46",
    d: "M13.3,13.1c0,0,0.2,0.1,0.2-0.1c0-0.1,0-0.1-0.1-0.2c0,0,0,0-0.1,0.1 s0,0.1,0,0.1s0.1,0,0.1,0S13.3,13.1,13.3,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5325",
    className: "st11",
    d: "M12.7,12.8L12.7,12.8L12.7,12.8L12.7,12.8 M12.7,12.9L12.7,12.9  M12.8,12.9L12.8,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5326",
    className: "st12",
    d: "M12.7,12.8L12.7,12.8L12.7,12.8L12.7,12.8L12.7,12.8L12.7,12.8 L12.7,12.8L12.7,12.8C12.7,12.8,12.8,12.8,12.7,12.8L12.7,12.8c0.1,0,0.1,0,0.1,0l0,0l0,0l0,0l0,0l0,0 C12.8,12.8,12.8,12.8,12.7,12.8L12.7,12.8L12.7,12.8L12.7,12.8L12.7,12.8L12.7,12.8L12.7,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5327",
    className: "st47",
    d: "M12.4,13.2c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.1-0.1 c0,0-0.1,0.1-0.1,0.1C12.2,13.1,12.3,13.2,12.4,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5328",
    className: "st47",
    d: "M12.1,13C12,13,12,12.9,12,12.9c0-0.1,0.2-0.1,0.2-0.1s-0.2,0-0.2,0.1 S12.1,13,12.1,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5329",
    className: "st47",
    d: "M13.3,13.1L13.3,13.1c0.1,0,0.2,0,0.2-0.1c0,0,0-0.1,0-0.2 c0,0,0,0-0.1,0c0,0,0,0,0.1,0c0,0,0,0.1,0,0.2C13.4,13.1,13.4,13.1,13.3,13.1L13.3,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5330",
    className: "st42",
    d: "M14.1,12.5l-0.1,0.1l-0.2-0.1L13.2,12L13,11.8v-0.2L14.1,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5331",
    className: "st42",
    d: "M14.4,12.3l-0.6-0.4L13,11.3v0.3l0.9,0.8l0.3,0.1h0.1l0.1-0.1L14.4,12.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5332",
    className: "st48",
    d: "M13,11.7c0.2,0.2,0.3,0.4,0.5,0.5c0.2,0.2,0.4,0.4,0.5,0.3s0-0.1,0-0.1 L13,11.7L13,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5333",
    className: "st42",
    d: "M13.6,12.6l-0.1-0.1L12.9,12v-0.1h0.1L13.6,12.6L13.6,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5334",
    className: "st45",
    d: "M14.4,12.3c0,0-0.1,0.2-0.2,0.1c-0.4-0.3-0.8-0.6-1.1-0.9v0.1 c0.3,0.3,0.7,0.6,1.1,0.9C14.2,12.6,14.4,12.5,14.4,12.3L14.4,12.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5335",
    className: "st48",
    d: "M12.9,11.8c0.1,0.2,0.3,0.4,0.5,0.5c0.2,0.1,0.3,0.2,0.4,0.2 s0-0.1,0-0.1l-0.5-0.4L13,11.8C13,11.8,12.9,11.8,12.9,11.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5336",
    className: "st45",
    d: "M13,11.8c0,0,0.8,0.8,0.8,0.8s0.3-0.1,0.3-0.1h-0.1l0,0 c0,0,0,0.1-0.2,0.1C13.6,12.4,13.3,12.1,13,11.8L13,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5337",
    className: "st42",
    d: "M13.4,12.6L13.4,12.6h-0.1h-0.1L13,12.3l-0.1-0.1V12L13.4,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5338",
    className: "st45",
    d: "M13.8,12.6c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.1-0.1l-0.5-0.5V12 c0.2,0.2,0.4,0.4,0.7,0.6C13.7,12.6,13.7,12.6,13.8,12.6L13.8,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5339",
    className: "st45",
    d: "M13.5,12.6c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0l-0.3-0.4v-0.1 c0.1,0.2,0.3,0.3,0.4,0.5C13.4,12.7,13.4,12.7,13.5,12.6L13.5,12.6L13.5,12.6L13.5,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5340",
    className: "st49",
    d: "M13.1,11.6c0,0,0.3,0.3,0.3,0.3s0.1,0,0.1,0s-0.1,0-0.1,0 c0.1,0.1,0.1,0.1,0.2,0.1h0.2h-0.1c0,0.1,0.1,0.1,0.2,0.1h0.2c0,0-0.1,0-0.1,0s0.2,0.2,0.2,0.2s-0.3-0.2-0.3-0.2 s0,0.1,0,0.1s0-0.1,0-0.1S13.8,12,13.8,12s0,0.1,0,0.1s0-0.1,0-0.1c-0.1-0.1-0.1-0.1-0.2-0.1c0,0,0,0.1,0,0.1 s0-0.1,0-0.1c-0.1-0.1-0.2-0.2-0.3-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5341",
    className: "st42",
    d: "M12.6,12.4c0,0,0,0.1-0.1,0.1s-0.2-0.2-0.2-0.2v-0.2l0.2,0.1L12.6,12.4z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5342",
    className: "st42",
    d: "M13,12.4L13,12.4c0-0.1,0-0.1,0-0.1v-0.1V12l0,0l0,0l-0.1,0.1v0.1 L13,12.4L13,12.4L13,12.4L13,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5343",
    className: "st42",
    d: "M12.9,12.6v-0.2l-0.1-0.2v-0.1h-0.1l-0.1,0.1v0.1c0,0.1,0.1,0.1,0.1,0.2 C12.8,12.5,12.9,12.6,12.9,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5344",
    className: "st45",
    d: "M12.8,12.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0.1,0.2h-0.1 c0,0,0.1,0.1,0.1,0.1s0-0.1,0-0.1s0,0-0.1,0c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0.1,0.1,0.1,0.1,0.2l0,0 c0,0,0-0.1,0-0.2V12c0,0,0,0,0-0.1l0,0l0,0c0,0,0,0,0-0.1s0-0.2,0-0.3l-0.3,0.4L12.8,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5345",
    className: "st45",
    d: "M12.8,12c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0.1,0.1c0,0.1,0,0.1,0,0.2 c0,0-0.1-0.2-0.1-0.3S12.7,12.1,12.8,12L12.8,12L12.8,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5346",
    className: "st42",
    d: "M12.8,12.7L12.8,12.7v-0.2l-0.1-0.2l-0.1-0.1L12.4,12v0.2 c0,0.1,0.1,0.2,0.2,0.2C12.7,12.6,12.7,12.6,12.8,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5347",
    className: "st45",
    d: "M12.3,12.1C12.3,12.2,12.3,12.2,12.3,12.1v0.2c0,0.1,0.1,0.1,0.1,0.2 c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0.1-0.1c0,0,0,0.1-0.1,0.1c-0.1-0.1-0.1-0.2-0.1-0.3h-0.1L12.3,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5348",
    className: "st45",
    d: "M12.6,12.4c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1v-0.1 c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1C12.7,12.3,12.7,12.3,12.6,12.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5349",
    className: "st50",
    d: "M12.4,12.2c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0-0.1-0.1-0.1-0.1L12.4,12.2 L12.4,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5350",
    className: "st45",
    d: "M12.6,12.1C12.6,12.1,12.6,12.1,12.6,12.1L12.6,12.1L12.6,12.1l0-0.1 C12.6,12,12.6,12.1,12.6,12.1C12.6,12.1,12.6,12.2,12.6,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5351",
    className: "st45",
    d: "M12.6,12.2c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.1,0,0.2c0,0,0-0.1,0-0.1 C12.7,12.4,12.6,12.3,12.6,12.2C12.6,12.2,12.6,12.2,12.6,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5352",
    className: "st42",
    d: "M12.8,12v-0.3v-0.1l-0.1-0.3c0,0,0,0.1,0,0c-0.1,0-0.1,0-0.2-0.1 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1L12.8,12L12.8,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5353",
    className: "st51",
    d: "M12.2,12.2C12.2,12.2,12.2,12.2,12.2,12.2c0.1,0,0.1-0.1,0.1-0.1 c-0.1-0.2-0.3-0.3-0.4-0.5C12,11.8,12.1,12,12.2,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5354",
    className: "st51",
    d: "M12.4,12.1c0,0,0,0.2,0,0.2S12,11.8,12,11.7s-0.2-0.1-0.2-0.2 s0.2,0.1,0.2,0.1L12.4,12.1L12.4,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5355",
    className: "st50",
    d: "M12.4,12.1L12.4,12.1C12.4,12.1,12.4,12.1,12.4,12.1c0,0.1,0,0.2,0,0.2 l0,0c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.3-0.3-0.4-0.4l0,0l0,0l-0.1-0.1c0,0-0.1-0.1-0.1-0.1l0,0h0.1H12l0,0 L12.4,12.1L12.4,12.1L12.4,12.1L12.4,12.1L12.4,12.1L12,11.6l0,0c-0.1,0-0.1-0.1-0.2-0.1l0,0l0,0l0.2,0.1l0,0 l0.2,0.3l0.1,0.2c0,0,0.1,0.1,0.1,0.1l0,0C12.4,12.2,12.4,12.2,12.4,12.1C12.4,12.1,12.4,12,12.4,12.1L12.4,12.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5356",
    className: "st45",
    d: "M12.2,12.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1s-0.2-0.3-0.3-0.4l-0.1-0.1 c0,0,0,0.1,0,0.1l0,0c0,0.1,0.1,0.2,0.2,0.3L12.2,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5357",
    className: "st42",
    d: "M12.6,12.2c0,0,0-0.1,0-0.2l-0.2-0.5h-0.1l-0.1-0.1l-0.1-0.1 c0,0,0,0.1,0,0.1v0.1l0.2,0.3L12.6,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5358",
    className: "st42",
    d: "M12.9,11.9L12.9,11.9l0.1-0.3l-0.1-0.5c0,0-0.1,0-0.1,0l-0.1-0.1v0.3 l0.1,0.4L12.9,11.9L12.9,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5359",
    className: "st45",
    d: "M12.4,12c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1h-0.1c0,0-0.1-0.1-0.1-0.1 c0,0,0,0.1,0.2,0.3S12.4,12,12.4,12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5360",
    className: "st51",
    d: "M12.8,12.1c0.1,0,0.1-0.3,0-0.4c0-0.1-0.1-0.2-0.1-0.3 c0.1,0.1,0.1,0.2,0.1,0.4s0,0.2,0,0.2s0-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1C12.6,11.6,12.8,12,12.8,12.1 c-0.1-0.2-0.2-0.4-0.3-0.6l0,0C12.4,11.5,12.6,12.1,12.8,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5361",
    className: "st42",
    d: "M12.9,10.9l0.1,0.2v0.2v0.2c0,0,0,0.4,0,0.4c0,0,0,0-0.1,0l-0.1-0.4 L12.8,11l0,0v-0.1L12.9,10.9L12.9,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5362",
    className: "st51",
    d: "M12.6,12.2v-0.1l0,0c0,0-0.1-0.1-0.1-0.1v-0.1c0,0,0,0.1-0.1,0.1 s-0.2-0.3-0.2-0.3l0,0c0,0,0.3,0.5,0.5,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5363",
    className: "st45",
    d: "M12.5,11.9c0,0,0-0.1,0-0.1c0-0.1-0.1-0.2-0.1-0.2h-0.1l-0.1-0.1 c0,0.1,0.1,0.2,0.1,0.2C12.4,11.8,12.5,11.9,12.5,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5364",
    className: "st45",
    d: "M12.6,11.8c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0.1,0,0.1 v0.1c0.1,0,0.1,0.1,0.1,0.1C12.6,11.7,12.6,11.8,12.6,11.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5365",
    className: "st45",
    d: "M12.9,11.5c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.1-0.2l0,0l0,0v0.1 c0-0.1,0-0.1,0-0.2l0,0h-0.1c0,0,0,0.1,0,0.1s0,0,0,0l0,0c0,0,0,0.1,0,0.1v0.1c0,0.1,0,0.1,0.1,0.2 C12.8,11.5,12.8,11.5,12.9,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5366",
    className: "st45",
    d: "M13,11.5c0-0.1,0-0.3,0-0.4c0-0.1-0.1-0.1-0.1-0.2l0,0 c0.1,0.1,0.1,0.2,0.1,0.3C13,11.3,13,11.5,13,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5367",
    className: "st45",
    d: "M12.8,11.6c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2l-0.1-0.1 c0,0.1,0,0.1,0,0.2v0.1l0.1,0.1C12.7,11.5,12.8,11.6,12.8,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5368",
    className: "st40",
    d: "M12.9,12c0.1,0,0-0.3,0-0.4s-0.1-0.4-0.1-0.4s0.1,0.5,0.1,0.5 s-0.1-0.1-0.1-0.1S12.9,11.9,12.9,12c-0.1-0.1-0.1-0.1-0.1-0.1L12.9,12C12.8,11.9,12.8,12,12.9,12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5369",
    className: "st40",
    d: "M13,11.8c0-0.1,0-0.3,0-0.4c0-0.1-0.1-0.4-0.1-0.4 c0.1,0.1,0.1,0.2,0.1,0.4C13.1,11.6,13.1,11.7,13,11.8C13,11.9,13,11.9,13,11.8L13,11.8C13,11.9,13,11.9,13,11.8 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5370",
    className: "st52",
    d: "M12.5,12.1c0,0,0,0.1-0.1,0.1c-0.1,0-0.1-0.1-0.2-0.1 C12.3,12.1,12.4,12.2,12.5,12.1C12.5,12.2,12.4,12.1,12.5,12.1L12.5,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5371",
    className: "st43",
    d: "M12.8,10.8c0,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1 c0,0,0.1,0,0.1,0.1s0,0.2-0.1,0.2S12.8,10.9,12.8,10.8L12.8,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5372",
    className: "st44",
    d: "M12.6,10.6c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.2,0,0.2l0,0L12.6,10.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5373",
    className: "st53",
    d: "M11.2,10.7l0.5,0.8l0.7-0.7L12,10.3L11.2,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5374",
    className: "st42",
    d: "M11.9,10.3v0.1l0.1,0.2l0.1,0.1l0.1,0.1v-0.1v-0.1l0,0h0.1l0.1-0.1 l0.1-0.1v-0.1l0,0l-0.1-0.2l-0.1,0.1l0,0h-0.1l-0.1,0.1L11.9,10.3L11.9,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5375",
    className: "st54",
    d: "M12.2,10.8C12.2,10.8,12.2,10.7,12.2,10.8c0-0.2,0-0.3,0-0.4 c0-0.1,0-0.1-0.1-0.2c0,0.1,0.1,0.2,0.1,0.3C12.2,10.7,12.2,10.8,12.2,10.8C12.2,10.8,12.2,10.8,12.2,10.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5376",
    className: "st54",
    d: "M12.2,10.5c0,0,0.1,0.1,0.1,0.1s0-0.2,0-0.3c0,0,0-0.1-0.1-0.1l0,0v0.2 c0,0.1,0.1,0.3,0,0.3S12.2,10.5,12.2,10.5L12.2,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5377",
    className: "st44",
    d: "M11.9,10.6C12,10.6,12,10.5,11.9,10.6L11.9,10.6L11.9,10.6l0.1,0.2v0.1 l0,0l0,0l-0.1,0l0,0L11.9,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5378",
    className: "st43",
    d: "M12.1,11.6c0,0-0.1,0-0.2-0.1s-0.3-0.3-0.3-0.3v-0.2h0.1l0.2-0.1v-0.1 l0.2-0.1l0.1-0.1h0.3l0.1-0.1c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3c0,0-0.1-0.1-0.1-0.1s0.1,0.3,0,0.3 s-0.2-0.1-0.2-0.1s0.1,0.2,0,0.2c-0.1,0-0.2-0.1-0.2-0.1C12.2,11.4,12.2,11.6,12.1,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5379",
    className: "st44",
    d: "M12.1,11.3L12.1,11.3c0.1,0.1,0.1,0.2,0.1,0.2c0,0-0.1-0.1-0.1-0.1 l-0.1-0.2L12.1,11.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5380",
    className: "st44",
    d: "M12.6,10.7c0,0,0.1,0.4,0,0.4s-0.2-0.1-0.2-0.1s-0.2-0.3-0.2-0.3l0,0 l0,0h0.1L12.6,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5381",
    className: "st44",
    d: "M11.9,11.4C11.9,11.4,11.9,11.4,11.9,11.4c-0.1-0.1-0.2-0.2-0.2-0.2 c0,0-0.1-0.1-0.1-0.1V11l0,0h0.1l0.3,0.2C11.9,11.4,11.9,11.4,11.9,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5382",
    className: "st44",
    d: "M12.4,11.4c-0.1-0.1-0.2-0.1-0.3-0.2C12,11.2,12,11.1,11.9,11v-0.1H12 C12.1,11.1,12.3,11.2,12.4,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5383",
    className: "st44",
    d: "M12.4,11.3c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1 C12.3,11.1,12.4,11.2,12.4,11.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5384",
    className: "st44",
    d: "M12.5,11.2c0,0-0.1-0.1-0.2-0.2s-0.1-0.1-0.1-0.1h-0.1l0,0l0,0l0.1-0.1 L12.5,11.2L12.5,11.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5385",
    className: "st41",
    d: "M12,11.6C12,11.6,12,11.6,12,11.6c-0.3-0.1-0.4-0.2-0.6-0.4L11.2,11 l0.1-0.1l0.5,0.5L12,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5386",
    className: "st44",
    d: "M12,11.6C12,11.6,12,11.6,12,11.6c-0.2-0.1-0.3-0.1-0.4-0.3 c-0.1-0.1-0.2-0.2-0.3-0.4v-0.1h0.1l0.3,0.5L12,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5387",
    className: "st42",
    d: "M12.3,11.4c-0.1,0-0.1-0.1-0.2-0.1C12,11.1,12,11,11.9,10.9H12v-0.1l0,0 h0.1l0.1,0.1V11c0,0.1,0,0.1,0.1,0.2c0,0-0.1-0.1-0.1-0.1S12.2,11.4,12.3,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5388",
    className: "st42",
    d: "M12.1,11.3C12.1,11.3,12.1,11.4,12.1,11.3 C12.1,11.4,12.1,11.4,12.1,11.3c-0.1,0-0.1,0-0.2-0.1v0.1c0,0-0.1-0.1-0.1-0.2L11.6,11v-0.1c0-0.1,0-0.1,0-0.1 s0,0,0,0.1l0,0l0.2,0.2h0.1l0.1,0.2L12.1,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5389",
    className: "st42",
    d: "M11.4,11c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.2,0.1,0.3,0.2l-0.4-0.5 L11.4,11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5390",
    className: "st42",
    d: "M12.5,11.2c-0.1,0-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.2 c0-0.1,0-0.2,0-0.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.2s-0.1-0.1-0.1,0S12.5,11.2,12.5,11.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5391",
    className: "st42",
    d: "M12.6,11c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2l-0.1-0.1v-0.2h0.1 l0.1,0.1c0,0.1,0,0.1,0,0.2C12.6,10.8,12.6,10.9,12.6,11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5392",
    className: "st42",
    d: "M11.5,11.4c-0.1-0.1-0.2-0.2-0.2-0.3V11l0,0 C11.3,11.1,11.4,11.2,11.5,11.4c0.1,0,0.2,0.1,0.3,0.1c0,0,0,0.1,0,0.1C11.7,11.6,11.6,11.5,11.5,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5393",
    className: "st45",
    d: "M11.7,11.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.2-0.2-0.2-0.3l0.1-0.1 c0,0.1,0.1,0.2,0.2,0.4L11.7,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5394",
    className: "st45",
    d: "M12,11.6c0,0-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.1-0.1-0.2h0.1 c0,0.1,0.1,0.1,0.1,0.2L12,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5395",
    className: "st45",
    d: "M11.9,11.2L11.8,11c0-0.1-0.1-0.1-0.1-0.2c0.1,0.1,0.1,0.1,0.2,0.2l0,0 c0,0,0,0.1,0,0.1C11.8,11.1,11.8,11.2,11.9,11.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5396",
    className: "st45",
    d: "M12,10.7c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1l0.1,0.1 c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1,0-0.1s0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0-0.1,0-0.1-0.1-0.2 C12.1,10.8,12,10.8,12,10.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5397",
    className: "st45",
    d: "M12.4,11l-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3v0.1c0,0.1,0,0.1-0.1,0.2 c0,0,0,0-0.1,0l0,0h0.1c0,0,0-0.1,0.1-0.1s0,0.1,0.1,0.1L12.4,11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5398",
    className: "st45",
    d: "M12.2,10.5c0,0,0.1,0.1,0.1,0.1s0-0.2,0-0.2s0.1,0,0.1,0c0,0,0,0,0-0.1 l0.2,0.3c0,0.1,0.1,0.2,0.1,0.3c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.2c0,0,0,0.1,0,0.1l0.1,0.2 c0,0.1,0.1,0.2,0.1,0.2l-0.1-0.1l-0.1-0.1l-0.1-0.1h-0.1l0,0V10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5399",
    className: "st55",
    d: "M11.9,11l0.1,0.2l0.1,0.1L12,11.2C12,11.1,11.9,11.1,11.9,11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5400",
    className: "st44",
    d: "M12.6,11C12.6,11,12.5,11,12.6,11c-0.1,0,0,0.1,0,0.1h0.1 C12.6,11.1,12.6,11.1,12.6,11C12.6,11,12.6,11,12.6,11L12.6,11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5401",
    className: "st43",
    d: "M11.3,10.3L11.3,10.3l-0.1,0.1v0.3l0.1,0.2c0,0.1,0.2,0.2,0.2,0.2 s0.1-0.1,0.1-0.2s0-0.2,0-0.2c0,0,0,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.1,0.1s0.1-0.1,0.1-0.2s-0.2-0.5-0.2-0.5h-0.1 L11.3,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5402",
    className: "st41",
    d: "M11.8,10.7c0,0,0,0.1,0.1,0.2s0,0.1,0,0.1c0.1-0.1,0.1-0.1,0.1-0.2 c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2h-0.1l-0.1,0.2L11.8,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5403",
    className: "st41",
    d: "M11.4,10.6c0,0,0,0.2,0,0.2s0,0.2,0.1,0.1c0-0.1,0.1-0.1,0.1-0.2 c0-0.1,0-0.2,0-0.3c0-0.2,0-0.2,0-0.2L11.4,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5404",
    className: "st56",
    d: "M11.2,10.2c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.2 c0,0.1,0.1,0.2,0.1,0.3l0,0L11.2,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5405",
    className: "st41",
    d: "M11.2,10.3c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.2 c0,0.1,0,0.2,0.1,0.3h0.1l0.1-0.1l-0.1-0.1c0,0,0-0.1,0-0.1v-0.1v-0.2v-0.1v-0.1L11.2,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5406",
    className: "st57",
    d: "M11.9,10.6h-0.1c0,0,0,0,0-0.1l0,0L11.9,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5407",
    className: "st43",
    d: "M11.2,10.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0.1,0.3l0,0v-0.4v-0.1 L11.2,10.3L11.2,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5408",
    className: "st44",
    d: "M11.4,10.3C11.4,10.4,11.4,10.4,11.4,10.3c0,0.1-0.1,0.2-0.1,0.2 c0,0,0,0.1,0,0.1c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0.1,0,0.1 c0,0,0-0.1,0-0.1s0,0,0,0l0.1,0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1l0,0c0-0.1,0-0.1,0-0.2c0,0,0.1,0,0.1,0 C11.5,10.5,11.5,10.4,11.4,10.3l-0.1,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5410",
    className: "st44",
    d: "M11.3,10.8C11.3,10.8,11.3,10.8,11.3,10.8c0,0.1,0,0.1,0,0.1 C11.3,10.9,11.3,10.8,11.3,10.8c0,0,0-0.1,0-0.1l0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1s0,0-0.1,0v0.1 c0,0,0-0.1,0-0.1l0.1-0.1c0,0,0,0,0-0.1l0,0c0,0,0.1,0,0.1,0.1h-0.1c0,0,0,0,0,0.2s0,0.2,0,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5411",
    className: "st44",
    d: "M11.7,10.3c0,0,0,0.1,0,0.1l-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0-0.1l0,0 c0,0,0,0.1,0,0.1v0.1v-0.1l0,0h0.1c0,0,0,0,0-0.1c0,0,0,0-0.1-0.1c0,0,0-0.1,0-0.1h0.1l0.1,0.1l0,0L11.7,10.3 C11.8,10.4,11.8,10.3,11.7,10.3c0.1,0,0.1-0.1,0-0.1l-0.2,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5412",
    className: "st53",
    d: "M12.3,10.2c0,0.1,0,0.1,0,0.2l0.1,0.2c0-0.1-0.1-0.1-0.1-0.2 C12.3,10.2,12.3,10.2,12.3,10.2C12.1,10.2,12.2,10.2,12.3,10.2c-0.1,0.1-0.1,0.2,0,0.3c0,0-0.1-0.1-0.1-0.1 L12.3,10.2c-0.1,0.1-0.1,0.1-0.1,0.2c0,0,0,0.1,0.1,0.1l-0.1-0.1l0,0c0,0,0,0.1,0,0.1l0.1,0.1l-0.1-0.1l0,0 c0,0.1,0,0.1,0,0.2l0.1,0.1c0,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.3-0.1-0.4l0.1-0.1c0-0.1,0.1-0.2,0.1-0.2 C12.2,10,12.2,10.1,12.3,10.2L12.3,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5413",
    className: "st53",
    d: "M11.9,10.1L11.9,10.1c0,0.1,0,0.1,0,0.1l-0.1,0.1 c-0.1,0-0.1,0.1-0.2,0.1s0,0,0-0.1l0.1-0.1C11.7,10.2,11.8,10.2,11.9,10.1L11.9,10.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5414",
    className: "st53",
    d: "M11.3,10.3v0.1c0,0,0.2-0.1,0.2-0.1c0,0,0,0,0-0.1l0,0 C11.5,10.2,11.4,10.3,11.3,10.3C11.3,10.3,11.3,10.3,11.3,10.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5415",
    className: "st53",
    d: "M11.3,10.1c0,0,0,0.1,0,0.1l0,0c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1 L11.3,10.1L11.3,10.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5416",
    className: "st53",
    d: "M12.3,10c0,0.1,0,0.1,0.1,0.1l0.1,0.1l-0.1-0.1h-0.1c0,0,0,0,0-0.1 L12.3,10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5417",
    className: "st57",
    d: "M11.1,10.2L11.1,10.2L11.1,10.2L11.1,10.2 C11.2,10.2,11.2,10.2,11.1,10.2c0.1,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0.1,0,0.1 c0,0.1,0.1,0.1,0.1,0l0.1-0.1l0,0l0.1-0.1V9.9l0,0h-0.1h-0.1l0,0l-0.1,0.1l0,0h-0.1l0,0l0,0l0,0l-0.1,0.1h-0.1 L11.1,10.2L11.1,10.2l0,0.1L11.1,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5418",
    className: "st44",
    d: "M11.7,9.9c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2c0.1,0,0.1-0.1,0.2-0.2 c0-0.1,0-0.2,0-0.3L11.7,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5419",
    className: "st44",
    d: "M11.9,9.8c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2l0,0c0,0,0,0.1,0.1,0.1 c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0.1-0.1s0,0,0,0s0,0.1,0,0.1s0.1,0.1,0.1,0.1c0,0,0,0,0-0.1l-0.1-0.2l-0.1-0.2 L12,9.6h0L11.9,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5420",
    className: "st41",
    d: "M12.1,9.6c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0-0.1,0-0.1,0-0.2V9.6 L12.1,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5421",
    className: "st42",
    d: "M12.3,10c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1-0.1c0-0.1,0-0.1-0.1-0.2 c0,0,0-0.1,0-0.1h0.1L12.3,10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5422",
    className: "st42",
    d: "M12,10.2c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0-0.2-0.1-0.3 c0,0.1,0,0.2-0.1,0.3L12,10.2L12,10.2L12,10.2C12,10.2,12,10.2,12,10.2L12,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5423",
    className: "st42",
    d: "M11.9,9.8c0,0,0,0.1-0.1,0.1L11.6,10c0,0,0.1-0.1,0.1-0.1 c0,0,0-0.1,0-0.1c0,0,0,0,0,0.1c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1l0,0l0.1-0.1L11.9,9.8L11.9,9.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5424",
    className: "st53",
    d: "M12.3,9.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.2c0,0-0.1-0.1-0.1-0.1 c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0h0c0,0,0,0,0.1-0.1V9.5L12.3,9.5L12.3,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5425",
    className: "st53",
    d: "M12,10c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2H12l0-0.1 c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0,0.1,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0.1C12,9.9,12,9.9,12,10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5426",
    className: "st44",
    d: "M11.1,10.2c0,0,0.1-0.1,0.1-0.2l0.1-0.2l0,0c0,0,0.1,0,0.1-0.1V9.7 c0,0,0,0.1,0,0.1c0,0.1,0,0,0.1,0c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.2c0-0.1,0-0.1,0-0.2c0,0,0,0-0.1,0.1 l-0.1,0.1l0.1-0.1c0-0.1,0-0.1,0-0.1l0,0l0,0l0,0c0,0,0-0.1,0.1-0.1c0,0,0,0,0-0.1s0,0,0,0l-0.1,0.1l-0.1,0.1 c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1l0,0V10c0-0.1,0-0.1,0.1-0.2l0,0l0,0L11.2,10C11.2,10.1,11.2,10.2,11.1,10.2 L11.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5427",
    className: "st58",
    d: "M12.3,9.5C12.3,9.5,12.3,9.5,12.3,9.5c-0.1,0.1-0.1,0.1-0.2,0.1 c0,0,0,0,0-0.1H12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5428",
    className: "st59",
    d: "M11.3,9.6c0,0,0,0.1,0,0.1l-0.1,0.1c0,0,0.1,0,0.1,0L11.3,9.6L11.3,9.6 L11.3,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5429",
    className: "st57",
    d: "M12,9.5c0,0,0,0.3-0.1,0.3s-0.1-0.2-0.1-0.2s0,0.2-0.1,0.2 s-0.1-0.2-0.1-0.2c0,0.1,0,0.1-0.1,0.2c-0.1,0.1-0.2,0-0.2,0c0-0.1,0.1-0.1,0.1-0.2l0,0c0,0,0-0.1,0.1-0.1h0.1 l0.1-0.1c0,0,0,0,0.1,0c0,0,0.1-0.1,0.1-0.1L12,9.5L12,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5430",
    className: "st59",
    d: "M11.6,9.2c0,0.1,0.1,0.1,0.1,0.2l0,0c0,0,0,0,0,0.1c0,0.1-0.1,0.1,0,0.2 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1s0,0.3,0,0.3s0.1-0.1,0.1-0.2s0,0,0,0s0.1,0.1,0.1,0.1S12,9.5,12,9.5 c0-0.1,0-0.1-0.1-0.2L11.6,9.2C11.6,9.2,11.6,9.2,11.6,9.2c0,0.1-0.1,0-0.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5431",
    className: "st44",
    d: "M12.1,9.2C12.1,9.2,12.1,9.2,12.1,9.2c0,0.2,0,0.4,0,0.4 c0,0,0,0-0.1-0.1c0,0,0-0.1,0-0.2c0,0-0.1-0.1-0.1-0.1V9.1L12.1,9.2L12.1,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5432",
    className: "st42",
    d: "M12,9.1l0.1,0.2l0.1,0.2h0.1c0,0-0.1,0-0.1,0c-0.1,0,0-0.1-0.1-0.2 C12,9.2,12,9.1,12,9.1L12,9.1L12,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5433",
    className: "st53",
    d: "M12,9c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0.1,0.1,0.1,0.2l0.1,0.1 M12.3,9.5 C12.3,9.5,12.3,9.4,12.3,9.5c-0.1-0.1-0.1-0.2-0.2-0.3c0,0-0.1-0.1-0.1-0.1l0.1,0.1c0,0,0.1,0.1,0.1,0.1 c0,0,0-0.1-0.1-0.1c0-0.1-0.1-0.2-0.1-0.1c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2L12,9.3c0,0,0-0.1-0.1-0.1 l-0.1-0.1c0,0,0.1,0,0.1,0L12,9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5434",
    className: "st44",
    d: "M11.7,9.2c0,0,0.1,0,0.1,0h0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1 c0,0,0-0.1,0-0.1L11.7,9.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5435",
    className: "st59",
    d: "M11.7,9.4c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2-0.1,0.2c0-0.1,0-0.1,0-0.2l0,0 v0.1V9.6l0,0L11.7,9.4L11.7,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5436",
    className: "st44",
    d: "M11.6,9.5C11.6,9.5,11.5,9.5,11.6,9.5C11.4,9.5,11.5,9.5,11.6,9.5 L11.6,9.5L11.6,9.5c-0.1,0.1-0.2,0.2-0.2,0.2C11.4,9.7,11.4,9.6,11.6,9.5C11.5,9.5,11.5,9.5,11.6,9.5 C11.5,9.5,11.5,9.5,11.6,9.5C11.6,9.5,11.5,9.5,11.6,9.5c0,0,0,0.1,0,0.1C11.5,9.6,11.5,9.5,11.6,9.5 c0-0.1,0-0.1,0-0.2l0,0h-0.1C11.5,9.4,11.5,9.4,11.6,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5437",
    className: "st57",
    d: "M12,8.9C12,9,12,9,12,9c0,0,0,0-0.1,0h-0.1L11.6,9h-0.1h-0.1V8.9h0.1 l0.1,0.1h0.1h0.1l0,0l0,0l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5438",
    className: "st41",
    d: "M12,8.9C12,8.9,12,9,12,8.9C12,9,11.9,9,11.9,9l-0.2-0.1h-0.2 c-0.1,0,0,0,0,0c0.1,0,0.1,0,0.2,0C11.8,9,11.9,9,12,8.9C12,9,12,9,12,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5440",
    className: "st57",
    d: "M11.8,9.1c0,0,0.1,0.1,0,0.1l-0.1-0.1l-0.2-0.1h-0.1V9l0,0l0,0h0.1h0.1 L11.8,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5441",
    className: "st57",
    d: "M11.7,9.2c0,0,0.1,0.2,0.1,0.2l-0.3-0.2l-0.1,0.2l-0.2-0.1l0.2-0.2l0,0 h0.1L11.7,9.2L11.7,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5442",
    className: "st41",
    d: "M11.6,9l0.2,0.1h0.1c0,0-0.1,0-0.1,0L11.7,9H11.6L11.6,9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5443",
    className: "st42",
    d: "M11.4,8.9h0.1c0.1,0,0.1,0,0.1,0l0,0l0,0H11.4 C11.5,8.9,11.4,8.9,11.4,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5444",
    className: "st41",
    d: "M11.8,9.2L11.8,9.2L11.8,9.2c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.1 L11.4,9h-0.1h0.1h0.2h0.1h0.1L11.8,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5445",
    className: "st41",
    d: "M11.5,9.3v0.1v0.1l0,0l0,0l0,0c0,0,0,0,0-0.1l-0.1-0.1 C11.4,9.4,11.4,9.3,11.5,9.3C11.6,9.3,11.5,9.2,11.5,9.3L11.5,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5446",
    className: "st42",
    d: "M11.4,9C11.4,9,11.4,9,11.4,9h0.2l0,0h0.1c0,0,0.1,0,0.1,0.1h-0.1 L11.5,9C11.4,9,11.3,9,11.4,9L11.4,9L11.4,9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5447",
    className: "st41",
    d: "M11.8,9.4L11.8,9.4c-0.1,0-0.1,0-0.2,0c0,0,0,0,0-0.1l-0.1-0.1l0,0 l0.2,0.1L11.8,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5448",
    className: "st42",
    d: "M11.8,9.4c-0.1-0.1-0.2-0.1-0.2-0.2h-0.1h-0.1l0,0l0,0c0,0,0.1,0,0.1,0 c0.1,0,0.1,0,0.1,0s-0.1,0.1-0.1,0.1s0-0.1,0.1-0.1c0,0,0,0,0.1,0l0,0c0,0-0.1-0.1-0.1-0.1c0.1,0,0.1,0,0.2,0.1 C11.7,9.3,11.8,9.3,11.8,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5449",
    className: "st57",
    d: "M11.4,9.2c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.1-0.1,0.1s0,0,0.1,0 s0.1-0.1,0-0.1C11.5,9.3,11.5,9.3,11.4,9.2L11.4,9.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5450",
    className: "st60",
    d: "M10.9,8.9c0,0,0,0,0,0.1c0,0.1-0.1,0.1-0.1,0.2 c-0.1,0.1-0.2,0.1-0.1,0.2s0,0,0.1,0s0.2-0.3,0.2-0.3L10.9,8.9L10.9,8.9L10.9,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5451",
    className: "st57",
    d: "M11.4,8.7c0,0.1,0,0.2,0,0.2c0,0.2-0.2,0.3-0.2,0.3l-0.3,0.2h-0.2 c0,0,0,0-0.1,0c0,0,0,0,0-0.1V9.3l0.1-0.1l0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1l0,0V9v0.1h0.1L11.1,9 c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2V8.7l0,0c0,0,0,0.1,0,0.1v0.1V8.8l0.1-0.1c0,0,0-0.1,0-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5452",
    className: "st40",
    d: "M11.4,9.5C11.4,9.5,11.4,9.5,11.4,9.5c0,0.1,0,0.2-0.1,0.2L11.4,9.5 l-0.2,0h-0.1l0,0h0.1L11.4,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5453",
    className: "st41",
    d: "M11.3,9.5C11.3,9.5,11.3,9.5,11.3,9.5C11.4,9.5,11.4,9.4,11.3,9.5 L11.3,9.5C11.4,9.4,11.4,9.4,11.3,9.5C11.4,9.5,11.3,9.4,11.3,9.5c-0.1-0.1-0.1-0.1-0.1-0.1l0,0L11.3,9.5 L11.3,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5454",
    className: "st40",
    d: "M10.9,9.3H11h0.2l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1,0-0.2,0-0.2 c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0.2-0.1,0.2,0c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0.1 s-0.1,0-0.2,0c0,0-0.1,0-0.1,0.1c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2-0.1l0.1-0.1 C10.8,9.3,10.9,9.3,10.9,9.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5455",
    className: "st41",
    d: "M11.2,8.9c0,0,0.1-0.1,0.1-0.1V8.7C11.3,8.7,11.3,8.7,11.2,8.9L11.2,8.9 L11.2,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5456",
    className: "st40",
    d: "M11.2,8.7c0,0,0,0.2,0,0.3c-0.1,0.1-0.2,0.2-0.3,0.2 C11,9.2,11.1,9.1,11.1,9C11.2,8.9,11.2,8.9,11.2,8.7L11.2,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5457",
    className: "st53",
    d: "M11,9.3c0,0,0.1,0,0.1,0l0.1-0.1c0,0-0.1,0-0.1,0s0,0,0,0L11,9.3L11,9.3 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5458",
    className: "st53",
    d: "M11.1,9c0-0.1,0.1-0.1,0.1-0.2c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0.1,0,0.1 C11.2,8.9,11.2,8.9,11.1,9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5459",
    className: "st53",
    d: "M11.2,9c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0.1,0,0.1 C11.3,9,11.3,9,11.2,9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5460",
    className: "st53",
    d: "M11.2,9.5C11.2,9.5,11.2,9.4,11.2,9.5c0.1,0,0.1,0,0.2,0H11.2L11.2,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5461",
    className: "st53",
    d: "M11,9.3h0.2l0.1-0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0.1 c0.1,0,0.1-0.1,0.2-0.1L11,9.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5462",
    className: "st2",
    d: "M10.9,9.2c0,0.1,0,0.1,0,0.2l0,0c0,0-0.1,0-0.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5463",
    className: "st61",
    d: "M10.9,9.2c0,0,0,0.1,0,0.1l0,0c0,0-0.1,0-0.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5464",
    className: "st62",
    d: "M10.8,9.2C10.8,9.2,10.8,9.2,10.8,9.2L10.8,9.2 M10.7,9.3L10.7,9.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5466",
    className: "st41",
    d: "M10.9,9.1C10.9,9,11,9,11,8.9c0-0.1,0-0.1,0-0.2v0.1v0.1V9h0.1 c0-0.1,0.1-0.2,0.1-0.3c0,0.1,0,0.1,0,0.2C11.1,9,11.1,9.1,10.9,9.1c0,0-0.1,0.1-0.1,0.2l-0.1,0.1l0.1-0.1 C10.8,9.3,10.8,9.2,10.9,9.1L10.9,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5467",
    className: "st40",
    d: "M10.9,9.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0.1 C10.9,9.1,10.9,9.1,10.9,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5468",
    className: "st42",
    d: "M11,9c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0.1S11,9,11,9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5469",
    className: "st41",
    d: "M10.6,9.4C10.6,9.4,10.6,9.4,10.6,9.4c0-0.1,0-0.1,0.1-0.2 c0,0,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0-0.2c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0.2C10.6,9.3,10.6,9.3,10.6,9.4 C10.6,9.4,10.6,9.4,10.6,9.4L10.6,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5470",
    className: "st64",
    d: "M11.3,9.6L11.3,9.6C11.3,9.6,11.3,9.6,11.3,9.6c0-0.1,0-0.1-0.1-0.1 h-0.1c0,0,0,0,0.1,0.1S11.3,9.6,11.3,9.6C11.3,9.6,11.3,9.6,11.3,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5471",
    className: "st64",
    d: "M11.3,9.6c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0-0.1l0,0l0,0 C11.4,9.5,11.4,9.6,11.3,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5472",
    className: "st65",
    d: "M10.8,9.6L10.8,9.6L10.8,9.6L11,9.6L11,9.5V9.4h-0.1L10.8,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5473",
    className: "st66",
    d: "M11.2,9.6L11.2,9.6L11.2,9.6l-0.1-0.1H11c0,0,0,0-0.1,0h-0.1h-0.1h-0.1 l-0.1,0.1l0,0l0,0c-0.1,0-0.1,0.1-0.2,0.2c0,0.1,0.2,0.3,0.3,0.2s-0.1-0.1-0.1-0.2c0-0.1,0.1-0.2,0.2-0.1 c0.1,0,0.1,0,0.2-0.1C11,9.6,11.1,9.6,11.2,9.6c0,0.1-0.3,0.2-0.3,0.2l0,0C10.9,9.8,11.3,9.7,11.2,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5474",
    className: "st44",
    d: "M11.2,9.6L11.2,9.6L11.2,9.6L11.2,9.6L11.2,9.6L11,9.5l0,0l0,0h-0.1 h-0.1l0,0h-0.1h-0.1v0.1l0,0l0,0l0,0h-0.1c0,0-0.1,0.1-0.1,0.2l0,0c0,0.1,0,0.1,0.1,0.2c0,0,0.1,0.1,0.2,0.1 c0,0,0,0,0.1,0l0,0h-0.1c0,0,0-0.1,0-0.1l0,0c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0h0.1 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l0,0l0,0c0,0,0,0-0.1,0h-0.1h-0.1v0.1l0,0l0.2-0.1l0.1-0.1h0.1l0,0l0,0l0,0 h-0.1L11,9.7h-0.1l0,0V9.6l0,0h0.1L11.2,9.6L11.2,9.6L11.2,9.6L11.2,9.6c-0.1,0-0.2-0.1-0.2-0.1c0,0-0.1,0-0.1,0 h-0.1h-0.1c0,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1l0,0c0,0,0,0.1,0.1,0.1h0.1l0,0h-0.1c-0.1,0-0.1,0-0.2-0.1 c0,0-0.1-0.1-0.1-0.1l0,0c0-0.1,0-0.1,0.1-0.1h0.1l0,0l0,0l0,0h0.1h0.1l0,0h0.1h0.3l0,0l0,0v0.1l0,0L11.2,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5475",
    className: "st67",
    d: "M10.5,9.9c0,0-0.2,0-0.1-0.2c0-0.1,0.1-0.2,0.2-0.2c0,0,0-0.1,0-0.1 c0,0,0.1,0,0.1,0h0.1c0,0-0.3,0.1-0.3,0.3S10.4,9.8,10.5,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5476",
    className: "st68",
    d: "M11.2,9.6L11.2,9.6c0,0-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.2,0h-0.1 c0,0-0.2-0.1-0.2-0.1c0,0,0,0,0,0.1h-0.1c0,0,0.1-0.1,0.1-0.1s0.2,0.1,0.3,0.1s0.1,0,0.2,0S11.2,9.5,11.2,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5477",
    className: "st69",
    d: "M10.8,9.7h0.1H11c0,0-0.1,0-0.1,0.1L10.8,9.7L10.8,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5478",
    className: "st66",
    d: "M10.6,10c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.1 c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.1-0.1l0,0l-0.1,0.1v0.1v0.1v0.1v0.1L10.6,10L10.6,10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5480",
    className: "st66",
    d: "M10.8,9.6l-0.2,0.1L10.8,9.6c0.1,0.1,0.3,0,0.3,0.1s-0.2,0.1-0.2,0.1 l0,0H11h0.1l0,0L11,9.7L10.8,9.6L10.8,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5481",
    className: "st44",
    d: "M10.5,9.8c0,0,0,0.1,0.1,0.1l0,0c0,0-0.1,0-0.1,0 c-0.1,0-0.2-0.1-0.2-0.2l0,0v0.1l0.1,0.1L10.5,9.8L10.5,9.8L10.5,9.8L10.5,9.8L10.5,9.8l-0.1-0.1l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5483",
    className: "st15",
    d: "M10.9,9.8L10.9,9.8L10.9,9.8L10.9,9.8L10.9,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5484",
    className: "st14",
    d: "M11.1,11.6L11.1,11.6c-0.1,0-0.2,0-0.2,0l0,0H11.1L11.1,11.6L11.1,11.6 L11.1,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5485",
    className: "st14",
    d: "M11.1,11.4H11h-0.1l0,0l0,0c0,0,0,0,0.1,0H11.1L11.1,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5486",
    className: "st14",
    d: "M11.1,11.3L11,11.4l-0.1,0.1l0,0l0,0H11h0.1l0,0L11.1,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5487",
    className: "st14",
    d: "M11,11.2L11,11.2C11,11.2,11,11.2,11,11.2L11,11.2l-0.1,0.2h-0.1l0,0 L11,11.2v0.1l0,0C11,11.3,11,11.3,11,11.2L11,11.2L11,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5488",
    className: "st14",
    d: "M10.9,11.1L10.9,11.1L10.9,11.1C10.9,11.1,10.9,11.1,10.9,11.1 c0,0.1,0,0.1-0.1,0.2v0.1l0,0C10.9,11.3,10.9,11.2,10.9,11.1C11,11.2,11,11.1,10.9,11.1L10.9,11.1L10.9,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5489",
    className: "st14",
    d: "M10.8,11.1L10.8,11.1c0,0.1,0,0.1,0,0.1v0.1v0.1l0,0c0,0,0-0.1,0.1-0.1 C10.9,11.2,10.9,11.2,10.8,11.1L10.8,11.1L10.8,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5490",
    className: "st14",
    d: "M10.8,11.1L10.8,11.1c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1l0,0l0,0 c0,0,0,0,0-0.1C10.8,11.3,10.8,11.2,10.8,11.1L10.8,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5491",
    className: "st14",
    d: "M10.6,11.1L10.6,11.1L10.6,11.1c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1l0,0 l0,0c0,0,0-0.1,0-0.1C10.7,11.3,10.7,11.2,10.6,11.1L10.6,11.1L10.6,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5492",
    className: "st14",
    d: "M10.6,11.1L10.6,11.1c0,0,0,0.1,0,0.1v0.1v0.1l0,0v-0.1 C10.6,11.2,10.6,11.2,10.6,11.1L10.6,11.1L10.6,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5493",
    className: "st14",
    d: "M10.5,11.1L10.5,11.1L10.5,11.1c0,0,0,0.1,0,0.1l-0.1,0.1l0,0l0,0 L10.5,11.1C10.6,11.2,10.6,11.1,10.5,11.1L10.5,11.1L10.5,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5494",
    className: "st14",
    d: "M10.5,11.1L10.5,11.1c0,0.1-0.1,0.1-0.1,0.1l0,0l0,0L10.5,11.1 C10.5,11.2,10.5,11.1,10.5,11.1L10.5,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5496",
    className: "st14",
    d: "M10.4,11L10.4,11L10.4,11L10.4,11L10.4,11L10.4,11L10.4,11L10.4,11 L10.4,11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5500",
    className: "st14",
    d: "M10.3,10.8L10.3,10.8C10.3,10.8,10.3,10.8,10.3,10.8L10.3,10.8 L10.3,10.8L10.3,10.8L10.3,10.8L10.3,10.8L10.3,10.8L10.3,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5503",
    className: "st14",
    d: "M10.9,10.1L10.9,10.1L10.9,10.1L11,10l0,0l0,0l0,0L10.9,10.1L10.9,10.1z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5504",
    className: "st14",
    d: "M10.8,10L10.8,10L11,9.9l0,0l-0.1,0.1L10.8,10L10.8,10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5505",
    className: "st14",
    d: "M10.8,9.9l0.2-0.1l0,0L10.8,9.9L10.8,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5506",
    className: "st14",
    d: "M10.7,9.8L10.7,9.8l0.2-0.1l0,0h-0.1L10.7,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5507",
    className: "st14",
    d: "M10.6,9.8L10.6,9.8l0.1-0.1l0,0l0,0l0,0L10.6,9.8L10.6,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5508",
    className: "st8",
    d: "M10.8,9.6L10.8,9.6c0,0,0.1,0.1,0.1,0.1C11,9.8,11,9.9,11,10l0,0 c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.2,0.2-0.4,0.3c-0.1,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.2l0,0 c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.1,0.2,0.1l0,0h0.3c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3 c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1l0,0l0,0c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.1 c-0.1,0-0.2,0-0.3,0l0,0c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.2l0,0c0-0.1,0-0.2,0.1-0.2 c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.2-0.2,0.3-0.3l0,0c0-0.1,0-0.2-0.1-0.2L10.8,9.6L10.8,9.6z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3569"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M14.1,12.9C14,12.9,14,13,14,13.1s0.1,0,0.2-0.1s0.1-0.2,0.1-0.2s0,0-0.1,0 C14.2,12.8,14.2,12.8,14.1,12.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2259"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Trazado_5532_1_",
    cx: 192.0642,
    cy: 885.4626,
    r: 0.28,
    gradientTransform: "matrix(0.5 0.58 1.15 -0.98 -1098.9906 768.2781)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D3395F"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5532",
    className: "st72",
    d: "M13.8,12.9l0.4,0.4l0.4-0.4l-0.4-0.4L13.8,12.9z"
  }))))))))))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1987",
    x: 7.1,
    y: 1.2,
    className: "st2",
    width: 10,
    height: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1988",
    x: 7.1,
    y: 18.2,
    className: "st2",
    width: 10,
    height: 5
  })))))))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6874",
    className: "st73",
    d: "M22.6,11.8c0.1,5.9-4.5,10.7-10.4,10.8S1.5,18.1,1.4,12.2C1.3,6.4,5.9,1.5,11.8,1.4H12 C17.8,1.3,22.5,6,22.6,11.8z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlagMx, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FlagMx.ce6187f5.svg";
export { ForwardRef as ReactComponent };